import produce from 'immer'
import { useEffect, useId, useState } from 'react'
import { Socket, io } from 'socket.io-client'
import { createStore } from 'zustand'
import { devtools } from 'zustand/middleware'
import {
  ClientToServerEventsSynchron,
  DataForPrismaModelsForFrontend,
  DataForPrismaModelsForFrontendPartial,
  ForGetDataBySelectID,
  PrismaSelect,
  ServerToClientEventsSynchron,
} from './synchronBackendAtSite'

type SynchroneState = {
  data: DataForPrismaModelsForFrontend | undefined
}

const clientStore = createStore<SynchroneState>()(
  devtools<SynchroneState>(set => ({
    data: undefined,
    clearClients: () =>
      set(
        produce<SynchroneState>(state => {
          // state.clients = []
        })
      ),
  }))
)

let dataStore: {
  Site1: Map<string, ForGetDataBySelectID['Site1']>

  UserSelect1: Map<string, ForGetDataBySelectID['UserSelect1']>

  TelegramChannel1: Map<string, ForGetDataBySelectID['TelegramChannel1']>

  TelegramGift1: Map<string, ForGetDataBySelectID['TelegramGift1']>

  Image1: Map<string, ForGetDataBySelectID['Image1']>

  PageOnlyWithFields: Map<string, ForGetDataBySelectID['PageOnlyWithFields']>
  Page1: Map<string, ForGetDataBySelectID['Page1']>
  PageForLink: Map<string, ForGetDataBySelectID['PageForLink']>

  Target1: Map<string, ForGetDataBySelectID['Target1']>

  TelegramPersonalBot1: Map<string, ForGetDataBySelectID['TelegramPersonalBot1']>

  PaidPlace1: Map<string, ForGetDataBySelectID['PaidPlace1']>

  PaidPlaceOutcomeBalance1: Map<string, ForGetDataBySelectID['PaidPlaceOutcomeBalance1']>

  TelegramUser1: Map<string, ForGetDataBySelectID['TelegramUser1']>

  Domain1: Map<string, ForGetDataBySelectID['Domain1']>

  SectionsPinned1: Map<string, ForGetDataBySelectID['SectionsPinned1']>
  SectionsPinnedID: Map<string, ForGetDataBySelectID['SectionsPinnedID']>

  Sections1: Map<string, ForGetDataBySelectID['Sections1']>

  Section1: Map<string, ForGetDataBySelectID['Section1']>
  SectionID: Map<string, ForGetDataBySelectID['SectionID']>

  PopupWithName: Map<string, ForGetDataBySelectID['PopupWithName']>
  PopupID: Map<string, ForGetDataBySelectID['PopupID']>
  Popup1: Map<string, ForGetDataBySelectID['Popup1']>

  BoxBlock1: Map<string, ForGetDataBySelectID['BoxBlock1']>

  Box1: Map<string, ForGetDataBySelectID['Box1']>

  ResponsiveBoxSetting1: Map<string, ForGetDataBySelectID['ResponsiveBoxSetting1']>

  BoxSetting1: Map<string, ForGetDataBySelectID['BoxSetting1']>

  BoxBackground1: Map<string, ForGetDataBySelectID['BoxBackground1']>

  Color1: Map<string, ForGetDataBySelectID['Color1']>

  BoxBorder1: Map<string, ForGetDataBySelectID['BoxBorder1']>

  BoxShadow1: Map<string, ForGetDataBySelectID['BoxShadow1']>

  Link1: Map<string, ForGetDataBySelectID['Link1']>

  TextComponent1: Map<string, ForGetDataBySelectID['TextComponent1']>

  TextSettings1: Map<string, ForGetDataBySelectID['TextSettings1']>

  FontWeight1: Map<string, ForGetDataBySelectID['FontWeight1']>

  ImageComponent1: Map<string, ForGetDataBySelectID['ImageComponent1']>

  FormComponent1: Map<string, ForGetDataBySelectID['FormComponent1']>

  Form1: Map<string, ForGetDataBySelectID['Form1']>

  ExtraInput1: Map<string, ForGetDataBySelectID['ExtraInput1']>

  QuizComponent1: Map<string, ForGetDataBySelectID['QuizComponent1']>

  Quiz1: Map<string, ForGetDataBySelectID['Quiz1']>

  QuizStep1: Map<string, ForGetDataBySelectID['QuizStep1']>

  QuizCheckboxStep1: Map<string, ForGetDataBySelectID['QuizCheckboxStep1']>

  QuizCheckboxStepItem1: Map<string, ForGetDataBySelectID['QuizCheckboxStepItem1']>

  QuizRadioStep1: Map<string, ForGetDataBySelectID['QuizRadioStep1']>

  QuizRadioStepItem1: Map<string, ForGetDataBySelectID['QuizRadioStepItem1']>

  QuizFieldInputStep1: Map<string, ForGetDataBySelectID['QuizFieldInputStep1']>

  VideoComponent1: Map<string, ForGetDataBySelectID['VideoComponent1']>

  FaqComponent1: Map<string, ForGetDataBySelectID['FaqComponent1']>

  FaqComponentItem1: Map<string, ForGetDataBySelectID['FaqComponentItem1']>

  MapComponent1: Map<string, ForGetDataBySelectID['MapComponent1']>

  MapComponentPoint1: Map<string, ForGetDataBySelectID['MapComponentPoint1']>

  CodeComponent1: Map<string, ForGetDataBySelectID['CodeComponent1']>

  WhatsAppBotComponent1: Map<string, ForGetDataBySelectID['WhatsAppBotComponent1']>

  WhatsAppBotLink1: Map<string, ForGetDataBySelectID['WhatsAppBotLink1']>

  TableColumnSimple: Map<string, ForGetDataBySelectID['TableColumnSimple']>
  TableColumnAtBoxAtSchema: Map<string, ForGetDataBySelectID['TableColumnAtBoxAtSchema']>
  TableColumnAtBox: Map<string, ForGetDataBySelectID['TableColumnAtBox']>
  TableColumn1: Map<string, ForGetDataBySelectID['TableColumn1']>

  TableAtBox: Map<string, ForGetDataBySelectID['TableAtBox']>
  TableWithID: Map<string, ForGetDataBySelectID['TableWithID']>
  Table1: Map<string, ForGetDataBySelectID['Table1']>

  TableConnectorAtBox: Map<string, ForGetDataBySelectID['TableConnectorAtBox']>
  TableConnectorWithID: Map<string, ForGetDataBySelectID['TableConnectorWithID']>
  TableConnector1: Map<string, ForGetDataBySelectID['TableConnector1']>

  TableDataAtBox: Map<string, ForGetDataBySelectID['TableDataAtBox']>
  TableDataPinnedToPage: Map<string, ForGetDataBySelectID['TableDataPinnedToPage']>
  TableData1: Map<string, ForGetDataBySelectID['TableData1']>

  TableRowAtBox: Map<string, ForGetDataBySelectID['TableRowAtBox']>
  TableDataRowPinnedToPage: Map<string, ForGetDataBySelectID['TableDataRowPinnedToPage']>
  TableDataRow1: Map<string, ForGetDataBySelectID['TableDataRow1']>

  TableRowItemAtBox: Map<string, ForGetDataBySelectID['TableRowItemAtBox']>
  TableDataRowItem1: Map<string, ForGetDataBySelectID['TableDataRowItem1']>

  BlockCategory1: Map<string, ForGetDataBySelectID['BlockCategory1']>

  Lead1: Map<string, ForGetDataBySelectID['Lead1']>

  GroupFont1: Map<string, ForGetDataBySelectID['GroupFont1']>

  WhatsAppBot1: Map<string, ForGetDataBySelectID['WhatsAppBot1']>
} = {
  Site1: new Map(),

  UserSelect1: new Map(),

  TelegramChannel1: new Map(),

  TelegramGift1: new Map(),

  Image1: new Map(),

  PageOnlyWithFields: new Map(),
  Page1: new Map(),
  PageForLink: new Map(),

  Target1: new Map(),

  TelegramPersonalBot1: new Map(),

  PaidPlace1: new Map(),

  PaidPlaceOutcomeBalance1: new Map(),

  TelegramUser1: new Map(),

  Domain1: new Map(),

  SectionsPinned1: new Map(),
  SectionsPinnedID: new Map(),

  Sections1: new Map(),

  Section1: new Map(),
  SectionID: new Map(),

  PopupWithName: new Map(),
  PopupID: new Map(),
  Popup1: new Map(),

  BoxBlock1: new Map(),

  Box1: new Map(),

  ResponsiveBoxSetting1: new Map(),

  BoxSetting1: new Map(),

  BoxBackground1: new Map(),

  Color1: new Map(),

  BoxBorder1: new Map(),

  BoxShadow1: new Map(),

  Link1: new Map(),

  TextComponent1: new Map(),

  TextSettings1: new Map(),

  FontWeight1: new Map(),

  ImageComponent1: new Map(),

  FormComponent1: new Map(),

  Form1: new Map(),

  ExtraInput1: new Map(),

  QuizComponent1: new Map(),

  Quiz1: new Map(),

  QuizStep1: new Map(),

  QuizCheckboxStep1: new Map(),

  QuizCheckboxStepItem1: new Map(),

  QuizRadioStep1: new Map(),

  QuizRadioStepItem1: new Map(),

  QuizFieldInputStep1: new Map(),

  VideoComponent1: new Map(),

  FaqComponent1: new Map(),

  FaqComponentItem1: new Map(),

  MapComponent1: new Map(),

  MapComponentPoint1: new Map(),

  CodeComponent1: new Map(),

  WhatsAppBotComponent1: new Map(),

  WhatsAppBotLink1: new Map(),

  TableColumnSimple: new Map(),
  TableColumnAtBoxAtSchema: new Map(),
  TableColumnAtBox: new Map(),
  TableColumn1: new Map(),

  TableAtBox: new Map(),
  TableWithID: new Map(),
  Table1: new Map(),

  TableConnectorAtBox: new Map(),
  TableConnectorWithID: new Map(),
  TableConnector1: new Map(),

  TableDataAtBox: new Map(),
  TableDataPinnedToPage: new Map(),
  TableData1: new Map(),

  TableRowAtBox: new Map(),
  TableDataRowPinnedToPage: new Map(),
  TableDataRow1: new Map(),

  TableRowItemAtBox: new Map(),
  TableDataRowItem1: new Map(),

  BlockCategory1: new Map(),

  Lead1: new Map(),

  GroupFont1: new Map(),

  WhatsAppBot1: new Map(),
}

const callbacks: {
  Site1: Map<
    string,
    {
      entityID: string
      callback: () => void
    }
  >

  UserSelect1: Map<
    string,
    {
      entityID: string
      callback: () => void
    }
  >

  TelegramChannel1: Map<
    string,
    {
      entityID: string
      callback: () => void
    }
  >

  TelegramGift1: Map<
    string,
    {
      entityID: string
      callback: () => void
    }
  >

  Image1: Map<
    string,
    {
      entityID: string
      callback: () => void
    }
  >

  PageOnlyWithFields: Map<
    string,
    {
      entityID: string
      callback: () => void
    }
  >
  Page1: Map<
    string,
    {
      entityID: string
      callback: () => void
    }
  >
  PageForLink: Map<
    string,
    {
      entityID: string
      callback: () => void
    }
  >

  Target1: Map<
    string,
    {
      entityID: string
      callback: () => void
    }
  >

  TelegramPersonalBot1: Map<
    string,
    {
      entityID: string
      callback: () => void
    }
  >

  PaidPlace1: Map<
    string,
    {
      entityID: string
      callback: () => void
    }
  >

  PaidPlaceOutcomeBalance1: Map<
    string,
    {
      entityID: string
      callback: () => void
    }
  >

  TelegramUser1: Map<
    string,
    {
      entityID: string
      callback: () => void
    }
  >

  Domain1: Map<
    string,
    {
      entityID: string
      callback: () => void
    }
  >

  SectionsPinned1: Map<
    string,
    {
      entityID: string
      callback: () => void
    }
  >
  SectionsPinnedID: Map<
    string,
    {
      entityID: string
      callback: () => void
    }
  >

  Sections1: Map<
    string,
    {
      entityID: string
      callback: () => void
    }
  >

  Section1: Map<
    string,
    {
      entityID: string
      callback: () => void
    }
  >
  SectionID: Map<
    string,
    {
      entityID: string
      callback: () => void
    }
  >

  PopupWithName: Map<
    string,
    {
      entityID: string
      callback: () => void
    }
  >
  PopupID: Map<
    string,
    {
      entityID: string
      callback: () => void
    }
  >
  Popup1: Map<
    string,
    {
      entityID: string
      callback: () => void
    }
  >

  BoxBlock1: Map<
    string,
    {
      entityID: string
      callback: () => void
    }
  >

  Box1: Map<
    string,
    {
      entityID: string
      callback: () => void
    }
  >

  ResponsiveBoxSetting1: Map<
    string,
    {
      entityID: string
      callback: () => void
    }
  >

  BoxSetting1: Map<
    string,
    {
      entityID: string
      callback: () => void
    }
  >

  BoxBackground1: Map<
    string,
    {
      entityID: string
      callback: () => void
    }
  >

  Color1: Map<
    string,
    {
      entityID: string
      callback: () => void
    }
  >

  BoxBorder1: Map<
    string,
    {
      entityID: string
      callback: () => void
    }
  >

  BoxShadow1: Map<
    string,
    {
      entityID: string
      callback: () => void
    }
  >

  Link1: Map<
    string,
    {
      entityID: string
      callback: () => void
    }
  >

  TextComponent1: Map<
    string,
    {
      entityID: string
      callback: () => void
    }
  >

  TextSettings1: Map<
    string,
    {
      entityID: string
      callback: () => void
    }
  >

  FontWeight1: Map<
    string,
    {
      entityID: string
      callback: () => void
    }
  >

  ImageComponent1: Map<
    string,
    {
      entityID: string
      callback: () => void
    }
  >

  FormComponent1: Map<
    string,
    {
      entityID: string
      callback: () => void
    }
  >

  Form1: Map<
    string,
    {
      entityID: string
      callback: () => void
    }
  >

  ExtraInput1: Map<
    string,
    {
      entityID: string
      callback: () => void
    }
  >

  QuizComponent1: Map<
    string,
    {
      entityID: string
      callback: () => void
    }
  >

  Quiz1: Map<
    string,
    {
      entityID: string
      callback: () => void
    }
  >

  QuizStep1: Map<
    string,
    {
      entityID: string
      callback: () => void
    }
  >

  QuizCheckboxStep1: Map<
    string,
    {
      entityID: string
      callback: () => void
    }
  >

  QuizCheckboxStepItem1: Map<
    string,
    {
      entityID: string
      callback: () => void
    }
  >

  QuizRadioStep1: Map<
    string,
    {
      entityID: string
      callback: () => void
    }
  >

  QuizRadioStepItem1: Map<
    string,
    {
      entityID: string
      callback: () => void
    }
  >

  QuizFieldInputStep1: Map<
    string,
    {
      entityID: string
      callback: () => void
    }
  >

  VideoComponent1: Map<
    string,
    {
      entityID: string
      callback: () => void
    }
  >

  FaqComponent1: Map<
    string,
    {
      entityID: string
      callback: () => void
    }
  >

  FaqComponentItem1: Map<
    string,
    {
      entityID: string
      callback: () => void
    }
  >

  MapComponent1: Map<
    string,
    {
      entityID: string
      callback: () => void
    }
  >

  MapComponentPoint1: Map<
    string,
    {
      entityID: string
      callback: () => void
    }
  >

  CodeComponent1: Map<
    string,
    {
      entityID: string
      callback: () => void
    }
  >

  WhatsAppBotComponent1: Map<
    string,
    {
      entityID: string
      callback: () => void
    }
  >

  WhatsAppBotLink1: Map<
    string,
    {
      entityID: string
      callback: () => void
    }
  >

  TableColumnSimple: Map<
    string,
    {
      entityID: string
      callback: () => void
    }
  >
  TableColumnAtBoxAtSchema: Map<
    string,
    {
      entityID: string
      callback: () => void
    }
  >
  TableColumnAtBox: Map<
    string,
    {
      entityID: string
      callback: () => void
    }
  >
  TableColumn1: Map<
    string,
    {
      entityID: string
      callback: () => void
    }
  >

  TableAtBox: Map<
    string,
    {
      entityID: string
      callback: () => void
    }
  >
  TableWithID: Map<
    string,
    {
      entityID: string
      callback: () => void
    }
  >
  Table1: Map<
    string,
    {
      entityID: string
      callback: () => void
    }
  >

  TableConnectorAtBox: Map<
    string,
    {
      entityID: string
      callback: () => void
    }
  >
  TableConnectorWithID: Map<
    string,
    {
      entityID: string
      callback: () => void
    }
  >
  TableConnector1: Map<
    string,
    {
      entityID: string
      callback: () => void
    }
  >

  TableDataAtBox: Map<
    string,
    {
      entityID: string
      callback: () => void
    }
  >
  TableDataPinnedToPage: Map<
    string,
    {
      entityID: string
      callback: () => void
    }
  >
  TableData1: Map<
    string,
    {
      entityID: string
      callback: () => void
    }
  >

  TableRowAtBox: Map<
    string,
    {
      entityID: string
      callback: () => void
    }
  >
  TableDataRowPinnedToPage: Map<
    string,
    {
      entityID: string
      callback: () => void
    }
  >
  TableDataRow1: Map<
    string,
    {
      entityID: string
      callback: () => void
    }
  >

  TableRowItemAtBox: Map<
    string,
    {
      entityID: string
      callback: () => void
    }
  >
  TableDataRowItem1: Map<
    string,
    {
      entityID: string
      callback: () => void
    }
  >

  BlockCategory1: Map<
    string,
    {
      entityID: string
      callback: () => void
    }
  >

  Lead1: Map<
    string,
    {
      entityID: string
      callback: () => void
    }
  >

  GroupFont1: Map<
    string,
    {
      entityID: string
      callback: () => void
    }
  >

  WhatsAppBot1: Map<
    string,
    {
      entityID: string
      callback: () => void
    }
  >
} = {
  Site1: new Map(),

  UserSelect1: new Map(),

  TelegramChannel1: new Map(),

  TelegramGift1: new Map(),

  Image1: new Map(),

  PageOnlyWithFields: new Map(),
  Page1: new Map(),
  PageForLink: new Map(),

  Target1: new Map(),

  TelegramPersonalBot1: new Map(),

  PaidPlace1: new Map(),

  PaidPlaceOutcomeBalance1: new Map(),

  TelegramUser1: new Map(),

  Domain1: new Map(),

  SectionsPinned1: new Map(),
  SectionsPinnedID: new Map(),

  Sections1: new Map(),

  Section1: new Map(),
  SectionID: new Map(),

  PopupWithName: new Map(),
  PopupID: new Map(),
  Popup1: new Map(),

  BoxBlock1: new Map(),

  Box1: new Map(),

  ResponsiveBoxSetting1: new Map(),

  BoxSetting1: new Map(),

  BoxBackground1: new Map(),

  Color1: new Map(),

  BoxBorder1: new Map(),

  BoxShadow1: new Map(),

  Link1: new Map(),

  TextComponent1: new Map(),

  TextSettings1: new Map(),

  FontWeight1: new Map(),

  ImageComponent1: new Map(),

  FormComponent1: new Map(),

  Form1: new Map(),

  ExtraInput1: new Map(),

  QuizComponent1: new Map(),

  Quiz1: new Map(),

  QuizStep1: new Map(),

  QuizCheckboxStep1: new Map(),

  QuizCheckboxStepItem1: new Map(),

  QuizRadioStep1: new Map(),

  QuizRadioStepItem1: new Map(),

  QuizFieldInputStep1: new Map(),

  VideoComponent1: new Map(),

  FaqComponent1: new Map(),

  FaqComponentItem1: new Map(),

  MapComponent1: new Map(),

  MapComponentPoint1: new Map(),

  CodeComponent1: new Map(),

  WhatsAppBotComponent1: new Map(),

  WhatsAppBotLink1: new Map(),

  TableColumnSimple: new Map(),
  TableColumnAtBoxAtSchema: new Map(),
  TableColumnAtBox: new Map(),
  TableColumn1: new Map(),

  TableAtBox: new Map(),
  TableWithID: new Map(),
  Table1: new Map(),

  TableConnectorAtBox: new Map(),
  TableConnectorWithID: new Map(),
  TableConnector1: new Map(),

  TableDataAtBox: new Map(),
  TableDataPinnedToPage: new Map(),
  TableData1: new Map(),

  TableRowAtBox: new Map(),
  TableDataRowPinnedToPage: new Map(),
  TableDataRow1: new Map(),

  TableRowItemAtBox: new Map(),
  TableDataRowItem1: new Map(),

  BlockCategory1: new Map(),

  Lead1: new Map(),

  GroupFont1: new Map(),

  WhatsAppBot1: new Map(),
}

const parseAndMoveToStoreData = ({ data }: { data: DataForPrismaModelsForFrontend }) => {
  data.SiteV1.Site1.map(entity => {
    dataStore.Site1.set(entity.id, {
      id: entity.id,

      createdAt: entity.createdAt,

      bitrixAddLeadURL: entity.bitrixAddLeadURL,

      userId: entity.userId,

      lastCacheUpdate: entity.lastCacheUpdate,

      telegramSiteNotificationConnectCode: entity.telegramSiteNotificationConnectCode,

      telegramSiteToChannelConfirmCode: entity.telegramSiteToChannelConfirmCode,

      withBlockGroups: entity.withBlockGroups,

      isTemplate: entity.isTemplate,

      leadEmail: entity.leadEmail,

      logoText: entity.logoText,

      logoSubText: entity.logoSubText,

      customScript: entity.customScript,

      headScript: entity.headScript,

      name: entity.name,

      yandexMetrikaId: entity.yandexMetrikaId,

      metrikaApiKey: entity.metrikaApiKey,

      vkontaktePixelId: entity.vkontaktePixelId,

      user: entity.user,

      telegramChannel: entity.telegramChannel,

      templatePicture: entity.templatePicture,

      paidPlace: entity.paidPlace,

      telegramNotifications: entity.telegramNotifications?.filter(arrayEntity => {
        const getEntity = dataStore.TelegramUser1.get(arrayEntity.id)
        const getEntityFromServer = data.TelegramUser.TelegramUser1.find(serverEntity => serverEntity.id == arrayEntity.id)
        if (getEntity || getEntityFromServer) return true
        return false
      }),
      favicon: entity.favicon,

      domain: entity.domain,

      pagesV1: entity.pagesV1?.filter(arrayEntity => {
        const getEntity = dataStore.Page1.get(arrayEntity.id)
        const getEntityFromServer = data.PageV1.Page1.find(serverEntity => serverEntity.id == arrayEntity.id)
        if (getEntity || getEntityFromServer) return true
        return false
      }),
      leadsV1: entity.leadsV1?.filter(arrayEntity => {
        const getEntity = dataStore.Lead1.get(arrayEntity.id)
        const getEntityFromServer = data.LeadV1.Lead1.find(serverEntity => serverEntity.id == arrayEntity.id)
        if (getEntity || getEntityFromServer) return true
        return false
      }),
      boxShadows: entity.boxShadows?.filter(arrayEntity => {
        const getEntity = dataStore.BoxShadow1.get(arrayEntity.id)
        const getEntityFromServer = data.BoxShadow.BoxShadow1.find(serverEntity => serverEntity.id == arrayEntity.id)
        if (getEntity || getEntityFromServer) return true
        return false
      }),
      quizzesV1: entity.quizzesV1?.filter(arrayEntity => {
        const getEntity = dataStore.Quiz1.get(arrayEntity.id)
        const getEntityFromServer = data.QuizV1.Quiz1.find(serverEntity => serverEntity.id == arrayEntity.id)
        if (getEntity || getEntityFromServer) return true
        return false
      }),
      formsV1: entity.formsV1?.filter(arrayEntity => {
        const getEntity = dataStore.Form1.get(arrayEntity.id)
        const getEntityFromServer = data.FormV1.Form1.find(serverEntity => serverEntity.id == arrayEntity.id)
        if (getEntity || getEntityFromServer) return true
        return false
      }),
      popupsV1: entity.popupsV1?.filter(arrayEntity => {
        const getEntity = dataStore.Popup1.get(arrayEntity.id)
        const getEntityFromServer = data.PopupV1.Popup1.find(serverEntity => serverEntity.id == arrayEntity.id)
        if (getEntity || getEntityFromServer) return true
        return false
      }),
      boxBlocks: entity.boxBlocks?.filter(arrayEntity => {
        const getEntity = dataStore.BoxBlock1.get(arrayEntity.id)
        const getEntityFromServer = data.BoxBlock.BoxBlock1.find(serverEntity => serverEntity.id == arrayEntity.id)
        if (getEntity || getEntityFromServer) return true
        return false
      }),
      categoryBlocks: entity.categoryBlocks?.filter(arrayEntity => {
        const getEntity = dataStore.BlockCategory1.get(arrayEntity.id)
        const getEntityFromServer = data.BlockCategory.BlockCategory1.find(serverEntity => serverEntity.id == arrayEntity.id)
        if (getEntity || getEntityFromServer) return true
        return false
      }),
      sectionsCollection: entity.sectionsCollection?.filter(arrayEntity => {
        const getEntity = dataStore.Sections1.get(arrayEntity.id)
        const getEntityFromServer = data.SectionsV1.Sections1.find(serverEntity => serverEntity.id == arrayEntity.id)
        if (getEntity || getEntityFromServer) return true
        return false
      }),
      targets: entity.targets?.filter(arrayEntity => {
        const getEntity = dataStore.Target1.get(arrayEntity.id)
        const getEntityFromServer = data.Target.Target1.find(serverEntity => serverEntity.id == arrayEntity.id)
        if (getEntity || getEntityFromServer) return true
        return false
      }),
      colors: entity.colors?.filter(arrayEntity => {
        const getEntity = dataStore.Color1.get(arrayEntity.id)
        const getEntityFromServer = data.Color.Color1.find(serverEntity => serverEntity.id == arrayEntity.id)
        if (getEntity || getEntityFromServer) return true
        return false
      }),
      mainColor: entity.mainColor,

      images: entity.images?.filter(arrayEntity => {
        const getEntity = dataStore.Image1.get(arrayEntity.id)
        const getEntityFromServer = data.ImageV1.Image1.find(serverEntity => serverEntity.id == arrayEntity.id)
        if (getEntity || getEntityFromServer) return true
        return false
      }),
      fonts: entity.fonts?.filter(arrayEntity => {
        const getEntity = dataStore.GroupFont1.get(arrayEntity.id)
        const getEntityFromServer = data.GroupFont.GroupFont1.find(serverEntity => serverEntity.id == arrayEntity.id)
        if (getEntity || getEntityFromServer) return true
        return false
      }),
      fontWeights: entity.fontWeights?.filter(arrayEntity => {
        const getEntity = dataStore.FontWeight1.get(arrayEntity.id)
        const getEntityFromServer = data.FontWeight.FontWeight1.find(serverEntity => serverEntity.id == arrayEntity.id)
        if (getEntity || getEntityFromServer) return true
        return false
      }),
      tableConnectors: entity.tableConnectors?.filter(arrayEntity => {
        const getEntity = dataStore.TableConnector1.get(arrayEntity.id)
        const getEntityFromServer = data.TableConnector.TableConnector1.find(serverEntity => serverEntity.id == arrayEntity.id)
        if (getEntity || getEntityFromServer) return true
        return false
      }),
      whatsAppBot: entity.whatsAppBot,
    })
  })

  data.User.UserSelect1.map(entity => {
    dataStore.UserSelect1.set(entity.id, {
      id: entity.id,

      login: entity.login,

      isAdmin: entity.isAdmin,
    })
  })

  data.TelegramChannel.TelegramChannel1.map(entity => {
    dataStore.TelegramChannel1.set(entity.id, {
      id: entity.id,

      channelTitle: entity.channelTitle,

      channelUserName: entity.channelUserName,

      gifts: entity.gifts?.filter(arrayEntity => {
        const getEntity = dataStore.TelegramGift1.get(arrayEntity.id)
        const getEntityFromServer = data.TelegramGift.TelegramGift1.find(serverEntity => serverEntity.id == arrayEntity.id)
        if (getEntity || getEntityFromServer) return true
        return false
      }),
      bot: entity.bot,
    })
  })

  data.TelegramGift.TelegramGift1.map(entity => {
    dataStore.TelegramGift1.set(entity.id, {
      id: entity.id,

      messageStringBigID: entity.messageStringBigID,

      postBodyText: entity.postBodyText,

      postLinkText: entity.postLinkText,

      botBodyText: entity.botBodyText,

      botLinkText: entity.botLinkText,

      botDenyText: entity.botDenyText,

      postImage: entity.postImage,

      botPage: entity.botPage,

      botImage: entity.botImage,

      target: entity.target,

      bot: entity.bot,
    })
  })

  data.ImageV1.Image1.map(entity => {
    dataStore.Image1.set(entity.id, {
      id: entity.id,

      name: entity.name,

      folder: entity.folder,

      size: entity.size,
    })
  })

  data.PageV1.PageOnlyWithFields.map(entity => {
    dataStore.PageOnlyWithFields.set(entity.id, {
      id: entity.id,

      pathname: entity.pathname,

      title: entity.title,

      description: entity.description,
    })
  })
  data.PageV1.Page1.map(entity => {
    dataStore.Page1.set(entity.id, {
      id: entity.id,

      order: entity.order,

      pathname: entity.pathname,

      title: entity.title,

      description: entity.description,

      showFooterSections: entity.showFooterSections,

      showHeaderSections: entity.showHeaderSections,

      sectionsPinnedCollection: entity.sectionsPinnedCollection?.filter(arrayEntity => {
        const getEntity = dataStore.SectionsPinned1.get(arrayEntity.id)
        const getEntityFromServer = data.SectionsPinned.SectionsPinned1.find(serverEntity => serverEntity.id == arrayEntity.id)
        if (getEntity || getEntityFromServer) return true
        return false
      }),
      pinTable: entity.pinTable,
    })
  })
  data.PageV1.PageForLink.map(entity => {
    dataStore.PageForLink.set(entity.id, {
      id: entity.id,

      pathname: entity.pathname,
    })
  })

  data.Target.Target1.map(entity => {
    dataStore.Target1.set(entity.id, {
      id: entity.id,

      name: entity.name,
    })
  })

  data.TelegramPersonalBot.TelegramPersonalBot1.map(entity => {
    dataStore.TelegramPersonalBot1.set(entity.id, {
      id: entity.id,

      errorAtLaunch: entity.errorAtLaunch,

      botName: entity.botName,

      first_name: entity.first_name,

      last_name: entity.last_name,
    })
  })

  data.PaidPlace.PaidPlace1.map(entity => {
    dataStore.PaidPlace1.set(entity.id, {
      id: entity.id,

      isFree: entity.isFree,

      paidUntil: entity.paidUntil,

      outcomePaidPlaceBalances: entity.outcomePaidPlaceBalances?.filter(arrayEntity => {
        const getEntity = dataStore.PaidPlaceOutcomeBalance1.get(arrayEntity.id)
        const getEntityFromServer = data.PaidPlaceOutcomeBalance.PaidPlaceOutcomeBalance1.find(
          serverEntity => serverEntity.id == arrayEntity.id
        )
        if (getEntity || getEntityFromServer) return true
        return false
      }),
    })
  })

  data.PaidPlaceOutcomeBalance.PaidPlaceOutcomeBalance1.map(entity => {
    dataStore.PaidPlaceOutcomeBalance1.set(entity.id, {
      id: entity.id,
    })
  })

  data.TelegramUser.TelegramUser1.map(entity => {
    dataStore.TelegramUser1.set(entity.id, {
      id: entity.id,

      userName: entity.userName,

      firstName: entity.firstName,

      lastName: entity.lastName,
    })
  })

  data.DomainV1.Domain1.map(entity => {
    dataStore.Domain1.set(entity.id, {
      id: entity.id,

      domain: entity.domain,
    })
  })

  data.SectionsPinned.SectionsPinned1.map(entity => {
    dataStore.SectionsPinned1.set(entity.id, {
      id: entity.id,

      order: entity.order,

      isPinned: entity.isPinned,

      sectionsCollection: entity.sectionsCollection,
    })
  })
  data.SectionsPinned.SectionsPinnedID.map(entity => {
    dataStore.SectionsPinnedID.set(entity.id, {
      id: entity.id,
    })
  })

  data.SectionsV1.Sections1.map(entity => {
    dataStore.Sections1.set(entity.id, {
      id: entity.id,

      sectionsChild: entity.sectionsChild?.filter(arrayEntity => {
        const getEntity = dataStore.Section1.get(arrayEntity.id)
        const getEntityFromServer = data.SectionV1.Section1.find(serverEntity => serverEntity.id == arrayEntity.id)
        if (getEntity || getEntityFromServer) return true
        return false
      }),
    })
  })

  data.SectionV1.Section1.map(entity => {
    dataStore.Section1.set(entity.id, {
      id: entity.id,

      order: entity.order,

      popupOpen: entity.popupOpen,

      boxBlock: entity.boxBlock,
    })
  })
  data.SectionV1.SectionID.map(entity => {
    dataStore.SectionID.set(entity.id, {
      id: entity.id,
    })
  })

  data.PopupV1.PopupWithName.map(entity => {
    dataStore.PopupWithName.set(entity.id, {
      id: entity.id,

      name: entity.name,
    })
  })
  data.PopupV1.PopupID.map(entity => {
    dataStore.PopupID.set(entity.id, {
      id: entity.id,
    })
  })
  data.PopupV1.Popup1.map(entity => {
    dataStore.Popup1.set(entity.id, {
      id: entity.id,

      name: entity.name,

      verticalPosition: entity.verticalPosition,

      horizontalPosition: entity.horizontalPosition,

      form: entity.form,

      quiz: entity.quiz,

      box: entity.box,

      boxBlock: entity.boxBlock,
    })
  })

  data.BoxBlock.BoxBlock1.map(entity => {
    dataStore.BoxBlock1.set(entity.id, {
      id: entity.id,

      box: entity.box,

      categories: entity.categories?.filter(arrayEntity => {
        const getEntity = dataStore.BlockCategory1.get(arrayEntity.id)
        const getEntityFromServer = data.BlockCategory.BlockCategory1.find(serverEntity => serverEntity.id == arrayEntity.id)
        if (getEntity || getEntityFromServer) return true
        return false
      }),
      pinedPopup: entity.pinedPopup,
    })
  })

  data.Box.Box1.map(entity => {
    dataStore.Box1.set(entity.id, {
      id: entity.id,

      siteId: entity.siteId,

      parentBoxId: entity.parentBoxId,

      widthType: entity.widthType,

      widthTypeMobileResponsiveMode: entity.widthTypeMobileResponsiveMode,

      widthTypeTabletResponsiveMode: entity.widthTypeTabletResponsiveMode,

      widthTypeDesktopResponsiveMode: entity.widthTypeDesktopResponsiveMode,

      heightType: entity.heightType,

      heightTypeMobileResponsiveMode: entity.heightTypeMobileResponsiveMode,

      heightTypeTabletResponsiveMode: entity.heightTypeTabletResponsiveMode,

      heightTypeDesktopResponsiveMode: entity.heightTypeDesktopResponsiveMode,

      positionTypeMobileResponsiveMode: entity.positionTypeMobileResponsiveMode,

      positionTypeTabletResponsiveMode: entity.positionTypeTabletResponsiveMode,

      positionTypeDesktopResponsiveMode: entity.positionTypeDesktopResponsiveMode,

      hiddenMobileResponsiveMode: entity.hiddenMobileResponsiveMode,

      hiddenTabletResponsiveMode: entity.hiddenTabletResponsiveMode,

      hiddenDesktopResponsiveMode: entity.hiddenDesktopResponsiveMode,

      overflowHiddenMobileResponsiveMode: entity.overflowHiddenMobileResponsiveMode,

      overflowHiddenTabletResponsiveMode: entity.overflowHiddenTabletResponsiveMode,

      overflowHiddenDesktopResponsiveMode: entity.overflowHiddenDesktopResponsiveMode,

      gapMobileResponsiveMode: entity.gapMobileResponsiveMode,

      gapTabletResponsiveMode: entity.gapTabletResponsiveMode,

      gapDesktopResponsiveMode: entity.gapDesktopResponsiveMode,

      widthMobileResponsiveMode: entity.widthMobileResponsiveMode,

      widthTabletResponsiveMode: entity.widthTabletResponsiveMode,

      widthDesktopResponsiveMode: entity.widthDesktopResponsiveMode,

      heightMobileResponsiveMode: entity.heightMobileResponsiveMode,

      heightTabletResponsiveMode: entity.heightTabletResponsiveMode,

      heightDesktopResponsiveMode: entity.heightDesktopResponsiveMode,

      marginMobileResponsiveMode: entity.marginMobileResponsiveMode,

      marginTabletResponsiveMode: entity.marginTabletResponsiveMode,

      marginDesktopResponsiveMode: entity.marginDesktopResponsiveMode,

      paddingMobileResponsiveMode: entity.paddingMobileResponsiveMode,

      paddingTabletResponsiveMode: entity.paddingTabletResponsiveMode,

      paddingDesktopResponsiveMode: entity.paddingDesktopResponsiveMode,

      positionMobileResponsiveMode: entity.positionMobileResponsiveMode,

      positionTabletResponsiveMode: entity.positionTabletResponsiveMode,

      positionDesktopResponsiveMode: entity.positionDesktopResponsiveMode,

      backgroundMobileResponsiveMode: entity.backgroundMobileResponsiveMode,

      backgroundTabletResponsiveMode: entity.backgroundTabletResponsiveMode,

      backgroundDesktopResponsiveMode: entity.backgroundDesktopResponsiveMode,

      borderRadiusMobileResponsiveMode: entity.borderRadiusMobileResponsiveMode,

      borderRadiusTabletResponsiveMode: entity.borderRadiusTabletResponsiveMode,

      borderRadiusDesktopResponsiveMode: entity.borderRadiusDesktopResponsiveMode,

      borderMobileResponsiveMode: entity.borderMobileResponsiveMode,

      borderTabletResponsiveMode: entity.borderTabletResponsiveMode,

      borderDesktopResponsiveMode: entity.borderDesktopResponsiveMode,

      shadowMobileResponsiveMode: entity.shadowMobileResponsiveMode,

      shadowTabletResponsiveMode: entity.shadowTabletResponsiveMode,

      shadowDesktopResponsiveMode: entity.shadowDesktopResponsiveMode,

      isSliderShell: entity.isSliderShell,

      isSlider: entity.isSlider,

      isSliderArrowNext: entity.isSliderArrowNext,

      isSliderArrowPrev: entity.isSliderArrowPrev,

      isClosePopup: entity.isClosePopup,

      isInput: entity.isInput,

      tableColumnDataOutputID: entity.tableColumnDataOutputID,

      tableImageIsCover: entity.tableImageIsCover,

      popup: entity.popup,

      responsiveBoxSettings: entity.responsiveBoxSettings,

      link: entity.link,

      textComponent: entity.textComponent,

      imageComponent: entity.imageComponent,

      formComponent: entity.formComponent,

      quizComponent: entity.quizComponent,

      videoComponent: entity.videoComponent,

      faqComponent: entity.faqComponent,

      mapComponent: entity.mapComponent,

      codeComponent: entity.codeComponent,

      wBotComponent: entity.wBotComponent,

      boxes: entity.boxes?.filter(arrayEntity => {
        const getEntity = dataStore.Box1.get(arrayEntity.id)
        const getEntityFromServer = data.Box.Box1.find(serverEntity => serverEntity.id == arrayEntity.id)
        if (getEntity || getEntityFromServer) return true
        return false
      }),
      tableColumnDataOutput: entity.tableColumnDataOutput,

      pinTable: entity.pinTable,
    })
  })

  data.ResponsiveBoxSettings.ResponsiveBoxSetting1.map(entity => {
    dataStore.ResponsiveBoxSetting1.set(entity.id, {
      id: entity.id,

      desktopBoxSettings: entity.desktopBoxSettings,

      tabletBoxSettings: entity.tabletBoxSettings,

      mobileBoxSettings: entity.mobileBoxSettings,
    })
  })

  data.BoxSettings.BoxSetting1.map(entity => {
    dataStore.BoxSetting1.set(entity.id, {
      id: entity.id,

      widthType: entity.widthType,

      heightType: entity.heightType,

      positionType: entity.positionType,

      positionX: entity.positionX,

      positionY: entity.positionY,

      marginTop: entity.marginTop,

      marginLeft: entity.marginLeft,

      marginBottom: entity.marginBottom,

      marginRight: entity.marginRight,

      paddingTop: entity.paddingTop,

      paddingLeft: entity.paddingLeft,

      paddingBottom: entity.paddingBottom,

      paddingRight: entity.paddingRight,

      borderRadiusLeftTop: entity.borderRadiusLeftTop,

      borderRadiusLeftBottom: entity.borderRadiusLeftBottom,

      borderRadiusRightTop: entity.borderRadiusRightTop,

      borderRadiusRightBottom: entity.borderRadiusRightBottom,

      width: entity.width,

      height: entity.height,

      hidden: entity.hidden,

      isOverflowHidden: entity.isOverflowHidden,

      vector: entity.vector,

      horizontalPosition: entity.horizontalPosition,

      verticalPosition: entity.verticalPosition,

      gap: entity.gap,

      order: entity.order,

      background: entity.background,

      border: entity.border,

      shadow: entity.shadow,
    })
  })

  data.BoxBackground.BoxBackground1.map(entity => {
    dataStore.BoxBackground1.set(entity.id, {
      id: entity.id,

      positionX: entity.positionX,

      positionY: entity.positionY,

      width: entity.width,

      height: entity.height,

      verticalPosition: entity.verticalPosition,

      image: entity.image,

      color: entity.color,
    })
  })

  data.Color.Color1.map(entity => {
    dataStore.Color1.set(entity.id, {
      id: entity.id,

      name: entity.name,

      viewName: entity.viewName,

      value: entity.value,
    })
  })

  data.BoxBorder.BoxBorder1.map(entity => {
    dataStore.BoxBorder1.set(entity.id, {
      id: entity.id,

      top: entity.top,

      right: entity.right,

      bottom: entity.bottom,

      left: entity.left,

      color: entity.color,
    })
  })

  data.BoxShadow.BoxShadow1.map(entity => {
    dataStore.BoxShadow1.set(entity.id, {
      id: entity.id,

      viewName: entity.viewName,

      xShift: entity.xShift,

      yShift: entity.yShift,

      blur: entity.blur,

      spread: entity.spread,

      color: entity.color,
    })
  })

  data.LinkV1.Link1.map(entity => {
    dataStore.Link1.set(entity.id, {
      id: entity.id,

      popupData: entity.popupData,

      url: entity.url,

      page: entity.page,

      sectionCollection: entity.sectionCollection,

      section: entity.section,

      popup: entity.popup,
    })
  })

  data.TextComponent.TextComponent1.map(entity => {
    dataStore.TextComponent1.set(entity.id, {
      id: entity.id,

      text: entity.text,

      type: entity.type,

      alignMobileResponsiveMode: entity.alignMobileResponsiveMode,

      alignTabletResponsiveMode: entity.alignTabletResponsiveMode,

      alignDesktopResponsiveMode: entity.alignDesktopResponsiveMode,

      alignMobile: entity.alignMobile,

      alignTablet: entity.alignTablet,

      alignDesktop: entity.alignDesktop,

      textSettings: entity.textSettings,
    })
  })

  data.TextSettings.TextSettings1.map(entity => {
    dataStore.TextSettings1.set(entity.id, {
      id: entity.id,

      name: entity.name,

      lib: entity.lib,

      siteId: entity.siteId,

      fontSizeMobileResponsiveMode: entity.fontSizeMobileResponsiveMode,

      fontSizeTabletResponsiveMode: entity.fontSizeTabletResponsiveMode,

      fontSizeDesktopResponsiveMode: entity.fontSizeDesktopResponsiveMode,

      fontSizeMobile: entity.fontSizeMobile,

      fontSizeTablet: entity.fontSizeTablet,

      fontSizeDesktop: entity.fontSizeDesktop,

      lineHeightMobileResponsiveMode: entity.lineHeightMobileResponsiveMode,

      lineHeightTabletResponsiveMode: entity.lineHeightTabletResponsiveMode,

      lineHeightDesktopResponsiveMode: entity.lineHeightDesktopResponsiveMode,

      lineHeightMobile: entity.lineHeightMobile,

      lineHeightTablet: entity.lineHeightTablet,

      lineHeightDesktop: entity.lineHeightDesktop,

      fontWeightMobileResponsiveMode: entity.fontWeightMobileResponsiveMode,

      fontWeightTabletResponsiveMode: entity.fontWeightTabletResponsiveMode,

      fontWeightDesktopResponsiveMode: entity.fontWeightDesktopResponsiveMode,

      fontWeightMobile: entity.fontWeightMobile,

      fontWeightTablet: entity.fontWeightTablet,

      fontWeightDesktop: entity.fontWeightDesktop,
    })
  })

  data.FontWeight.FontWeight1.map(entity => {
    dataStore.FontWeight1.set(entity.id, {
      id: entity.id,

      previewName: entity.previewName,

      name: entity.name,

      folder: entity.folder,

      size: entity.size,
    })
  })

  data.ImageComponent.ImageComponent1.map(entity => {
    dataStore.ImageComponent1.set(entity.id, {
      id: entity.id,

      width: entity.width,

      height: entity.height,

      positionX: entity.positionX,

      positionY: entity.positionY,

      shellWidth: entity.shellWidth,

      shellHeight: entity.shellHeight,

      isCover: entity.isCover,

      image: entity.image,
    })
  })

  data.FormComponent.FormComponent1.map(entity => {
    dataStore.FormComponent1.set(entity.id, {
      id: entity.id,

      form: entity.form,
    })
  })

  data.FormV1.Form1.map(entity => {
    dataStore.Form1.set(entity.id, {
      id: entity.id,

      title: entity.title,

      description: entity.description,

      formButtonText: entity.formButtonText,

      name: entity.name,

      extraInputs: entity.extraInputs?.filter(arrayEntity => {
        const getEntity = dataStore.ExtraInput1.get(arrayEntity.id)
        const getEntityFromServer = data.ExtraInputV1.ExtraInput1.find(serverEntity => serverEntity.id == arrayEntity.id)
        if (getEntity || getEntityFromServer) return true
        return false
      }),
      target: entity.target,

      link: entity.link,
    })
  })

  data.ExtraInputV1.ExtraInput1.map(entity => {
    dataStore.ExtraInput1.set(entity.id, {
      id: entity.id,

      order: entity.order,

      placeholder: entity.placeholder,

      bitrixFieldName: entity.bitrixFieldName,

      type: entity.type,

      isRequired: entity.isRequired,
    })
  })

  data.QuizComponent.QuizComponent1.map(entity => {
    dataStore.QuizComponent1.set(entity.id, {
      id: entity.id,

      quiz: entity.quiz,
    })
  })

  data.QuizV1.Quiz1.map(entity => {
    dataStore.Quiz1.set(entity.id, {
      id: entity.id,

      name: entity.name,

      title: entity.title,

      description: entity.description,

      form: entity.form,

      steps: entity.steps?.filter(arrayEntity => {
        const getEntity = dataStore.QuizStep1.get(arrayEntity.id)
        const getEntityFromServer = data.QuizV1StepV1.QuizStep1.find(serverEntity => serverEntity.id == arrayEntity.id)
        if (getEntity || getEntityFromServer) return true
        return false
      }),
      mainColor: entity.mainColor,

      textColor: entity.textColor,

      buttonTextColor: entity.buttonTextColor,
    })
  })

  data.QuizV1StepV1.QuizStep1.map(entity => {
    dataStore.QuizStep1.set(entity.id, {
      id: entity.id,

      order: entity.order,

      isItemWithImage: entity.isItemWithImage,

      checkboxStepsV1: entity.checkboxStepsV1,

      radioStepsV1: entity.radioStepsV1,

      fieldInputStep: entity.fieldInputStep,
    })
  })

  data.QuizV1CheckboxStepV1.QuizCheckboxStep1.map(entity => {
    dataStore.QuizCheckboxStep1.set(entity.id, {
      id: entity.id,

      title: entity.title,

      checkboxItemsV1: entity.checkboxItemsV1?.filter(arrayEntity => {
        const getEntity = dataStore.QuizCheckboxStepItem1.get(arrayEntity.id)
        const getEntityFromServer = data.QuizV1CheckboxItemV1.QuizCheckboxStepItem1.find(
          serverEntity => serverEntity.id == arrayEntity.id
        )
        if (getEntity || getEntityFromServer) return true
        return false
      }),
    })
  })

  data.QuizV1CheckboxItemV1.QuizCheckboxStepItem1.map(entity => {
    dataStore.QuizCheckboxStepItem1.set(entity.id, {
      id: entity.id,

      order: entity.order,

      title: entity.title,

      target: entity.target,

      image: entity.image,
    })
  })

  data.QuizV1RadioStepV1.QuizRadioStep1.map(entity => {
    dataStore.QuizRadioStep1.set(entity.id, {
      id: entity.id,

      title: entity.title,

      radioItemsV1: entity.radioItemsV1?.filter(arrayEntity => {
        const getEntity = dataStore.QuizRadioStepItem1.get(arrayEntity.id)
        const getEntityFromServer = data.QuizV1RadioItemV1.QuizRadioStepItem1.find(
          serverEntity => serverEntity.id == arrayEntity.id
        )
        if (getEntity || getEntityFromServer) return true
        return false
      }),
    })
  })

  data.QuizV1RadioItemV1.QuizRadioStepItem1.map(entity => {
    dataStore.QuizRadioStepItem1.set(entity.id, {
      id: entity.id,

      order: entity.order,

      title: entity.title,

      target: entity.target,

      image: entity.image,
    })
  })

  data.QuizV1FieldInputStepV1.QuizFieldInputStep1.map(entity => {
    dataStore.QuizFieldInputStep1.set(entity.id, {
      id: entity.id,

      title: entity.title,

      placeholder: entity.placeholder,
    })
  })

  data.VideoComponent.VideoComponent1.map(entity => {
    dataStore.VideoComponent1.set(entity.id, {
      id: entity.id,

      videoURL: entity.videoURL,
    })
  })

  data.FaqComponent.FaqComponent1.map(entity => {
    dataStore.FaqComponent1.set(entity.id, {
      id: entity.id,

      faqItems: entity.faqItems?.filter(arrayEntity => {
        const getEntity = dataStore.FaqComponentItem1.get(arrayEntity.id)
        const getEntityFromServer = data.FaqComponentItem.FaqComponentItem1.find(
          serverEntity => serverEntity.id == arrayEntity.id
        )
        if (getEntity || getEntityFromServer) return true
        return false
      }),
    })
  })

  data.FaqComponentItem.FaqComponentItem1.map(entity => {
    dataStore.FaqComponentItem1.set(entity.id, {
      id: entity.id,

      order: entity.order,

      question: entity.question,

      answer: entity.answer,
    })
  })

  data.MapComponent.MapComponent1.map(entity => {
    dataStore.MapComponent1.set(entity.id, {
      id: entity.id,

      zoomFloat: entity.zoomFloat,

      centerLat: entity.centerLat,

      centerLng: entity.centerLng,

      points: entity.points?.filter(arrayEntity => {
        const getEntity = dataStore.MapComponentPoint1.get(arrayEntity.id)
        const getEntityFromServer = data.MapComponentPoint.MapComponentPoint1.find(
          serverEntity => serverEntity.id == arrayEntity.id
        )
        if (getEntity || getEntityFromServer) return true
        return false
      }),
    })
  })

  data.MapComponentPoint.MapComponentPoint1.map(entity => {
    dataStore.MapComponentPoint1.set(entity.id, {
      id: entity.id,

      lat: entity.lat,

      lng: entity.lng,
    })
  })

  data.CodeComponent.CodeComponent1.map(entity => {
    dataStore.CodeComponent1.set(entity.id, {
      id: entity.id,

      code: entity.code,
    })
  })

  data.WBotComponent.WhatsAppBotComponent1.map(entity => {
    dataStore.WhatsAppBotComponent1.set(entity.id, {
      id: entity.id,

      link: entity.link,
    })
  })

  data.WhatsAppBotLink.WhatsAppBotLink1.map(entity => {
    dataStore.WhatsAppBotLink1.set(entity.id, {
      id: entity.id,

      text: entity.text,

      target: entity.target,
    })
  })

  data.TableColumn.TableColumnSimple.map(entity => {
    dataStore.TableColumnSimple.set(entity.id, {
      id: entity.id,

      name: entity.name,

      order: entity.order,

      width: entity.width,

      type: entity.type,
    })
  })
  data.TableColumn.TableColumnAtBoxAtSchema.map(entity => {
    dataStore.TableColumnAtBoxAtSchema.set(entity.id, {
      id: entity.id,

      name: entity.name,

      order: entity.order,

      width: entity.width,

      type: entity.type,

      columnTableSchema: entity.columnTableSchema,
    })
  })
  data.TableColumn.TableColumnAtBox.map(entity => {
    dataStore.TableColumnAtBox.set(entity.id, {
      id: entity.id,

      motherTableID: entity.motherTableID,

      name: entity.name,

      type: entity.type,
    })
  })
  data.TableColumn.TableColumn1.map(entity => {
    dataStore.TableColumn1.set(entity.id, {
      id: entity.id,

      name: entity.name,

      order: entity.order,

      width: entity.width,

      type: entity.type,

      columnTableSchema: entity.columnTableSchema,
    })
  })

  data.Table.TableAtBox.map(entity => {
    dataStore.TableAtBox.set(entity.id, {
      id: entity.id,

      name: entity.name,

      colums: entity.colums?.filter(arrayEntity => {
        const getEntity = dataStore.TableColumnAtBoxAtSchema.get(arrayEntity.id)
        const getEntityFromServer = data.TableColumn.TableColumnAtBoxAtSchema.find(
          serverEntity => serverEntity.id == arrayEntity.id
        )
        if (getEntity || getEntityFromServer) return true
        return false
      }),
      connector: entity.connector,

      pinnedTableData: entity.pinnedTableData?.filter(arrayEntity => {
        const getEntity = dataStore.TableDataPinnedToPage.get(arrayEntity.id)
        const getEntityFromServer = data.TableData.TableDataPinnedToPage.find(serverEntity => serverEntity.id == arrayEntity.id)
        if (getEntity || getEntityFromServer) return true
        return false
      }),
    })
  })
  data.Table.TableWithID.map(entity => {
    dataStore.TableWithID.set(entity.id, {
      id: entity.id,
    })
  })
  data.Table.Table1.map(entity => {
    dataStore.Table1.set(entity.id, {
      id: entity.id,

      name: entity.name,

      colums: entity.colums?.filter(arrayEntity => {
        const getEntity = dataStore.TableColumn1.get(arrayEntity.id)
        const getEntityFromServer = data.TableColumn.TableColumn1.find(serverEntity => serverEntity.id == arrayEntity.id)
        if (getEntity || getEntityFromServer) return true
        return false
      }),
      columnTableTypeSchema: entity.columnTableTypeSchema,
    })
  })

  data.TableConnector.TableConnectorAtBox.map(entity => {
    dataStore.TableConnectorAtBox.set(entity.id, {
      id: entity.id,

      tableData: entity.tableData,
    })
  })
  data.TableConnector.TableConnectorWithID.map(entity => {
    dataStore.TableConnectorWithID.set(entity.id, {
      id: entity.id,
    })
  })
  data.TableConnector.TableConnector1.map(entity => {
    dataStore.TableConnector1.set(entity.id, {
      id: entity.id,

      tableSchema: entity.tableSchema,

      tableData: entity.tableData,
    })
  })

  data.TableData.TableDataAtBox.map(entity => {
    dataStore.TableDataAtBox.set(entity.id, {
      id: entity.id,

      rows: entity.rows?.filter(arrayEntity => {
        const getEntity = dataStore.TableRowAtBox.get(arrayEntity.id)
        const getEntityFromServer = data.TableRow.TableRowAtBox.find(serverEntity => serverEntity.id == arrayEntity.id)
        if (getEntity || getEntityFromServer) return true
        return false
      }),
    })
  })
  data.TableData.TableDataPinnedToPage.map(entity => {
    dataStore.TableDataPinnedToPage.set(entity.id, {
      id: entity.id,

      connector: entity.connector,

      rows: entity.rows?.filter(arrayEntity => {
        const getEntity = dataStore.TableDataRowPinnedToPage.get(arrayEntity.id)
        const getEntityFromServer = data.TableRow.TableDataRowPinnedToPage.find(
          serverEntity => serverEntity.id == arrayEntity.id
        )
        if (getEntity || getEntityFromServer) return true
        return false
      }),
      pinnedToTable: entity.pinnedToTable,
    })
  })
  data.TableData.TableData1.map(entity => {
    dataStore.TableData1.set(entity.id, {
      id: entity.id,

      rows: entity.rows?.filter(arrayEntity => {
        const getEntity = dataStore.TableDataRow1.get(arrayEntity.id)
        const getEntityFromServer = data.TableRow.TableDataRow1.find(serverEntity => serverEntity.id == arrayEntity.id)
        if (getEntity || getEntityFromServer) return true
        return false
      }),
    })
  })

  data.TableRow.TableRowAtBox.map(entity => {
    dataStore.TableRowAtBox.set(entity.id, {
      id: entity.id,

      slug: entity.slug,

      items: entity.items?.filter(arrayEntity => {
        const getEntity = dataStore.TableRowItemAtBox.get(arrayEntity.id)
        const getEntityFromServer = data.TableRowItem.TableRowItemAtBox.find(serverEntity => serverEntity.id == arrayEntity.id)
        if (getEntity || getEntityFromServer) return true
        return false
      }),
    })
  })
  data.TableRow.TableDataRowPinnedToPage.map(entity => {
    dataStore.TableDataRowPinnedToPage.set(entity.id, {
      id: entity.id,

      slug: entity.slug,
    })
  })
  data.TableRow.TableDataRow1.map(entity => {
    dataStore.TableDataRow1.set(entity.id, {
      id: entity.id,

      slug: entity.slug,

      items: entity.items?.filter(arrayEntity => {
        const getEntity = dataStore.TableDataRowItem1.get(arrayEntity.id)
        const getEntityFromServer = data.TableRowItem.TableDataRowItem1.find(serverEntity => serverEntity.id == arrayEntity.id)
        if (getEntity || getEntityFromServer) return true
        return false
      }),
    })
  })

  data.TableRowItem.TableRowItemAtBox.map(entity => {
    dataStore.TableRowItemAtBox.set(entity.id, {
      id: entity.id,

      text: entity.text,

      number: entity.number,

      tableColumnID: entity.tableColumnID,

      image: entity.image,

      tableData: entity.tableData,

      tableColumn: entity.tableColumn,
    })
  })
  data.TableRowItem.TableDataRowItem1.map(entity => {
    dataStore.TableDataRowItem1.set(entity.id, {
      id: entity.id,

      text: entity.text,

      number: entity.number,

      tableColumnID: entity.tableColumnID,

      image: entity.image,

      tableData: entity.tableData,

      tableColumn: entity.tableColumn,
    })
  })

  data.BlockCategory.BlockCategory1.map(entity => {
    dataStore.BlockCategory1.set(entity.id, {
      id: entity.id,

      name: entity.name,
    })
  })

  data.LeadV1.Lead1.map(entity => {
    dataStore.Lead1.set(entity.id, {
      id: entity.id,

      createdAt: entity.createdAt,

      information: entity.information,

      AmazonEmailMessageId: entity.AmazonEmailMessageId,
    })
  })

  data.GroupFont.GroupFont1.map(entity => {
    dataStore.GroupFont1.set(entity.id, {
      id: entity.id,

      name: entity.name,

      weight: entity.weight?.filter(arrayEntity => {
        const getEntity = dataStore.FontWeight1.get(arrayEntity.id)
        const getEntityFromServer = data.FontWeight.FontWeight1.find(serverEntity => serverEntity.id == arrayEntity.id)
        if (getEntity || getEntityFromServer) return true
        return false
      }),
    })
  })

  data.WhatsAppBot.WhatsAppBot1.map(entity => {
    dataStore.WhatsAppBot1.set(entity.id, {
      id: entity.id,

      phone: entity.phone,

      qrCode: entity.qrCode,

      connected: entity.connected,

      links: entity.links?.filter(arrayEntity => {
        const getEntity = dataStore.WhatsAppBotLink1.get(arrayEntity.id)
        const getEntityFromServer = data.WhatsAppBotLink.WhatsAppBotLink1.find(
          serverEntity => serverEntity.id == arrayEntity.id
        )
        if (getEntity || getEntityFromServer) return true
        return false
      }),
    })
  })
}
const parseAndMoveToStoreDataPartial = ({ data }: { data: DataForPrismaModelsForFrontendPartial }) => {
  data.SiteV1.Site1.map(entity => {
    const getEntity = dataStore.Site1.get(entity.id)
    if (getEntity) {
      dataStore.Site1.set(entity.id, {
        id: entity.id !== undefined ? entity.id : getEntity.id,
        createdAt: entity.createdAt !== undefined ? entity.createdAt : getEntity.createdAt,
        bitrixAddLeadURL: entity.bitrixAddLeadURL !== undefined ? entity.bitrixAddLeadURL : getEntity.bitrixAddLeadURL,
        userId: entity.userId !== undefined ? entity.userId : getEntity.userId,
        lastCacheUpdate: entity.lastCacheUpdate !== undefined ? entity.lastCacheUpdate : getEntity.lastCacheUpdate,
        telegramSiteNotificationConnectCode:
          entity.telegramSiteNotificationConnectCode !== undefined
            ? entity.telegramSiteNotificationConnectCode
            : getEntity.telegramSiteNotificationConnectCode,
        telegramSiteToChannelConfirmCode:
          entity.telegramSiteToChannelConfirmCode !== undefined
            ? entity.telegramSiteToChannelConfirmCode
            : getEntity.telegramSiteToChannelConfirmCode,
        withBlockGroups: entity.withBlockGroups !== undefined ? entity.withBlockGroups : getEntity.withBlockGroups,
        isTemplate: entity.isTemplate !== undefined ? entity.isTemplate : getEntity.isTemplate,
        leadEmail: entity.leadEmail !== undefined ? entity.leadEmail : getEntity.leadEmail,
        logoText: entity.logoText !== undefined ? entity.logoText : getEntity.logoText,
        logoSubText: entity.logoSubText !== undefined ? entity.logoSubText : getEntity.logoSubText,
        customScript: entity.customScript !== undefined ? entity.customScript : getEntity.customScript,
        headScript: entity.headScript !== undefined ? entity.headScript : getEntity.headScript,
        name: entity.name !== undefined ? entity.name : getEntity.name,
        yandexMetrikaId: entity.yandexMetrikaId !== undefined ? entity.yandexMetrikaId : getEntity.yandexMetrikaId,
        metrikaApiKey: entity.metrikaApiKey !== undefined ? entity.metrikaApiKey : getEntity.metrikaApiKey,
        vkontaktePixelId: entity.vkontaktePixelId !== undefined ? entity.vkontaktePixelId : getEntity.vkontaktePixelId,
        user: entity.user !== undefined ? entity.user : getEntity.user,
        telegramChannel: entity.telegramChannel !== undefined ? entity.telegramChannel : getEntity.telegramChannel,
        templatePicture: entity.templatePicture !== undefined ? entity.templatePicture : getEntity.templatePicture,
        paidPlace: entity.paidPlace !== undefined ? entity.paidPlace : getEntity.paidPlace,
        telegramNotifications:
          entity.telegramNotifications !== undefined
            ? entity.telegramNotifications?.filter(arrayEntity => {
                const getEntity = dataStore.TelegramUser1.get(arrayEntity.id)
                const getEntityFromServer = data.TelegramUser.TelegramUser1.find(
                  serverEntity => serverEntity.id == arrayEntity.id
                )
                if (getEntity || getEntityFromServer) return true
                return false
              })
            : getEntity.telegramNotifications,
        favicon: entity.favicon !== undefined ? entity.favicon : getEntity.favicon,
        domain: entity.domain !== undefined ? entity.domain : getEntity.domain,
        pagesV1:
          entity.pagesV1 !== undefined
            ? entity.pagesV1?.filter(arrayEntity => {
                const getEntity = dataStore.Page1.get(arrayEntity.id)
                const getEntityFromServer = data.PageV1.Page1.find(serverEntity => serverEntity.id == arrayEntity.id)
                if (getEntity || getEntityFromServer) return true
                return false
              })
            : getEntity.pagesV1,
        leadsV1:
          entity.leadsV1 !== undefined
            ? entity.leadsV1?.filter(arrayEntity => {
                const getEntity = dataStore.Lead1.get(arrayEntity.id)
                const getEntityFromServer = data.LeadV1.Lead1.find(serverEntity => serverEntity.id == arrayEntity.id)
                if (getEntity || getEntityFromServer) return true
                return false
              })
            : getEntity.leadsV1,
        boxShadows:
          entity.boxShadows !== undefined
            ? entity.boxShadows?.filter(arrayEntity => {
                const getEntity = dataStore.BoxShadow1.get(arrayEntity.id)
                const getEntityFromServer = data.BoxShadow.BoxShadow1.find(serverEntity => serverEntity.id == arrayEntity.id)
                if (getEntity || getEntityFromServer) return true
                return false
              })
            : getEntity.boxShadows,
        quizzesV1:
          entity.quizzesV1 !== undefined
            ? entity.quizzesV1?.filter(arrayEntity => {
                const getEntity = dataStore.Quiz1.get(arrayEntity.id)
                const getEntityFromServer = data.QuizV1.Quiz1.find(serverEntity => serverEntity.id == arrayEntity.id)
                if (getEntity || getEntityFromServer) return true
                return false
              })
            : getEntity.quizzesV1,
        formsV1:
          entity.formsV1 !== undefined
            ? entity.formsV1?.filter(arrayEntity => {
                const getEntity = dataStore.Form1.get(arrayEntity.id)
                const getEntityFromServer = data.FormV1.Form1.find(serverEntity => serverEntity.id == arrayEntity.id)
                if (getEntity || getEntityFromServer) return true
                return false
              })
            : getEntity.formsV1,
        popupsV1:
          entity.popupsV1 !== undefined
            ? entity.popupsV1?.filter(arrayEntity => {
                const getEntity = dataStore.Popup1.get(arrayEntity.id)
                const getEntityFromServer = data.PopupV1.Popup1.find(serverEntity => serverEntity.id == arrayEntity.id)
                if (getEntity || getEntityFromServer) return true
                return false
              })
            : getEntity.popupsV1,
        boxBlocks:
          entity.boxBlocks !== undefined
            ? entity.boxBlocks?.filter(arrayEntity => {
                const getEntity = dataStore.BoxBlock1.get(arrayEntity.id)
                const getEntityFromServer = data.BoxBlock.BoxBlock1.find(serverEntity => serverEntity.id == arrayEntity.id)
                if (getEntity || getEntityFromServer) return true
                return false
              })
            : getEntity.boxBlocks,
        categoryBlocks:
          entity.categoryBlocks !== undefined
            ? entity.categoryBlocks?.filter(arrayEntity => {
                const getEntity = dataStore.BlockCategory1.get(arrayEntity.id)
                const getEntityFromServer = data.BlockCategory.BlockCategory1.find(
                  serverEntity => serverEntity.id == arrayEntity.id
                )
                if (getEntity || getEntityFromServer) return true
                return false
              })
            : getEntity.categoryBlocks,
        sectionsCollection:
          entity.sectionsCollection !== undefined
            ? entity.sectionsCollection?.filter(arrayEntity => {
                const getEntity = dataStore.Sections1.get(arrayEntity.id)
                const getEntityFromServer = data.SectionsV1.Sections1.find(serverEntity => serverEntity.id == arrayEntity.id)
                if (getEntity || getEntityFromServer) return true
                return false
              })
            : getEntity.sectionsCollection,
        targets:
          entity.targets !== undefined
            ? entity.targets?.filter(arrayEntity => {
                const getEntity = dataStore.Target1.get(arrayEntity.id)
                const getEntityFromServer = data.Target.Target1.find(serverEntity => serverEntity.id == arrayEntity.id)
                if (getEntity || getEntityFromServer) return true
                return false
              })
            : getEntity.targets,
        colors:
          entity.colors !== undefined
            ? entity.colors?.filter(arrayEntity => {
                const getEntity = dataStore.Color1.get(arrayEntity.id)
                const getEntityFromServer = data.Color.Color1.find(serverEntity => serverEntity.id == arrayEntity.id)
                if (getEntity || getEntityFromServer) return true
                return false
              })
            : getEntity.colors,
        mainColor: entity.mainColor !== undefined ? entity.mainColor : getEntity.mainColor,
        images:
          entity.images !== undefined
            ? entity.images?.filter(arrayEntity => {
                const getEntity = dataStore.Image1.get(arrayEntity.id)
                const getEntityFromServer = data.ImageV1.Image1.find(serverEntity => serverEntity.id == arrayEntity.id)
                if (getEntity || getEntityFromServer) return true
                return false
              })
            : getEntity.images,
        fonts:
          entity.fonts !== undefined
            ? entity.fonts?.filter(arrayEntity => {
                const getEntity = dataStore.GroupFont1.get(arrayEntity.id)
                const getEntityFromServer = data.GroupFont.GroupFont1.find(serverEntity => serverEntity.id == arrayEntity.id)
                if (getEntity || getEntityFromServer) return true
                return false
              })
            : getEntity.fonts,
        fontWeights:
          entity.fontWeights !== undefined
            ? entity.fontWeights?.filter(arrayEntity => {
                const getEntity = dataStore.FontWeight1.get(arrayEntity.id)
                const getEntityFromServer = data.FontWeight.FontWeight1.find(serverEntity => serverEntity.id == arrayEntity.id)
                if (getEntity || getEntityFromServer) return true
                return false
              })
            : getEntity.fontWeights,
        tableConnectors:
          entity.tableConnectors !== undefined
            ? entity.tableConnectors?.filter(arrayEntity => {
                const getEntity = dataStore.TableConnector1.get(arrayEntity.id)
                const getEntityFromServer = data.TableConnector.TableConnector1.find(
                  serverEntity => serverEntity.id == arrayEntity.id
                )
                if (getEntity || getEntityFromServer) return true
                return false
              })
            : getEntity.tableConnectors,
        whatsAppBot: entity.whatsAppBot !== undefined ? entity.whatsAppBot : getEntity.whatsAppBot,
      })
    }
  })

  data.User.UserSelect1.map(entity => {
    const getEntity = dataStore.UserSelect1.get(entity.id)
    if (getEntity) {
      dataStore.UserSelect1.set(entity.id, {
        id: entity.id !== undefined ? entity.id : getEntity.id,
        login: entity.login !== undefined ? entity.login : getEntity.login,
        isAdmin: entity.isAdmin !== undefined ? entity.isAdmin : getEntity.isAdmin,
      })
    }
  })

  data.TelegramChannel.TelegramChannel1.map(entity => {
    const getEntity = dataStore.TelegramChannel1.get(entity.id)
    if (getEntity) {
      dataStore.TelegramChannel1.set(entity.id, {
        id: entity.id !== undefined ? entity.id : getEntity.id,
        channelTitle: entity.channelTitle !== undefined ? entity.channelTitle : getEntity.channelTitle,
        channelUserName: entity.channelUserName !== undefined ? entity.channelUserName : getEntity.channelUserName,
        gifts:
          entity.gifts !== undefined
            ? entity.gifts?.filter(arrayEntity => {
                const getEntity = dataStore.TelegramGift1.get(arrayEntity.id)
                const getEntityFromServer = data.TelegramGift.TelegramGift1.find(
                  serverEntity => serverEntity.id == arrayEntity.id
                )
                if (getEntity || getEntityFromServer) return true
                return false
              })
            : getEntity.gifts,
        bot: entity.bot !== undefined ? entity.bot : getEntity.bot,
      })
    }
  })

  data.TelegramGift.TelegramGift1.map(entity => {
    const getEntity = dataStore.TelegramGift1.get(entity.id)
    if (getEntity) {
      dataStore.TelegramGift1.set(entity.id, {
        id: entity.id !== undefined ? entity.id : getEntity.id,
        messageStringBigID: entity.messageStringBigID !== undefined ? entity.messageStringBigID : getEntity.messageStringBigID,
        postBodyText: entity.postBodyText !== undefined ? entity.postBodyText : getEntity.postBodyText,
        postLinkText: entity.postLinkText !== undefined ? entity.postLinkText : getEntity.postLinkText,
        botBodyText: entity.botBodyText !== undefined ? entity.botBodyText : getEntity.botBodyText,
        botLinkText: entity.botLinkText !== undefined ? entity.botLinkText : getEntity.botLinkText,
        botDenyText: entity.botDenyText !== undefined ? entity.botDenyText : getEntity.botDenyText,
        postImage: entity.postImage !== undefined ? entity.postImage : getEntity.postImage,
        botPage: entity.botPage !== undefined ? entity.botPage : getEntity.botPage,
        botImage: entity.botImage !== undefined ? entity.botImage : getEntity.botImage,
        target: entity.target !== undefined ? entity.target : getEntity.target,
        bot: entity.bot !== undefined ? entity.bot : getEntity.bot,
      })
    }
  })

  data.ImageV1.Image1.map(entity => {
    const getEntity = dataStore.Image1.get(entity.id)
    if (getEntity) {
      dataStore.Image1.set(entity.id, {
        id: entity.id !== undefined ? entity.id : getEntity.id,
        name: entity.name !== undefined ? entity.name : getEntity.name,
        folder: entity.folder !== undefined ? entity.folder : getEntity.folder,
        size: entity.size !== undefined ? entity.size : getEntity.size,
      })
    }
  })

  data.PageV1.PageOnlyWithFields.map(entity => {
    const getEntity = dataStore.PageOnlyWithFields.get(entity.id)
    if (getEntity) {
      dataStore.PageOnlyWithFields.set(entity.id, {
        id: entity.id !== undefined ? entity.id : getEntity.id,
        pathname: entity.pathname !== undefined ? entity.pathname : getEntity.pathname,
        title: entity.title !== undefined ? entity.title : getEntity.title,
        description: entity.description !== undefined ? entity.description : getEntity.description,
      })
    }
  })
  data.PageV1.Page1.map(entity => {
    const getEntity = dataStore.Page1.get(entity.id)
    if (getEntity) {
      dataStore.Page1.set(entity.id, {
        id: entity.id !== undefined ? entity.id : getEntity.id,
        order: entity.order !== undefined ? entity.order : getEntity.order,
        pathname: entity.pathname !== undefined ? entity.pathname : getEntity.pathname,
        title: entity.title !== undefined ? entity.title : getEntity.title,
        description: entity.description !== undefined ? entity.description : getEntity.description,
        showFooterSections: entity.showFooterSections !== undefined ? entity.showFooterSections : getEntity.showFooterSections,
        showHeaderSections: entity.showHeaderSections !== undefined ? entity.showHeaderSections : getEntity.showHeaderSections,
        sectionsPinnedCollection:
          entity.sectionsPinnedCollection !== undefined
            ? entity.sectionsPinnedCollection?.filter(arrayEntity => {
                const getEntity = dataStore.SectionsPinned1.get(arrayEntity.id)
                const getEntityFromServer = data.SectionsPinned.SectionsPinned1.find(
                  serverEntity => serverEntity.id == arrayEntity.id
                )
                if (getEntity || getEntityFromServer) return true
                return false
              })
            : getEntity.sectionsPinnedCollection,
        pinTable: entity.pinTable !== undefined ? entity.pinTable : getEntity.pinTable,
      })
    }
  })
  data.PageV1.PageForLink.map(entity => {
    const getEntity = dataStore.PageForLink.get(entity.id)
    if (getEntity) {
      dataStore.PageForLink.set(entity.id, {
        id: entity.id !== undefined ? entity.id : getEntity.id,
        pathname: entity.pathname !== undefined ? entity.pathname : getEntity.pathname,
      })
    }
  })

  data.Target.Target1.map(entity => {
    const getEntity = dataStore.Target1.get(entity.id)
    if (getEntity) {
      dataStore.Target1.set(entity.id, {
        id: entity.id !== undefined ? entity.id : getEntity.id,
        name: entity.name !== undefined ? entity.name : getEntity.name,
      })
    }
  })

  data.TelegramPersonalBot.TelegramPersonalBot1.map(entity => {
    const getEntity = dataStore.TelegramPersonalBot1.get(entity.id)
    if (getEntity) {
      dataStore.TelegramPersonalBot1.set(entity.id, {
        id: entity.id !== undefined ? entity.id : getEntity.id,
        errorAtLaunch: entity.errorAtLaunch !== undefined ? entity.errorAtLaunch : getEntity.errorAtLaunch,
        botName: entity.botName !== undefined ? entity.botName : getEntity.botName,
        first_name: entity.first_name !== undefined ? entity.first_name : getEntity.first_name,
        last_name: entity.last_name !== undefined ? entity.last_name : getEntity.last_name,
      })
    }
  })

  data.PaidPlace.PaidPlace1.map(entity => {
    const getEntity = dataStore.PaidPlace1.get(entity.id)
    if (getEntity) {
      dataStore.PaidPlace1.set(entity.id, {
        id: entity.id !== undefined ? entity.id : getEntity.id,
        isFree: entity.isFree !== undefined ? entity.isFree : getEntity.isFree,
        paidUntil: entity.paidUntil !== undefined ? entity.paidUntil : getEntity.paidUntil,
        outcomePaidPlaceBalances:
          entity.outcomePaidPlaceBalances !== undefined
            ? entity.outcomePaidPlaceBalances?.filter(arrayEntity => {
                const getEntity = dataStore.PaidPlaceOutcomeBalance1.get(arrayEntity.id)
                const getEntityFromServer = data.PaidPlaceOutcomeBalance.PaidPlaceOutcomeBalance1.find(
                  serverEntity => serverEntity.id == arrayEntity.id
                )
                if (getEntity || getEntityFromServer) return true
                return false
              })
            : getEntity.outcomePaidPlaceBalances,
      })
    }
  })

  data.PaidPlaceOutcomeBalance.PaidPlaceOutcomeBalance1.map(entity => {
    const getEntity = dataStore.PaidPlaceOutcomeBalance1.get(entity.id)
    if (getEntity) {
      dataStore.PaidPlaceOutcomeBalance1.set(entity.id, {
        id: entity.id !== undefined ? entity.id : getEntity.id,
      })
    }
  })

  data.TelegramUser.TelegramUser1.map(entity => {
    const getEntity = dataStore.TelegramUser1.get(entity.id)
    if (getEntity) {
      dataStore.TelegramUser1.set(entity.id, {
        id: entity.id !== undefined ? entity.id : getEntity.id,
        userName: entity.userName !== undefined ? entity.userName : getEntity.userName,
        firstName: entity.firstName !== undefined ? entity.firstName : getEntity.firstName,
        lastName: entity.lastName !== undefined ? entity.lastName : getEntity.lastName,
      })
    }
  })

  data.DomainV1.Domain1.map(entity => {
    const getEntity = dataStore.Domain1.get(entity.id)
    if (getEntity) {
      dataStore.Domain1.set(entity.id, {
        id: entity.id !== undefined ? entity.id : getEntity.id,
        domain: entity.domain !== undefined ? entity.domain : getEntity.domain,
      })
    }
  })

  data.SectionsPinned.SectionsPinned1.map(entity => {
    const getEntity = dataStore.SectionsPinned1.get(entity.id)
    if (getEntity) {
      dataStore.SectionsPinned1.set(entity.id, {
        id: entity.id !== undefined ? entity.id : getEntity.id,
        order: entity.order !== undefined ? entity.order : getEntity.order,
        isPinned: entity.isPinned !== undefined ? entity.isPinned : getEntity.isPinned,
        sectionsCollection: entity.sectionsCollection !== undefined ? entity.sectionsCollection : getEntity.sectionsCollection,
      })
    }
  })
  data.SectionsPinned.SectionsPinnedID.map(entity => {
    const getEntity = dataStore.SectionsPinnedID.get(entity.id)
    if (getEntity) {
      dataStore.SectionsPinnedID.set(entity.id, {
        id: entity.id !== undefined ? entity.id : getEntity.id,
      })
    }
  })

  data.SectionsV1.Sections1.map(entity => {
    const getEntity = dataStore.Sections1.get(entity.id)
    if (getEntity) {
      dataStore.Sections1.set(entity.id, {
        id: entity.id !== undefined ? entity.id : getEntity.id,
        sectionsChild:
          entity.sectionsChild !== undefined
            ? entity.sectionsChild?.filter(arrayEntity => {
                const getEntity = dataStore.Section1.get(arrayEntity.id)
                const getEntityFromServer = data.SectionV1.Section1.find(serverEntity => serverEntity.id == arrayEntity.id)
                if (getEntity || getEntityFromServer) return true
                return false
              })
            : getEntity.sectionsChild,
      })
    }
  })

  data.SectionV1.Section1.map(entity => {
    const getEntity = dataStore.Section1.get(entity.id)
    if (getEntity) {
      dataStore.Section1.set(entity.id, {
        id: entity.id !== undefined ? entity.id : getEntity.id,
        order: entity.order !== undefined ? entity.order : getEntity.order,
        popupOpen: entity.popupOpen !== undefined ? entity.popupOpen : getEntity.popupOpen,
        boxBlock: entity.boxBlock !== undefined ? entity.boxBlock : getEntity.boxBlock,
      })
    }
  })
  data.SectionV1.SectionID.map(entity => {
    const getEntity = dataStore.SectionID.get(entity.id)
    if (getEntity) {
      dataStore.SectionID.set(entity.id, {
        id: entity.id !== undefined ? entity.id : getEntity.id,
      })
    }
  })

  data.PopupV1.PopupWithName.map(entity => {
    const getEntity = dataStore.PopupWithName.get(entity.id)
    if (getEntity) {
      dataStore.PopupWithName.set(entity.id, {
        id: entity.id !== undefined ? entity.id : getEntity.id,
        name: entity.name !== undefined ? entity.name : getEntity.name,
      })
    }
  })
  data.PopupV1.PopupID.map(entity => {
    const getEntity = dataStore.PopupID.get(entity.id)
    if (getEntity) {
      dataStore.PopupID.set(entity.id, {
        id: entity.id !== undefined ? entity.id : getEntity.id,
      })
    }
  })
  data.PopupV1.Popup1.map(entity => {
    const getEntity = dataStore.Popup1.get(entity.id)
    if (getEntity) {
      dataStore.Popup1.set(entity.id, {
        id: entity.id !== undefined ? entity.id : getEntity.id,
        name: entity.name !== undefined ? entity.name : getEntity.name,
        verticalPosition: entity.verticalPosition !== undefined ? entity.verticalPosition : getEntity.verticalPosition,
        horizontalPosition: entity.horizontalPosition !== undefined ? entity.horizontalPosition : getEntity.horizontalPosition,
        form: entity.form !== undefined ? entity.form : getEntity.form,
        quiz: entity.quiz !== undefined ? entity.quiz : getEntity.quiz,
        box: entity.box !== undefined ? entity.box : getEntity.box,
        boxBlock: entity.boxBlock !== undefined ? entity.boxBlock : getEntity.boxBlock,
      })
    }
  })

  data.BoxBlock.BoxBlock1.map(entity => {
    const getEntity = dataStore.BoxBlock1.get(entity.id)
    if (getEntity) {
      dataStore.BoxBlock1.set(entity.id, {
        id: entity.id !== undefined ? entity.id : getEntity.id,
        box: entity.box !== undefined ? entity.box : getEntity.box,
        categories:
          entity.categories !== undefined
            ? entity.categories?.filter(arrayEntity => {
                const getEntity = dataStore.BlockCategory1.get(arrayEntity.id)
                const getEntityFromServer = data.BlockCategory.BlockCategory1.find(
                  serverEntity => serverEntity.id == arrayEntity.id
                )
                if (getEntity || getEntityFromServer) return true
                return false
              })
            : getEntity.categories,
        pinedPopup: entity.pinedPopup !== undefined ? entity.pinedPopup : getEntity.pinedPopup,
      })
    }
  })

  data.Box.Box1.map(entity => {
    const getEntity = dataStore.Box1.get(entity.id)
    if (getEntity) {
      dataStore.Box1.set(entity.id, {
        id: entity.id !== undefined ? entity.id : getEntity.id,
        siteId: entity.siteId !== undefined ? entity.siteId : getEntity.siteId,
        parentBoxId: entity.parentBoxId !== undefined ? entity.parentBoxId : getEntity.parentBoxId,
        widthType: entity.widthType !== undefined ? entity.widthType : getEntity.widthType,
        widthTypeMobileResponsiveMode:
          entity.widthTypeMobileResponsiveMode !== undefined
            ? entity.widthTypeMobileResponsiveMode
            : getEntity.widthTypeMobileResponsiveMode,
        widthTypeTabletResponsiveMode:
          entity.widthTypeTabletResponsiveMode !== undefined
            ? entity.widthTypeTabletResponsiveMode
            : getEntity.widthTypeTabletResponsiveMode,
        widthTypeDesktopResponsiveMode:
          entity.widthTypeDesktopResponsiveMode !== undefined
            ? entity.widthTypeDesktopResponsiveMode
            : getEntity.widthTypeDesktopResponsiveMode,
        heightType: entity.heightType !== undefined ? entity.heightType : getEntity.heightType,
        heightTypeMobileResponsiveMode:
          entity.heightTypeMobileResponsiveMode !== undefined
            ? entity.heightTypeMobileResponsiveMode
            : getEntity.heightTypeMobileResponsiveMode,
        heightTypeTabletResponsiveMode:
          entity.heightTypeTabletResponsiveMode !== undefined
            ? entity.heightTypeTabletResponsiveMode
            : getEntity.heightTypeTabletResponsiveMode,
        heightTypeDesktopResponsiveMode:
          entity.heightTypeDesktopResponsiveMode !== undefined
            ? entity.heightTypeDesktopResponsiveMode
            : getEntity.heightTypeDesktopResponsiveMode,
        positionTypeMobileResponsiveMode:
          entity.positionTypeMobileResponsiveMode !== undefined
            ? entity.positionTypeMobileResponsiveMode
            : getEntity.positionTypeMobileResponsiveMode,
        positionTypeTabletResponsiveMode:
          entity.positionTypeTabletResponsiveMode !== undefined
            ? entity.positionTypeTabletResponsiveMode
            : getEntity.positionTypeTabletResponsiveMode,
        positionTypeDesktopResponsiveMode:
          entity.positionTypeDesktopResponsiveMode !== undefined
            ? entity.positionTypeDesktopResponsiveMode
            : getEntity.positionTypeDesktopResponsiveMode,
        hiddenMobileResponsiveMode:
          entity.hiddenMobileResponsiveMode !== undefined
            ? entity.hiddenMobileResponsiveMode
            : getEntity.hiddenMobileResponsiveMode,
        hiddenTabletResponsiveMode:
          entity.hiddenTabletResponsiveMode !== undefined
            ? entity.hiddenTabletResponsiveMode
            : getEntity.hiddenTabletResponsiveMode,
        hiddenDesktopResponsiveMode:
          entity.hiddenDesktopResponsiveMode !== undefined
            ? entity.hiddenDesktopResponsiveMode
            : getEntity.hiddenDesktopResponsiveMode,
        overflowHiddenMobileResponsiveMode:
          entity.overflowHiddenMobileResponsiveMode !== undefined
            ? entity.overflowHiddenMobileResponsiveMode
            : getEntity.overflowHiddenMobileResponsiveMode,
        overflowHiddenTabletResponsiveMode:
          entity.overflowHiddenTabletResponsiveMode !== undefined
            ? entity.overflowHiddenTabletResponsiveMode
            : getEntity.overflowHiddenTabletResponsiveMode,
        overflowHiddenDesktopResponsiveMode:
          entity.overflowHiddenDesktopResponsiveMode !== undefined
            ? entity.overflowHiddenDesktopResponsiveMode
            : getEntity.overflowHiddenDesktopResponsiveMode,
        gapMobileResponsiveMode:
          entity.gapMobileResponsiveMode !== undefined ? entity.gapMobileResponsiveMode : getEntity.gapMobileResponsiveMode,
        gapTabletResponsiveMode:
          entity.gapTabletResponsiveMode !== undefined ? entity.gapTabletResponsiveMode : getEntity.gapTabletResponsiveMode,
        gapDesktopResponsiveMode:
          entity.gapDesktopResponsiveMode !== undefined ? entity.gapDesktopResponsiveMode : getEntity.gapDesktopResponsiveMode,
        widthMobileResponsiveMode:
          entity.widthMobileResponsiveMode !== undefined
            ? entity.widthMobileResponsiveMode
            : getEntity.widthMobileResponsiveMode,
        widthTabletResponsiveMode:
          entity.widthTabletResponsiveMode !== undefined
            ? entity.widthTabletResponsiveMode
            : getEntity.widthTabletResponsiveMode,
        widthDesktopResponsiveMode:
          entity.widthDesktopResponsiveMode !== undefined
            ? entity.widthDesktopResponsiveMode
            : getEntity.widthDesktopResponsiveMode,
        heightMobileResponsiveMode:
          entity.heightMobileResponsiveMode !== undefined
            ? entity.heightMobileResponsiveMode
            : getEntity.heightMobileResponsiveMode,
        heightTabletResponsiveMode:
          entity.heightTabletResponsiveMode !== undefined
            ? entity.heightTabletResponsiveMode
            : getEntity.heightTabletResponsiveMode,
        heightDesktopResponsiveMode:
          entity.heightDesktopResponsiveMode !== undefined
            ? entity.heightDesktopResponsiveMode
            : getEntity.heightDesktopResponsiveMode,
        marginMobileResponsiveMode:
          entity.marginMobileResponsiveMode !== undefined
            ? entity.marginMobileResponsiveMode
            : getEntity.marginMobileResponsiveMode,
        marginTabletResponsiveMode:
          entity.marginTabletResponsiveMode !== undefined
            ? entity.marginTabletResponsiveMode
            : getEntity.marginTabletResponsiveMode,
        marginDesktopResponsiveMode:
          entity.marginDesktopResponsiveMode !== undefined
            ? entity.marginDesktopResponsiveMode
            : getEntity.marginDesktopResponsiveMode,
        paddingMobileResponsiveMode:
          entity.paddingMobileResponsiveMode !== undefined
            ? entity.paddingMobileResponsiveMode
            : getEntity.paddingMobileResponsiveMode,
        paddingTabletResponsiveMode:
          entity.paddingTabletResponsiveMode !== undefined
            ? entity.paddingTabletResponsiveMode
            : getEntity.paddingTabletResponsiveMode,
        paddingDesktopResponsiveMode:
          entity.paddingDesktopResponsiveMode !== undefined
            ? entity.paddingDesktopResponsiveMode
            : getEntity.paddingDesktopResponsiveMode,
        positionMobileResponsiveMode:
          entity.positionMobileResponsiveMode !== undefined
            ? entity.positionMobileResponsiveMode
            : getEntity.positionMobileResponsiveMode,
        positionTabletResponsiveMode:
          entity.positionTabletResponsiveMode !== undefined
            ? entity.positionTabletResponsiveMode
            : getEntity.positionTabletResponsiveMode,
        positionDesktopResponsiveMode:
          entity.positionDesktopResponsiveMode !== undefined
            ? entity.positionDesktopResponsiveMode
            : getEntity.positionDesktopResponsiveMode,
        backgroundMobileResponsiveMode:
          entity.backgroundMobileResponsiveMode !== undefined
            ? entity.backgroundMobileResponsiveMode
            : getEntity.backgroundMobileResponsiveMode,
        backgroundTabletResponsiveMode:
          entity.backgroundTabletResponsiveMode !== undefined
            ? entity.backgroundTabletResponsiveMode
            : getEntity.backgroundTabletResponsiveMode,
        backgroundDesktopResponsiveMode:
          entity.backgroundDesktopResponsiveMode !== undefined
            ? entity.backgroundDesktopResponsiveMode
            : getEntity.backgroundDesktopResponsiveMode,
        borderRadiusMobileResponsiveMode:
          entity.borderRadiusMobileResponsiveMode !== undefined
            ? entity.borderRadiusMobileResponsiveMode
            : getEntity.borderRadiusMobileResponsiveMode,
        borderRadiusTabletResponsiveMode:
          entity.borderRadiusTabletResponsiveMode !== undefined
            ? entity.borderRadiusTabletResponsiveMode
            : getEntity.borderRadiusTabletResponsiveMode,
        borderRadiusDesktopResponsiveMode:
          entity.borderRadiusDesktopResponsiveMode !== undefined
            ? entity.borderRadiusDesktopResponsiveMode
            : getEntity.borderRadiusDesktopResponsiveMode,
        borderMobileResponsiveMode:
          entity.borderMobileResponsiveMode !== undefined
            ? entity.borderMobileResponsiveMode
            : getEntity.borderMobileResponsiveMode,
        borderTabletResponsiveMode:
          entity.borderTabletResponsiveMode !== undefined
            ? entity.borderTabletResponsiveMode
            : getEntity.borderTabletResponsiveMode,
        borderDesktopResponsiveMode:
          entity.borderDesktopResponsiveMode !== undefined
            ? entity.borderDesktopResponsiveMode
            : getEntity.borderDesktopResponsiveMode,
        shadowMobileResponsiveMode:
          entity.shadowMobileResponsiveMode !== undefined
            ? entity.shadowMobileResponsiveMode
            : getEntity.shadowMobileResponsiveMode,
        shadowTabletResponsiveMode:
          entity.shadowTabletResponsiveMode !== undefined
            ? entity.shadowTabletResponsiveMode
            : getEntity.shadowTabletResponsiveMode,
        shadowDesktopResponsiveMode:
          entity.shadowDesktopResponsiveMode !== undefined
            ? entity.shadowDesktopResponsiveMode
            : getEntity.shadowDesktopResponsiveMode,
        isSliderShell: entity.isSliderShell !== undefined ? entity.isSliderShell : getEntity.isSliderShell,
        isSlider: entity.isSlider !== undefined ? entity.isSlider : getEntity.isSlider,
        isSliderArrowNext: entity.isSliderArrowNext !== undefined ? entity.isSliderArrowNext : getEntity.isSliderArrowNext,
        isSliderArrowPrev: entity.isSliderArrowPrev !== undefined ? entity.isSliderArrowPrev : getEntity.isSliderArrowPrev,
        isClosePopup: entity.isClosePopup !== undefined ? entity.isClosePopup : getEntity.isClosePopup,
        isInput: entity.isInput !== undefined ? entity.isInput : getEntity.isInput,
        tableColumnDataOutputID:
          entity.tableColumnDataOutputID !== undefined ? entity.tableColumnDataOutputID : getEntity.tableColumnDataOutputID,
        tableImageIsCover: entity.tableImageIsCover !== undefined ? entity.tableImageIsCover : getEntity.tableImageIsCover,
        popup: entity.popup !== undefined ? entity.popup : getEntity.popup,
        responsiveBoxSettings:
          entity.responsiveBoxSettings !== undefined ? entity.responsiveBoxSettings : getEntity.responsiveBoxSettings,
        link: entity.link !== undefined ? entity.link : getEntity.link,
        textComponent: entity.textComponent !== undefined ? entity.textComponent : getEntity.textComponent,
        imageComponent: entity.imageComponent !== undefined ? entity.imageComponent : getEntity.imageComponent,
        formComponent: entity.formComponent !== undefined ? entity.formComponent : getEntity.formComponent,
        quizComponent: entity.quizComponent !== undefined ? entity.quizComponent : getEntity.quizComponent,
        videoComponent: entity.videoComponent !== undefined ? entity.videoComponent : getEntity.videoComponent,
        faqComponent: entity.faqComponent !== undefined ? entity.faqComponent : getEntity.faqComponent,
        mapComponent: entity.mapComponent !== undefined ? entity.mapComponent : getEntity.mapComponent,
        codeComponent: entity.codeComponent !== undefined ? entity.codeComponent : getEntity.codeComponent,
        wBotComponent: entity.wBotComponent !== undefined ? entity.wBotComponent : getEntity.wBotComponent,
        boxes:
          entity.boxes !== undefined
            ? entity.boxes?.filter(arrayEntity => {
                const getEntity = dataStore.Box1.get(arrayEntity.id)
                const getEntityFromServer = data.Box.Box1.find(serverEntity => serverEntity.id == arrayEntity.id)
                if (getEntity || getEntityFromServer) return true
                return false
              })
            : getEntity.boxes,
        tableColumnDataOutput:
          entity.tableColumnDataOutput !== undefined ? entity.tableColumnDataOutput : getEntity.tableColumnDataOutput,
        pinTable: entity.pinTable !== undefined ? entity.pinTable : getEntity.pinTable,
      })
    }
  })

  data.ResponsiveBoxSettings.ResponsiveBoxSetting1.map(entity => {
    const getEntity = dataStore.ResponsiveBoxSetting1.get(entity.id)
    if (getEntity) {
      dataStore.ResponsiveBoxSetting1.set(entity.id, {
        id: entity.id !== undefined ? entity.id : getEntity.id,
        desktopBoxSettings: entity.desktopBoxSettings !== undefined ? entity.desktopBoxSettings : getEntity.desktopBoxSettings,
        tabletBoxSettings: entity.tabletBoxSettings !== undefined ? entity.tabletBoxSettings : getEntity.tabletBoxSettings,
        mobileBoxSettings: entity.mobileBoxSettings !== undefined ? entity.mobileBoxSettings : getEntity.mobileBoxSettings,
      })
    }
  })

  data.BoxSettings.BoxSetting1.map(entity => {
    const getEntity = dataStore.BoxSetting1.get(entity.id)
    if (getEntity) {
      dataStore.BoxSetting1.set(entity.id, {
        id: entity.id !== undefined ? entity.id : getEntity.id,
        widthType: entity.widthType !== undefined ? entity.widthType : getEntity.widthType,
        heightType: entity.heightType !== undefined ? entity.heightType : getEntity.heightType,
        positionType: entity.positionType !== undefined ? entity.positionType : getEntity.positionType,
        positionX: entity.positionX !== undefined ? entity.positionX : getEntity.positionX,
        positionY: entity.positionY !== undefined ? entity.positionY : getEntity.positionY,
        marginTop: entity.marginTop !== undefined ? entity.marginTop : getEntity.marginTop,
        marginLeft: entity.marginLeft !== undefined ? entity.marginLeft : getEntity.marginLeft,
        marginBottom: entity.marginBottom !== undefined ? entity.marginBottom : getEntity.marginBottom,
        marginRight: entity.marginRight !== undefined ? entity.marginRight : getEntity.marginRight,
        paddingTop: entity.paddingTop !== undefined ? entity.paddingTop : getEntity.paddingTop,
        paddingLeft: entity.paddingLeft !== undefined ? entity.paddingLeft : getEntity.paddingLeft,
        paddingBottom: entity.paddingBottom !== undefined ? entity.paddingBottom : getEntity.paddingBottom,
        paddingRight: entity.paddingRight !== undefined ? entity.paddingRight : getEntity.paddingRight,
        borderRadiusLeftTop:
          entity.borderRadiusLeftTop !== undefined ? entity.borderRadiusLeftTop : getEntity.borderRadiusLeftTop,
        borderRadiusLeftBottom:
          entity.borderRadiusLeftBottom !== undefined ? entity.borderRadiusLeftBottom : getEntity.borderRadiusLeftBottom,
        borderRadiusRightTop:
          entity.borderRadiusRightTop !== undefined ? entity.borderRadiusRightTop : getEntity.borderRadiusRightTop,
        borderRadiusRightBottom:
          entity.borderRadiusRightBottom !== undefined ? entity.borderRadiusRightBottom : getEntity.borderRadiusRightBottom,
        width: entity.width !== undefined ? entity.width : getEntity.width,
        height: entity.height !== undefined ? entity.height : getEntity.height,
        hidden: entity.hidden !== undefined ? entity.hidden : getEntity.hidden,
        isOverflowHidden: entity.isOverflowHidden !== undefined ? entity.isOverflowHidden : getEntity.isOverflowHidden,
        vector: entity.vector !== undefined ? entity.vector : getEntity.vector,
        horizontalPosition: entity.horizontalPosition !== undefined ? entity.horizontalPosition : getEntity.horizontalPosition,
        verticalPosition: entity.verticalPosition !== undefined ? entity.verticalPosition : getEntity.verticalPosition,
        gap: entity.gap !== undefined ? entity.gap : getEntity.gap,
        order: entity.order !== undefined ? entity.order : getEntity.order,
        background: entity.background !== undefined ? entity.background : getEntity.background,
        border: entity.border !== undefined ? entity.border : getEntity.border,
        shadow: entity.shadow !== undefined ? entity.shadow : getEntity.shadow,
      })
    }
  })

  data.BoxBackground.BoxBackground1.map(entity => {
    const getEntity = dataStore.BoxBackground1.get(entity.id)
    if (getEntity) {
      dataStore.BoxBackground1.set(entity.id, {
        id: entity.id !== undefined ? entity.id : getEntity.id,
        positionX: entity.positionX !== undefined ? entity.positionX : getEntity.positionX,
        positionY: entity.positionY !== undefined ? entity.positionY : getEntity.positionY,
        width: entity.width !== undefined ? entity.width : getEntity.width,
        height: entity.height !== undefined ? entity.height : getEntity.height,
        verticalPosition: entity.verticalPosition !== undefined ? entity.verticalPosition : getEntity.verticalPosition,
        image: entity.image !== undefined ? entity.image : getEntity.image,
        color: entity.color !== undefined ? entity.color : getEntity.color,
      })
    }
  })

  data.Color.Color1.map(entity => {
    const getEntity = dataStore.Color1.get(entity.id)
    if (getEntity) {
      dataStore.Color1.set(entity.id, {
        id: entity.id !== undefined ? entity.id : getEntity.id,
        name: entity.name !== undefined ? entity.name : getEntity.name,
        viewName: entity.viewName !== undefined ? entity.viewName : getEntity.viewName,
        value: entity.value !== undefined ? entity.value : getEntity.value,
      })
    }
  })

  data.BoxBorder.BoxBorder1.map(entity => {
    const getEntity = dataStore.BoxBorder1.get(entity.id)
    if (getEntity) {
      dataStore.BoxBorder1.set(entity.id, {
        id: entity.id !== undefined ? entity.id : getEntity.id,
        top: entity.top !== undefined ? entity.top : getEntity.top,
        right: entity.right !== undefined ? entity.right : getEntity.right,
        bottom: entity.bottom !== undefined ? entity.bottom : getEntity.bottom,
        left: entity.left !== undefined ? entity.left : getEntity.left,
        color: entity.color !== undefined ? entity.color : getEntity.color,
      })
    }
  })

  data.BoxShadow.BoxShadow1.map(entity => {
    const getEntity = dataStore.BoxShadow1.get(entity.id)
    if (getEntity) {
      dataStore.BoxShadow1.set(entity.id, {
        id: entity.id !== undefined ? entity.id : getEntity.id,
        viewName: entity.viewName !== undefined ? entity.viewName : getEntity.viewName,
        xShift: entity.xShift !== undefined ? entity.xShift : getEntity.xShift,
        yShift: entity.yShift !== undefined ? entity.yShift : getEntity.yShift,
        blur: entity.blur !== undefined ? entity.blur : getEntity.blur,
        spread: entity.spread !== undefined ? entity.spread : getEntity.spread,
        color: entity.color !== undefined ? entity.color : getEntity.color,
      })
    }
  })

  data.LinkV1.Link1.map(entity => {
    const getEntity = dataStore.Link1.get(entity.id)
    if (getEntity) {
      dataStore.Link1.set(entity.id, {
        id: entity.id !== undefined ? entity.id : getEntity.id,
        popupData: entity.popupData !== undefined ? entity.popupData : getEntity.popupData,
        url: entity.url !== undefined ? entity.url : getEntity.url,
        page: entity.page !== undefined ? entity.page : getEntity.page,
        sectionCollection: entity.sectionCollection !== undefined ? entity.sectionCollection : getEntity.sectionCollection,
        section: entity.section !== undefined ? entity.section : getEntity.section,
        popup: entity.popup !== undefined ? entity.popup : getEntity.popup,
      })
    }
  })

  data.TextComponent.TextComponent1.map(entity => {
    const getEntity = dataStore.TextComponent1.get(entity.id)
    if (getEntity) {
      dataStore.TextComponent1.set(entity.id, {
        id: entity.id !== undefined ? entity.id : getEntity.id,
        text: entity.text !== undefined ? entity.text : getEntity.text,
        type: entity.type !== undefined ? entity.type : getEntity.type,
        alignMobileResponsiveMode:
          entity.alignMobileResponsiveMode !== undefined
            ? entity.alignMobileResponsiveMode
            : getEntity.alignMobileResponsiveMode,
        alignTabletResponsiveMode:
          entity.alignTabletResponsiveMode !== undefined
            ? entity.alignTabletResponsiveMode
            : getEntity.alignTabletResponsiveMode,
        alignDesktopResponsiveMode:
          entity.alignDesktopResponsiveMode !== undefined
            ? entity.alignDesktopResponsiveMode
            : getEntity.alignDesktopResponsiveMode,
        alignMobile: entity.alignMobile !== undefined ? entity.alignMobile : getEntity.alignMobile,
        alignTablet: entity.alignTablet !== undefined ? entity.alignTablet : getEntity.alignTablet,
        alignDesktop: entity.alignDesktop !== undefined ? entity.alignDesktop : getEntity.alignDesktop,
        textSettings: entity.textSettings !== undefined ? entity.textSettings : getEntity.textSettings,
      })
    }
  })

  data.TextSettings.TextSettings1.map(entity => {
    const getEntity = dataStore.TextSettings1.get(entity.id)
    if (getEntity) {
      dataStore.TextSettings1.set(entity.id, {
        id: entity.id !== undefined ? entity.id : getEntity.id,
        name: entity.name !== undefined ? entity.name : getEntity.name,
        lib: entity.lib !== undefined ? entity.lib : getEntity.lib,
        siteId: entity.siteId !== undefined ? entity.siteId : getEntity.siteId,
        fontSizeMobileResponsiveMode:
          entity.fontSizeMobileResponsiveMode !== undefined
            ? entity.fontSizeMobileResponsiveMode
            : getEntity.fontSizeMobileResponsiveMode,
        fontSizeTabletResponsiveMode:
          entity.fontSizeTabletResponsiveMode !== undefined
            ? entity.fontSizeTabletResponsiveMode
            : getEntity.fontSizeTabletResponsiveMode,
        fontSizeDesktopResponsiveMode:
          entity.fontSizeDesktopResponsiveMode !== undefined
            ? entity.fontSizeDesktopResponsiveMode
            : getEntity.fontSizeDesktopResponsiveMode,
        fontSizeMobile: entity.fontSizeMobile !== undefined ? entity.fontSizeMobile : getEntity.fontSizeMobile,
        fontSizeTablet: entity.fontSizeTablet !== undefined ? entity.fontSizeTablet : getEntity.fontSizeTablet,
        fontSizeDesktop: entity.fontSizeDesktop !== undefined ? entity.fontSizeDesktop : getEntity.fontSizeDesktop,
        lineHeightMobileResponsiveMode:
          entity.lineHeightMobileResponsiveMode !== undefined
            ? entity.lineHeightMobileResponsiveMode
            : getEntity.lineHeightMobileResponsiveMode,
        lineHeightTabletResponsiveMode:
          entity.lineHeightTabletResponsiveMode !== undefined
            ? entity.lineHeightTabletResponsiveMode
            : getEntity.lineHeightTabletResponsiveMode,
        lineHeightDesktopResponsiveMode:
          entity.lineHeightDesktopResponsiveMode !== undefined
            ? entity.lineHeightDesktopResponsiveMode
            : getEntity.lineHeightDesktopResponsiveMode,
        lineHeightMobile: entity.lineHeightMobile !== undefined ? entity.lineHeightMobile : getEntity.lineHeightMobile,
        lineHeightTablet: entity.lineHeightTablet !== undefined ? entity.lineHeightTablet : getEntity.lineHeightTablet,
        lineHeightDesktop: entity.lineHeightDesktop !== undefined ? entity.lineHeightDesktop : getEntity.lineHeightDesktop,
        fontWeightMobileResponsiveMode:
          entity.fontWeightMobileResponsiveMode !== undefined
            ? entity.fontWeightMobileResponsiveMode
            : getEntity.fontWeightMobileResponsiveMode,
        fontWeightTabletResponsiveMode:
          entity.fontWeightTabletResponsiveMode !== undefined
            ? entity.fontWeightTabletResponsiveMode
            : getEntity.fontWeightTabletResponsiveMode,
        fontWeightDesktopResponsiveMode:
          entity.fontWeightDesktopResponsiveMode !== undefined
            ? entity.fontWeightDesktopResponsiveMode
            : getEntity.fontWeightDesktopResponsiveMode,
        fontWeightMobile: entity.fontWeightMobile !== undefined ? entity.fontWeightMobile : getEntity.fontWeightMobile,
        fontWeightTablet: entity.fontWeightTablet !== undefined ? entity.fontWeightTablet : getEntity.fontWeightTablet,
        fontWeightDesktop: entity.fontWeightDesktop !== undefined ? entity.fontWeightDesktop : getEntity.fontWeightDesktop,
      })
    }
  })

  data.FontWeight.FontWeight1.map(entity => {
    const getEntity = dataStore.FontWeight1.get(entity.id)
    if (getEntity) {
      dataStore.FontWeight1.set(entity.id, {
        id: entity.id !== undefined ? entity.id : getEntity.id,
        previewName: entity.previewName !== undefined ? entity.previewName : getEntity.previewName,
        name: entity.name !== undefined ? entity.name : getEntity.name,
        folder: entity.folder !== undefined ? entity.folder : getEntity.folder,
        size: entity.size !== undefined ? entity.size : getEntity.size,
      })
    }
  })

  data.ImageComponent.ImageComponent1.map(entity => {
    const getEntity = dataStore.ImageComponent1.get(entity.id)
    if (getEntity) {
      dataStore.ImageComponent1.set(entity.id, {
        id: entity.id !== undefined ? entity.id : getEntity.id,
        width: entity.width !== undefined ? entity.width : getEntity.width,
        height: entity.height !== undefined ? entity.height : getEntity.height,
        positionX: entity.positionX !== undefined ? entity.positionX : getEntity.positionX,
        positionY: entity.positionY !== undefined ? entity.positionY : getEntity.positionY,
        shellWidth: entity.shellWidth !== undefined ? entity.shellWidth : getEntity.shellWidth,
        shellHeight: entity.shellHeight !== undefined ? entity.shellHeight : getEntity.shellHeight,
        isCover: entity.isCover !== undefined ? entity.isCover : getEntity.isCover,
        image: entity.image !== undefined ? entity.image : getEntity.image,
      })
    }
  })

  data.FormComponent.FormComponent1.map(entity => {
    const getEntity = dataStore.FormComponent1.get(entity.id)
    if (getEntity) {
      dataStore.FormComponent1.set(entity.id, {
        id: entity.id !== undefined ? entity.id : getEntity.id,
        form: entity.form !== undefined ? entity.form : getEntity.form,
      })
    }
  })

  data.FormV1.Form1.map(entity => {
    const getEntity = dataStore.Form1.get(entity.id)
    if (getEntity) {
      dataStore.Form1.set(entity.id, {
        id: entity.id !== undefined ? entity.id : getEntity.id,
        title: entity.title !== undefined ? entity.title : getEntity.title,
        description: entity.description !== undefined ? entity.description : getEntity.description,
        formButtonText: entity.formButtonText !== undefined ? entity.formButtonText : getEntity.formButtonText,
        name: entity.name !== undefined ? entity.name : getEntity.name,
        extraInputs:
          entity.extraInputs !== undefined
            ? entity.extraInputs?.filter(arrayEntity => {
                const getEntity = dataStore.ExtraInput1.get(arrayEntity.id)
                const getEntityFromServer = data.ExtraInputV1.ExtraInput1.find(
                  serverEntity => serverEntity.id == arrayEntity.id
                )
                if (getEntity || getEntityFromServer) return true
                return false
              })
            : getEntity.extraInputs,
        target: entity.target !== undefined ? entity.target : getEntity.target,
        link: entity.link !== undefined ? entity.link : getEntity.link,
      })
    }
  })

  data.ExtraInputV1.ExtraInput1.map(entity => {
    const getEntity = dataStore.ExtraInput1.get(entity.id)
    if (getEntity) {
      dataStore.ExtraInput1.set(entity.id, {
        id: entity.id !== undefined ? entity.id : getEntity.id,
        order: entity.order !== undefined ? entity.order : getEntity.order,
        placeholder: entity.placeholder !== undefined ? entity.placeholder : getEntity.placeholder,
        bitrixFieldName: entity.bitrixFieldName !== undefined ? entity.bitrixFieldName : getEntity.bitrixFieldName,
        type: entity.type !== undefined ? entity.type : getEntity.type,
        isRequired: entity.isRequired !== undefined ? entity.isRequired : getEntity.isRequired,
      })
    }
  })

  data.QuizComponent.QuizComponent1.map(entity => {
    const getEntity = dataStore.QuizComponent1.get(entity.id)
    if (getEntity) {
      dataStore.QuizComponent1.set(entity.id, {
        id: entity.id !== undefined ? entity.id : getEntity.id,
        quiz: entity.quiz !== undefined ? entity.quiz : getEntity.quiz,
      })
    }
  })

  data.QuizV1.Quiz1.map(entity => {
    const getEntity = dataStore.Quiz1.get(entity.id)
    if (getEntity) {
      dataStore.Quiz1.set(entity.id, {
        id: entity.id !== undefined ? entity.id : getEntity.id,
        name: entity.name !== undefined ? entity.name : getEntity.name,
        title: entity.title !== undefined ? entity.title : getEntity.title,
        description: entity.description !== undefined ? entity.description : getEntity.description,
        form: entity.form !== undefined ? entity.form : getEntity.form,
        steps:
          entity.steps !== undefined
            ? entity.steps?.filter(arrayEntity => {
                const getEntity = dataStore.QuizStep1.get(arrayEntity.id)
                const getEntityFromServer = data.QuizV1StepV1.QuizStep1.find(serverEntity => serverEntity.id == arrayEntity.id)
                if (getEntity || getEntityFromServer) return true
                return false
              })
            : getEntity.steps,
        mainColor: entity.mainColor !== undefined ? entity.mainColor : getEntity.mainColor,
        textColor: entity.textColor !== undefined ? entity.textColor : getEntity.textColor,
        buttonTextColor: entity.buttonTextColor !== undefined ? entity.buttonTextColor : getEntity.buttonTextColor,
      })
    }
  })

  data.QuizV1StepV1.QuizStep1.map(entity => {
    const getEntity = dataStore.QuizStep1.get(entity.id)
    if (getEntity) {
      dataStore.QuizStep1.set(entity.id, {
        id: entity.id !== undefined ? entity.id : getEntity.id,
        order: entity.order !== undefined ? entity.order : getEntity.order,
        isItemWithImage: entity.isItemWithImage !== undefined ? entity.isItemWithImage : getEntity.isItemWithImage,
        checkboxStepsV1: entity.checkboxStepsV1 !== undefined ? entity.checkboxStepsV1 : getEntity.checkboxStepsV1,
        radioStepsV1: entity.radioStepsV1 !== undefined ? entity.radioStepsV1 : getEntity.radioStepsV1,
        fieldInputStep: entity.fieldInputStep !== undefined ? entity.fieldInputStep : getEntity.fieldInputStep,
      })
    }
  })

  data.QuizV1CheckboxStepV1.QuizCheckboxStep1.map(entity => {
    const getEntity = dataStore.QuizCheckboxStep1.get(entity.id)
    if (getEntity) {
      dataStore.QuizCheckboxStep1.set(entity.id, {
        id: entity.id !== undefined ? entity.id : getEntity.id,
        title: entity.title !== undefined ? entity.title : getEntity.title,
        checkboxItemsV1:
          entity.checkboxItemsV1 !== undefined
            ? entity.checkboxItemsV1?.filter(arrayEntity => {
                const getEntity = dataStore.QuizCheckboxStepItem1.get(arrayEntity.id)
                const getEntityFromServer = data.QuizV1CheckboxItemV1.QuizCheckboxStepItem1.find(
                  serverEntity => serverEntity.id == arrayEntity.id
                )
                if (getEntity || getEntityFromServer) return true
                return false
              })
            : getEntity.checkboxItemsV1,
      })
    }
  })

  data.QuizV1CheckboxItemV1.QuizCheckboxStepItem1.map(entity => {
    const getEntity = dataStore.QuizCheckboxStepItem1.get(entity.id)
    if (getEntity) {
      dataStore.QuizCheckboxStepItem1.set(entity.id, {
        id: entity.id !== undefined ? entity.id : getEntity.id,
        order: entity.order !== undefined ? entity.order : getEntity.order,
        title: entity.title !== undefined ? entity.title : getEntity.title,
        target: entity.target !== undefined ? entity.target : getEntity.target,
        image: entity.image !== undefined ? entity.image : getEntity.image,
      })
    }
  })

  data.QuizV1RadioStepV1.QuizRadioStep1.map(entity => {
    const getEntity = dataStore.QuizRadioStep1.get(entity.id)
    if (getEntity) {
      dataStore.QuizRadioStep1.set(entity.id, {
        id: entity.id !== undefined ? entity.id : getEntity.id,
        title: entity.title !== undefined ? entity.title : getEntity.title,
        radioItemsV1:
          entity.radioItemsV1 !== undefined
            ? entity.radioItemsV1?.filter(arrayEntity => {
                const getEntity = dataStore.QuizRadioStepItem1.get(arrayEntity.id)
                const getEntityFromServer = data.QuizV1RadioItemV1.QuizRadioStepItem1.find(
                  serverEntity => serverEntity.id == arrayEntity.id
                )
                if (getEntity || getEntityFromServer) return true
                return false
              })
            : getEntity.radioItemsV1,
      })
    }
  })

  data.QuizV1RadioItemV1.QuizRadioStepItem1.map(entity => {
    const getEntity = dataStore.QuizRadioStepItem1.get(entity.id)
    if (getEntity) {
      dataStore.QuizRadioStepItem1.set(entity.id, {
        id: entity.id !== undefined ? entity.id : getEntity.id,
        order: entity.order !== undefined ? entity.order : getEntity.order,
        title: entity.title !== undefined ? entity.title : getEntity.title,
        target: entity.target !== undefined ? entity.target : getEntity.target,
        image: entity.image !== undefined ? entity.image : getEntity.image,
      })
    }
  })

  data.QuizV1FieldInputStepV1.QuizFieldInputStep1.map(entity => {
    const getEntity = dataStore.QuizFieldInputStep1.get(entity.id)
    if (getEntity) {
      dataStore.QuizFieldInputStep1.set(entity.id, {
        id: entity.id !== undefined ? entity.id : getEntity.id,
        title: entity.title !== undefined ? entity.title : getEntity.title,
        placeholder: entity.placeholder !== undefined ? entity.placeholder : getEntity.placeholder,
      })
    }
  })

  data.VideoComponent.VideoComponent1.map(entity => {
    const getEntity = dataStore.VideoComponent1.get(entity.id)
    if (getEntity) {
      dataStore.VideoComponent1.set(entity.id, {
        id: entity.id !== undefined ? entity.id : getEntity.id,
        videoURL: entity.videoURL !== undefined ? entity.videoURL : getEntity.videoURL,
      })
    }
  })

  data.FaqComponent.FaqComponent1.map(entity => {
    const getEntity = dataStore.FaqComponent1.get(entity.id)
    if (getEntity) {
      dataStore.FaqComponent1.set(entity.id, {
        id: entity.id !== undefined ? entity.id : getEntity.id,
        faqItems:
          entity.faqItems !== undefined
            ? entity.faqItems?.filter(arrayEntity => {
                const getEntity = dataStore.FaqComponentItem1.get(arrayEntity.id)
                const getEntityFromServer = data.FaqComponentItem.FaqComponentItem1.find(
                  serverEntity => serverEntity.id == arrayEntity.id
                )
                if (getEntity || getEntityFromServer) return true
                return false
              })
            : getEntity.faqItems,
      })
    }
  })

  data.FaqComponentItem.FaqComponentItem1.map(entity => {
    const getEntity = dataStore.FaqComponentItem1.get(entity.id)
    if (getEntity) {
      dataStore.FaqComponentItem1.set(entity.id, {
        id: entity.id !== undefined ? entity.id : getEntity.id,
        order: entity.order !== undefined ? entity.order : getEntity.order,
        question: entity.question !== undefined ? entity.question : getEntity.question,
        answer: entity.answer !== undefined ? entity.answer : getEntity.answer,
      })
    }
  })

  data.MapComponent.MapComponent1.map(entity => {
    const getEntity = dataStore.MapComponent1.get(entity.id)
    if (getEntity) {
      dataStore.MapComponent1.set(entity.id, {
        id: entity.id !== undefined ? entity.id : getEntity.id,
        zoomFloat: entity.zoomFloat !== undefined ? entity.zoomFloat : getEntity.zoomFloat,
        centerLat: entity.centerLat !== undefined ? entity.centerLat : getEntity.centerLat,
        centerLng: entity.centerLng !== undefined ? entity.centerLng : getEntity.centerLng,
        points:
          entity.points !== undefined
            ? entity.points?.filter(arrayEntity => {
                const getEntity = dataStore.MapComponentPoint1.get(arrayEntity.id)
                const getEntityFromServer = data.MapComponentPoint.MapComponentPoint1.find(
                  serverEntity => serverEntity.id == arrayEntity.id
                )
                if (getEntity || getEntityFromServer) return true
                return false
              })
            : getEntity.points,
      })
    }
  })

  data.MapComponentPoint.MapComponentPoint1.map(entity => {
    const getEntity = dataStore.MapComponentPoint1.get(entity.id)
    if (getEntity) {
      dataStore.MapComponentPoint1.set(entity.id, {
        id: entity.id !== undefined ? entity.id : getEntity.id,
        lat: entity.lat !== undefined ? entity.lat : getEntity.lat,
        lng: entity.lng !== undefined ? entity.lng : getEntity.lng,
      })
    }
  })

  data.CodeComponent.CodeComponent1.map(entity => {
    const getEntity = dataStore.CodeComponent1.get(entity.id)
    if (getEntity) {
      dataStore.CodeComponent1.set(entity.id, {
        id: entity.id !== undefined ? entity.id : getEntity.id,
        code: entity.code !== undefined ? entity.code : getEntity.code,
      })
    }
  })

  data.WBotComponent.WhatsAppBotComponent1.map(entity => {
    const getEntity = dataStore.WhatsAppBotComponent1.get(entity.id)
    if (getEntity) {
      dataStore.WhatsAppBotComponent1.set(entity.id, {
        id: entity.id !== undefined ? entity.id : getEntity.id,
        link: entity.link !== undefined ? entity.link : getEntity.link,
      })
    }
  })

  data.WhatsAppBotLink.WhatsAppBotLink1.map(entity => {
    const getEntity = dataStore.WhatsAppBotLink1.get(entity.id)
    if (getEntity) {
      dataStore.WhatsAppBotLink1.set(entity.id, {
        id: entity.id !== undefined ? entity.id : getEntity.id,
        text: entity.text !== undefined ? entity.text : getEntity.text,
        target: entity.target !== undefined ? entity.target : getEntity.target,
      })
    }
  })

  data.TableColumn.TableColumnSimple.map(entity => {
    const getEntity = dataStore.TableColumnSimple.get(entity.id)
    if (getEntity) {
      dataStore.TableColumnSimple.set(entity.id, {
        id: entity.id !== undefined ? entity.id : getEntity.id,
        name: entity.name !== undefined ? entity.name : getEntity.name,
        order: entity.order !== undefined ? entity.order : getEntity.order,
        width: entity.width !== undefined ? entity.width : getEntity.width,
        type: entity.type !== undefined ? entity.type : getEntity.type,
      })
    }
  })
  data.TableColumn.TableColumnAtBoxAtSchema.map(entity => {
    const getEntity = dataStore.TableColumnAtBoxAtSchema.get(entity.id)
    if (getEntity) {
      dataStore.TableColumnAtBoxAtSchema.set(entity.id, {
        id: entity.id !== undefined ? entity.id : getEntity.id,
        name: entity.name !== undefined ? entity.name : getEntity.name,
        order: entity.order !== undefined ? entity.order : getEntity.order,
        width: entity.width !== undefined ? entity.width : getEntity.width,
        type: entity.type !== undefined ? entity.type : getEntity.type,
        columnTableSchema: entity.columnTableSchema !== undefined ? entity.columnTableSchema : getEntity.columnTableSchema,
      })
    }
  })
  data.TableColumn.TableColumnAtBox.map(entity => {
    const getEntity = dataStore.TableColumnAtBox.get(entity.id)
    if (getEntity) {
      dataStore.TableColumnAtBox.set(entity.id, {
        id: entity.id !== undefined ? entity.id : getEntity.id,
        motherTableID: entity.motherTableID !== undefined ? entity.motherTableID : getEntity.motherTableID,
        name: entity.name !== undefined ? entity.name : getEntity.name,
        type: entity.type !== undefined ? entity.type : getEntity.type,
      })
    }
  })
  data.TableColumn.TableColumn1.map(entity => {
    const getEntity = dataStore.TableColumn1.get(entity.id)
    if (getEntity) {
      dataStore.TableColumn1.set(entity.id, {
        id: entity.id !== undefined ? entity.id : getEntity.id,
        name: entity.name !== undefined ? entity.name : getEntity.name,
        order: entity.order !== undefined ? entity.order : getEntity.order,
        width: entity.width !== undefined ? entity.width : getEntity.width,
        type: entity.type !== undefined ? entity.type : getEntity.type,
        columnTableSchema: entity.columnTableSchema !== undefined ? entity.columnTableSchema : getEntity.columnTableSchema,
      })
    }
  })

  data.Table.TableAtBox.map(entity => {
    const getEntity = dataStore.TableAtBox.get(entity.id)
    if (getEntity) {
      dataStore.TableAtBox.set(entity.id, {
        id: entity.id !== undefined ? entity.id : getEntity.id,
        name: entity.name !== undefined ? entity.name : getEntity.name,
        colums:
          entity.colums !== undefined
            ? entity.colums?.filter(arrayEntity => {
                const getEntity = dataStore.TableColumnAtBoxAtSchema.get(arrayEntity.id)
                const getEntityFromServer = data.TableColumn.TableColumnAtBoxAtSchema.find(
                  serverEntity => serverEntity.id == arrayEntity.id
                )
                if (getEntity || getEntityFromServer) return true
                return false
              })
            : getEntity.colums,
        connector: entity.connector !== undefined ? entity.connector : getEntity.connector,
        pinnedTableData:
          entity.pinnedTableData !== undefined
            ? entity.pinnedTableData?.filter(arrayEntity => {
                const getEntity = dataStore.TableDataPinnedToPage.get(arrayEntity.id)
                const getEntityFromServer = data.TableData.TableDataPinnedToPage.find(
                  serverEntity => serverEntity.id == arrayEntity.id
                )
                if (getEntity || getEntityFromServer) return true
                return false
              })
            : getEntity.pinnedTableData,
      })
    }
  })
  data.Table.TableWithID.map(entity => {
    const getEntity = dataStore.TableWithID.get(entity.id)
    if (getEntity) {
      dataStore.TableWithID.set(entity.id, {
        id: entity.id !== undefined ? entity.id : getEntity.id,
      })
    }
  })
  data.Table.Table1.map(entity => {
    const getEntity = dataStore.Table1.get(entity.id)
    if (getEntity) {
      dataStore.Table1.set(entity.id, {
        id: entity.id !== undefined ? entity.id : getEntity.id,
        name: entity.name !== undefined ? entity.name : getEntity.name,
        colums:
          entity.colums !== undefined
            ? entity.colums?.filter(arrayEntity => {
                const getEntity = dataStore.TableColumn1.get(arrayEntity.id)
                const getEntityFromServer = data.TableColumn.TableColumn1.find(
                  serverEntity => serverEntity.id == arrayEntity.id
                )
                if (getEntity || getEntityFromServer) return true
                return false
              })
            : getEntity.colums,
        columnTableTypeSchema:
          entity.columnTableTypeSchema !== undefined ? entity.columnTableTypeSchema : getEntity.columnTableTypeSchema,
      })
    }
  })

  data.TableConnector.TableConnectorAtBox.map(entity => {
    const getEntity = dataStore.TableConnectorAtBox.get(entity.id)
    if (getEntity) {
      dataStore.TableConnectorAtBox.set(entity.id, {
        id: entity.id !== undefined ? entity.id : getEntity.id,
        tableData: entity.tableData !== undefined ? entity.tableData : getEntity.tableData,
      })
    }
  })
  data.TableConnector.TableConnectorWithID.map(entity => {
    const getEntity = dataStore.TableConnectorWithID.get(entity.id)
    if (getEntity) {
      dataStore.TableConnectorWithID.set(entity.id, {
        id: entity.id !== undefined ? entity.id : getEntity.id,
      })
    }
  })
  data.TableConnector.TableConnector1.map(entity => {
    const getEntity = dataStore.TableConnector1.get(entity.id)
    if (getEntity) {
      dataStore.TableConnector1.set(entity.id, {
        id: entity.id !== undefined ? entity.id : getEntity.id,
        tableSchema: entity.tableSchema !== undefined ? entity.tableSchema : getEntity.tableSchema,
        tableData: entity.tableData !== undefined ? entity.tableData : getEntity.tableData,
      })
    }
  })

  data.TableData.TableDataAtBox.map(entity => {
    const getEntity = dataStore.TableDataAtBox.get(entity.id)
    if (getEntity) {
      dataStore.TableDataAtBox.set(entity.id, {
        id: entity.id !== undefined ? entity.id : getEntity.id,
        rows:
          entity.rows !== undefined
            ? entity.rows?.filter(arrayEntity => {
                const getEntity = dataStore.TableRowAtBox.get(arrayEntity.id)
                const getEntityFromServer = data.TableRow.TableRowAtBox.find(serverEntity => serverEntity.id == arrayEntity.id)
                if (getEntity || getEntityFromServer) return true
                return false
              })
            : getEntity.rows,
      })
    }
  })
  data.TableData.TableDataPinnedToPage.map(entity => {
    const getEntity = dataStore.TableDataPinnedToPage.get(entity.id)
    if (getEntity) {
      dataStore.TableDataPinnedToPage.set(entity.id, {
        id: entity.id !== undefined ? entity.id : getEntity.id,
        connector: entity.connector !== undefined ? entity.connector : getEntity.connector,
        rows:
          entity.rows !== undefined
            ? entity.rows?.filter(arrayEntity => {
                const getEntity = dataStore.TableDataRowPinnedToPage.get(arrayEntity.id)
                const getEntityFromServer = data.TableRow.TableDataRowPinnedToPage.find(
                  serverEntity => serverEntity.id == arrayEntity.id
                )
                if (getEntity || getEntityFromServer) return true
                return false
              })
            : getEntity.rows,
        pinnedToTable: entity.pinnedToTable !== undefined ? entity.pinnedToTable : getEntity.pinnedToTable,
      })
    }
  })
  data.TableData.TableData1.map(entity => {
    const getEntity = dataStore.TableData1.get(entity.id)
    if (getEntity) {
      dataStore.TableData1.set(entity.id, {
        id: entity.id !== undefined ? entity.id : getEntity.id,
        rows:
          entity.rows !== undefined
            ? entity.rows?.filter(arrayEntity => {
                const getEntity = dataStore.TableDataRow1.get(arrayEntity.id)
                const getEntityFromServer = data.TableRow.TableDataRow1.find(serverEntity => serverEntity.id == arrayEntity.id)
                if (getEntity || getEntityFromServer) return true
                return false
              })
            : getEntity.rows,
      })
    }
  })

  data.TableRow.TableRowAtBox.map(entity => {
    const getEntity = dataStore.TableRowAtBox.get(entity.id)
    if (getEntity) {
      dataStore.TableRowAtBox.set(entity.id, {
        id: entity.id !== undefined ? entity.id : getEntity.id,
        slug: entity.slug !== undefined ? entity.slug : getEntity.slug,
        items:
          entity.items !== undefined
            ? entity.items?.filter(arrayEntity => {
                const getEntity = dataStore.TableRowItemAtBox.get(arrayEntity.id)
                const getEntityFromServer = data.TableRowItem.TableRowItemAtBox.find(
                  serverEntity => serverEntity.id == arrayEntity.id
                )
                if (getEntity || getEntityFromServer) return true
                return false
              })
            : getEntity.items,
      })
    }
  })
  data.TableRow.TableDataRowPinnedToPage.map(entity => {
    const getEntity = dataStore.TableDataRowPinnedToPage.get(entity.id)
    if (getEntity) {
      dataStore.TableDataRowPinnedToPage.set(entity.id, {
        id: entity.id !== undefined ? entity.id : getEntity.id,
        slug: entity.slug !== undefined ? entity.slug : getEntity.slug,
      })
    }
  })
  data.TableRow.TableDataRow1.map(entity => {
    const getEntity = dataStore.TableDataRow1.get(entity.id)
    if (getEntity) {
      dataStore.TableDataRow1.set(entity.id, {
        id: entity.id !== undefined ? entity.id : getEntity.id,
        slug: entity.slug !== undefined ? entity.slug : getEntity.slug,
        items:
          entity.items !== undefined
            ? entity.items?.filter(arrayEntity => {
                const getEntity = dataStore.TableDataRowItem1.get(arrayEntity.id)
                const getEntityFromServer = data.TableRowItem.TableDataRowItem1.find(
                  serverEntity => serverEntity.id == arrayEntity.id
                )
                if (getEntity || getEntityFromServer) return true
                return false
              })
            : getEntity.items,
      })
    }
  })

  data.TableRowItem.TableRowItemAtBox.map(entity => {
    const getEntity = dataStore.TableRowItemAtBox.get(entity.id)
    if (getEntity) {
      dataStore.TableRowItemAtBox.set(entity.id, {
        id: entity.id !== undefined ? entity.id : getEntity.id,
        text: entity.text !== undefined ? entity.text : getEntity.text,
        number: entity.number !== undefined ? entity.number : getEntity.number,
        tableColumnID: entity.tableColumnID !== undefined ? entity.tableColumnID : getEntity.tableColumnID,
        image: entity.image !== undefined ? entity.image : getEntity.image,
        tableData: entity.tableData !== undefined ? entity.tableData : getEntity.tableData,
        tableColumn: entity.tableColumn !== undefined ? entity.tableColumn : getEntity.tableColumn,
      })
    }
  })
  data.TableRowItem.TableDataRowItem1.map(entity => {
    const getEntity = dataStore.TableDataRowItem1.get(entity.id)
    if (getEntity) {
      dataStore.TableDataRowItem1.set(entity.id, {
        id: entity.id !== undefined ? entity.id : getEntity.id,
        text: entity.text !== undefined ? entity.text : getEntity.text,
        number: entity.number !== undefined ? entity.number : getEntity.number,
        tableColumnID: entity.tableColumnID !== undefined ? entity.tableColumnID : getEntity.tableColumnID,
        image: entity.image !== undefined ? entity.image : getEntity.image,
        tableData: entity.tableData !== undefined ? entity.tableData : getEntity.tableData,
        tableColumn: entity.tableColumn !== undefined ? entity.tableColumn : getEntity.tableColumn,
      })
    }
  })

  data.BlockCategory.BlockCategory1.map(entity => {
    const getEntity = dataStore.BlockCategory1.get(entity.id)
    if (getEntity) {
      dataStore.BlockCategory1.set(entity.id, {
        id: entity.id !== undefined ? entity.id : getEntity.id,
        name: entity.name !== undefined ? entity.name : getEntity.name,
      })
    }
  })

  data.LeadV1.Lead1.map(entity => {
    const getEntity = dataStore.Lead1.get(entity.id)
    if (getEntity) {
      dataStore.Lead1.set(entity.id, {
        id: entity.id !== undefined ? entity.id : getEntity.id,
        createdAt: entity.createdAt !== undefined ? entity.createdAt : getEntity.createdAt,
        information: entity.information !== undefined ? entity.information : getEntity.information,
        AmazonEmailMessageId:
          entity.AmazonEmailMessageId !== undefined ? entity.AmazonEmailMessageId : getEntity.AmazonEmailMessageId,
      })
    }
  })

  data.GroupFont.GroupFont1.map(entity => {
    const getEntity = dataStore.GroupFont1.get(entity.id)
    if (getEntity) {
      dataStore.GroupFont1.set(entity.id, {
        id: entity.id !== undefined ? entity.id : getEntity.id,
        name: entity.name !== undefined ? entity.name : getEntity.name,
        weight:
          entity.weight !== undefined
            ? entity.weight?.filter(arrayEntity => {
                const getEntity = dataStore.FontWeight1.get(arrayEntity.id)
                const getEntityFromServer = data.FontWeight.FontWeight1.find(serverEntity => serverEntity.id == arrayEntity.id)
                if (getEntity || getEntityFromServer) return true
                return false
              })
            : getEntity.weight,
      })
    }
  })

  data.WhatsAppBot.WhatsAppBot1.map(entity => {
    const getEntity = dataStore.WhatsAppBot1.get(entity.id)
    if (getEntity) {
      dataStore.WhatsAppBot1.set(entity.id, {
        id: entity.id !== undefined ? entity.id : getEntity.id,
        phone: entity.phone !== undefined ? entity.phone : getEntity.phone,
        qrCode: entity.qrCode !== undefined ? entity.qrCode : getEntity.qrCode,
        connected: entity.connected !== undefined ? entity.connected : getEntity.connected,
        links:
          entity.links !== undefined
            ? entity.links?.filter(arrayEntity => {
                const getEntity = dataStore.WhatsAppBotLink1.get(arrayEntity.id)
                const getEntityFromServer = data.WhatsAppBotLink.WhatsAppBotLink1.find(
                  serverEntity => serverEntity.id == arrayEntity.id
                )
                if (getEntity || getEntityFromServer) return true
                return false
              })
            : getEntity.links,
      })
    }
  })
}

export function getDataBasedOnUniqueSelectAtSite<SelectID extends keyof ForGetDataBySelectID>({
  selectID,
  modelID,
}: {
  selectID?: SelectID
  modelID?: string
}) {
  const id = useId()

  const getData = () => {
    if (!selectID || !modelID) return undefined
    switch (selectID) {
      case 'Site1': {
        const value = dataStore.Site1.get(modelID)
        if (typeof value == 'undefined') return undefined // throw new Error("Site1 not found")
        return value as ForGetDataBySelectID[SelectID]
      }

      case 'UserSelect1': {
        const value = dataStore.UserSelect1.get(modelID)
        if (typeof value == 'undefined') return undefined // throw new Error("UserSelect1 not found")
        return value as ForGetDataBySelectID[SelectID]
      }

      case 'TelegramChannel1': {
        const value = dataStore.TelegramChannel1.get(modelID)
        if (typeof value == 'undefined') return undefined // throw new Error("TelegramChannel1 not found")
        return value as ForGetDataBySelectID[SelectID]
      }

      case 'TelegramGift1': {
        const value = dataStore.TelegramGift1.get(modelID)
        if (typeof value == 'undefined') return undefined // throw new Error("TelegramGift1 not found")
        return value as ForGetDataBySelectID[SelectID]
      }

      case 'Image1': {
        const value = dataStore.Image1.get(modelID)
        if (typeof value == 'undefined') return undefined // throw new Error("Image1 not found")
        return value as ForGetDataBySelectID[SelectID]
      }

      case 'PageOnlyWithFields': {
        const value = dataStore.PageOnlyWithFields.get(modelID)
        if (typeof value == 'undefined') return undefined // throw new Error("PageOnlyWithFields not found")
        return value as ForGetDataBySelectID[SelectID]
      }
      case 'Page1': {
        const value = dataStore.Page1.get(modelID)
        if (typeof value == 'undefined') return undefined // throw new Error("Page1 not found")
        return value as ForGetDataBySelectID[SelectID]
      }
      case 'PageForLink': {
        const value = dataStore.PageForLink.get(modelID)
        if (typeof value == 'undefined') return undefined // throw new Error("PageForLink not found")
        return value as ForGetDataBySelectID[SelectID]
      }

      case 'Target1': {
        const value = dataStore.Target1.get(modelID)
        if (typeof value == 'undefined') return undefined // throw new Error("Target1 not found")
        return value as ForGetDataBySelectID[SelectID]
      }

      case 'TelegramPersonalBot1': {
        const value = dataStore.TelegramPersonalBot1.get(modelID)
        if (typeof value == 'undefined') return undefined // throw new Error("TelegramPersonalBot1 not found")
        return value as ForGetDataBySelectID[SelectID]
      }

      case 'PaidPlace1': {
        const value = dataStore.PaidPlace1.get(modelID)
        if (typeof value == 'undefined') return undefined // throw new Error("PaidPlace1 not found")
        return value as ForGetDataBySelectID[SelectID]
      }

      case 'PaidPlaceOutcomeBalance1': {
        const value = dataStore.PaidPlaceOutcomeBalance1.get(modelID)
        if (typeof value == 'undefined') return undefined // throw new Error("PaidPlaceOutcomeBalance1 not found")
        return value as ForGetDataBySelectID[SelectID]
      }

      case 'TelegramUser1': {
        const value = dataStore.TelegramUser1.get(modelID)
        if (typeof value == 'undefined') return undefined // throw new Error("TelegramUser1 not found")
        return value as ForGetDataBySelectID[SelectID]
      }

      case 'Domain1': {
        const value = dataStore.Domain1.get(modelID)
        if (typeof value == 'undefined') return undefined // throw new Error("Domain1 not found")
        return value as ForGetDataBySelectID[SelectID]
      }

      case 'SectionsPinned1': {
        const value = dataStore.SectionsPinned1.get(modelID)
        if (typeof value == 'undefined') return undefined // throw new Error("SectionsPinned1 not found")
        return value as ForGetDataBySelectID[SelectID]
      }
      case 'SectionsPinnedID': {
        const value = dataStore.SectionsPinnedID.get(modelID)
        if (typeof value == 'undefined') return undefined // throw new Error("SectionsPinnedID not found")
        return value as ForGetDataBySelectID[SelectID]
      }

      case 'Sections1': {
        const value = dataStore.Sections1.get(modelID)
        if (typeof value == 'undefined') return undefined // throw new Error("Sections1 not found")
        return value as ForGetDataBySelectID[SelectID]
      }

      case 'Section1': {
        const value = dataStore.Section1.get(modelID)
        if (typeof value == 'undefined') return undefined // throw new Error("Section1 not found")
        return value as ForGetDataBySelectID[SelectID]
      }
      case 'SectionID': {
        const value = dataStore.SectionID.get(modelID)
        if (typeof value == 'undefined') return undefined // throw new Error("SectionID not found")
        return value as ForGetDataBySelectID[SelectID]
      }

      case 'PopupWithName': {
        const value = dataStore.PopupWithName.get(modelID)
        if (typeof value == 'undefined') return undefined // throw new Error("PopupWithName not found")
        return value as ForGetDataBySelectID[SelectID]
      }
      case 'PopupID': {
        const value = dataStore.PopupID.get(modelID)
        if (typeof value == 'undefined') return undefined // throw new Error("PopupID not found")
        return value as ForGetDataBySelectID[SelectID]
      }
      case 'Popup1': {
        const value = dataStore.Popup1.get(modelID)
        if (typeof value == 'undefined') return undefined // throw new Error("Popup1 not found")
        return value as ForGetDataBySelectID[SelectID]
      }

      case 'BoxBlock1': {
        const value = dataStore.BoxBlock1.get(modelID)
        if (typeof value == 'undefined') return undefined // throw new Error("BoxBlock1 not found")
        return value as ForGetDataBySelectID[SelectID]
      }

      case 'Box1': {
        const value = dataStore.Box1.get(modelID)
        if (typeof value == 'undefined') return undefined // throw new Error("Box1 not found")
        return value as ForGetDataBySelectID[SelectID]
      }

      case 'ResponsiveBoxSetting1': {
        const value = dataStore.ResponsiveBoxSetting1.get(modelID)
        if (typeof value == 'undefined') return undefined // throw new Error("ResponsiveBoxSetting1 not found")
        return value as ForGetDataBySelectID[SelectID]
      }

      case 'BoxSetting1': {
        const value = dataStore.BoxSetting1.get(modelID)
        if (typeof value == 'undefined') return undefined // throw new Error("BoxSetting1 not found")
        return value as ForGetDataBySelectID[SelectID]
      }

      case 'BoxBackground1': {
        const value = dataStore.BoxBackground1.get(modelID)
        if (typeof value == 'undefined') return undefined // throw new Error("BoxBackground1 not found")
        return value as ForGetDataBySelectID[SelectID]
      }

      case 'Color1': {
        const value = dataStore.Color1.get(modelID)
        if (typeof value == 'undefined') return undefined // throw new Error("Color1 not found")
        return value as ForGetDataBySelectID[SelectID]
      }

      case 'BoxBorder1': {
        const value = dataStore.BoxBorder1.get(modelID)
        if (typeof value == 'undefined') return undefined // throw new Error("BoxBorder1 not found")
        return value as ForGetDataBySelectID[SelectID]
      }

      case 'BoxShadow1': {
        const value = dataStore.BoxShadow1.get(modelID)
        if (typeof value == 'undefined') return undefined // throw new Error("BoxShadow1 not found")
        return value as ForGetDataBySelectID[SelectID]
      }

      case 'Link1': {
        const value = dataStore.Link1.get(modelID)
        if (typeof value == 'undefined') return undefined // throw new Error("Link1 not found")
        return value as ForGetDataBySelectID[SelectID]
      }

      case 'TextComponent1': {
        const value = dataStore.TextComponent1.get(modelID)
        if (typeof value == 'undefined') return undefined // throw new Error("TextComponent1 not found")
        return value as ForGetDataBySelectID[SelectID]
      }

      case 'TextSettings1': {
        const value = dataStore.TextSettings1.get(modelID)
        if (typeof value == 'undefined') return undefined // throw new Error("TextSettings1 not found")
        return value as ForGetDataBySelectID[SelectID]
      }

      case 'FontWeight1': {
        const value = dataStore.FontWeight1.get(modelID)
        if (typeof value == 'undefined') return undefined // throw new Error("FontWeight1 not found")
        return value as ForGetDataBySelectID[SelectID]
      }

      case 'ImageComponent1': {
        const value = dataStore.ImageComponent1.get(modelID)
        if (typeof value == 'undefined') return undefined // throw new Error("ImageComponent1 not found")
        return value as ForGetDataBySelectID[SelectID]
      }

      case 'FormComponent1': {
        const value = dataStore.FormComponent1.get(modelID)
        if (typeof value == 'undefined') return undefined // throw new Error("FormComponent1 not found")
        return value as ForGetDataBySelectID[SelectID]
      }

      case 'Form1': {
        const value = dataStore.Form1.get(modelID)
        if (typeof value == 'undefined') return undefined // throw new Error("Form1 not found")
        return value as ForGetDataBySelectID[SelectID]
      }

      case 'ExtraInput1': {
        const value = dataStore.ExtraInput1.get(modelID)
        if (typeof value == 'undefined') return undefined // throw new Error("ExtraInput1 not found")
        return value as ForGetDataBySelectID[SelectID]
      }

      case 'QuizComponent1': {
        const value = dataStore.QuizComponent1.get(modelID)
        if (typeof value == 'undefined') return undefined // throw new Error("QuizComponent1 not found")
        return value as ForGetDataBySelectID[SelectID]
      }

      case 'Quiz1': {
        const value = dataStore.Quiz1.get(modelID)
        if (typeof value == 'undefined') return undefined // throw new Error("Quiz1 not found")
        return value as ForGetDataBySelectID[SelectID]
      }

      case 'QuizStep1': {
        const value = dataStore.QuizStep1.get(modelID)
        if (typeof value == 'undefined') return undefined // throw new Error("QuizStep1 not found")
        return value as ForGetDataBySelectID[SelectID]
      }

      case 'QuizCheckboxStep1': {
        const value = dataStore.QuizCheckboxStep1.get(modelID)
        if (typeof value == 'undefined') return undefined // throw new Error("QuizCheckboxStep1 not found")
        return value as ForGetDataBySelectID[SelectID]
      }

      case 'QuizCheckboxStepItem1': {
        const value = dataStore.QuizCheckboxStepItem1.get(modelID)
        if (typeof value == 'undefined') return undefined // throw new Error("QuizCheckboxStepItem1 not found")
        return value as ForGetDataBySelectID[SelectID]
      }

      case 'QuizRadioStep1': {
        const value = dataStore.QuizRadioStep1.get(modelID)
        if (typeof value == 'undefined') return undefined // throw new Error("QuizRadioStep1 not found")
        return value as ForGetDataBySelectID[SelectID]
      }

      case 'QuizRadioStepItem1': {
        const value = dataStore.QuizRadioStepItem1.get(modelID)
        if (typeof value == 'undefined') return undefined // throw new Error("QuizRadioStepItem1 not found")
        return value as ForGetDataBySelectID[SelectID]
      }

      case 'QuizFieldInputStep1': {
        const value = dataStore.QuizFieldInputStep1.get(modelID)
        if (typeof value == 'undefined') return undefined // throw new Error("QuizFieldInputStep1 not found")
        return value as ForGetDataBySelectID[SelectID]
      }

      case 'VideoComponent1': {
        const value = dataStore.VideoComponent1.get(modelID)
        if (typeof value == 'undefined') return undefined // throw new Error("VideoComponent1 not found")
        return value as ForGetDataBySelectID[SelectID]
      }

      case 'FaqComponent1': {
        const value = dataStore.FaqComponent1.get(modelID)
        if (typeof value == 'undefined') return undefined // throw new Error("FaqComponent1 not found")
        return value as ForGetDataBySelectID[SelectID]
      }

      case 'FaqComponentItem1': {
        const value = dataStore.FaqComponentItem1.get(modelID)
        if (typeof value == 'undefined') return undefined // throw new Error("FaqComponentItem1 not found")
        return value as ForGetDataBySelectID[SelectID]
      }

      case 'MapComponent1': {
        const value = dataStore.MapComponent1.get(modelID)
        if (typeof value == 'undefined') return undefined // throw new Error("MapComponent1 not found")
        return value as ForGetDataBySelectID[SelectID]
      }

      case 'MapComponentPoint1': {
        const value = dataStore.MapComponentPoint1.get(modelID)
        if (typeof value == 'undefined') return undefined // throw new Error("MapComponentPoint1 not found")
        return value as ForGetDataBySelectID[SelectID]
      }

      case 'CodeComponent1': {
        const value = dataStore.CodeComponent1.get(modelID)
        if (typeof value == 'undefined') return undefined // throw new Error("CodeComponent1 not found")
        return value as ForGetDataBySelectID[SelectID]
      }

      case 'WhatsAppBotComponent1': {
        const value = dataStore.WhatsAppBotComponent1.get(modelID)
        if (typeof value == 'undefined') return undefined // throw new Error("WhatsAppBotComponent1 not found")
        return value as ForGetDataBySelectID[SelectID]
      }

      case 'WhatsAppBotLink1': {
        const value = dataStore.WhatsAppBotLink1.get(modelID)
        if (typeof value == 'undefined') return undefined // throw new Error("WhatsAppBotLink1 not found")
        return value as ForGetDataBySelectID[SelectID]
      }

      case 'TableColumnSimple': {
        const value = dataStore.TableColumnSimple.get(modelID)
        if (typeof value == 'undefined') return undefined // throw new Error("TableColumnSimple not found")
        return value as ForGetDataBySelectID[SelectID]
      }
      case 'TableColumnAtBoxAtSchema': {
        const value = dataStore.TableColumnAtBoxAtSchema.get(modelID)
        if (typeof value == 'undefined') return undefined // throw new Error("TableColumnAtBoxAtSchema not found")
        return value as ForGetDataBySelectID[SelectID]
      }
      case 'TableColumnAtBox': {
        const value = dataStore.TableColumnAtBox.get(modelID)
        if (typeof value == 'undefined') return undefined // throw new Error("TableColumnAtBox not found")
        return value as ForGetDataBySelectID[SelectID]
      }
      case 'TableColumn1': {
        const value = dataStore.TableColumn1.get(modelID)
        if (typeof value == 'undefined') return undefined // throw new Error("TableColumn1 not found")
        return value as ForGetDataBySelectID[SelectID]
      }

      case 'TableAtBox': {
        const value = dataStore.TableAtBox.get(modelID)
        if (typeof value == 'undefined') return undefined // throw new Error("TableAtBox not found")
        return value as ForGetDataBySelectID[SelectID]
      }
      case 'TableWithID': {
        const value = dataStore.TableWithID.get(modelID)
        if (typeof value == 'undefined') return undefined // throw new Error("TableWithID not found")
        return value as ForGetDataBySelectID[SelectID]
      }
      case 'Table1': {
        const value = dataStore.Table1.get(modelID)
        if (typeof value == 'undefined') return undefined // throw new Error("Table1 not found")
        return value as ForGetDataBySelectID[SelectID]
      }

      case 'TableConnectorAtBox': {
        const value = dataStore.TableConnectorAtBox.get(modelID)
        if (typeof value == 'undefined') return undefined // throw new Error("TableConnectorAtBox not found")
        return value as ForGetDataBySelectID[SelectID]
      }
      case 'TableConnectorWithID': {
        const value = dataStore.TableConnectorWithID.get(modelID)
        if (typeof value == 'undefined') return undefined // throw new Error("TableConnectorWithID not found")
        return value as ForGetDataBySelectID[SelectID]
      }
      case 'TableConnector1': {
        const value = dataStore.TableConnector1.get(modelID)
        if (typeof value == 'undefined') return undefined // throw new Error("TableConnector1 not found")
        return value as ForGetDataBySelectID[SelectID]
      }

      case 'TableDataAtBox': {
        const value = dataStore.TableDataAtBox.get(modelID)
        if (typeof value == 'undefined') return undefined // throw new Error("TableDataAtBox not found")
        return value as ForGetDataBySelectID[SelectID]
      }
      case 'TableDataPinnedToPage': {
        const value = dataStore.TableDataPinnedToPage.get(modelID)
        if (typeof value == 'undefined') return undefined // throw new Error("TableDataPinnedToPage not found")
        return value as ForGetDataBySelectID[SelectID]
      }
      case 'TableData1': {
        const value = dataStore.TableData1.get(modelID)
        if (typeof value == 'undefined') return undefined // throw new Error("TableData1 not found")
        return value as ForGetDataBySelectID[SelectID]
      }

      case 'TableRowAtBox': {
        const value = dataStore.TableRowAtBox.get(modelID)
        if (typeof value == 'undefined') return undefined // throw new Error("TableRowAtBox not found")
        return value as ForGetDataBySelectID[SelectID]
      }
      case 'TableDataRowPinnedToPage': {
        const value = dataStore.TableDataRowPinnedToPage.get(modelID)
        if (typeof value == 'undefined') return undefined // throw new Error("TableDataRowPinnedToPage not found")
        return value as ForGetDataBySelectID[SelectID]
      }
      case 'TableDataRow1': {
        const value = dataStore.TableDataRow1.get(modelID)
        if (typeof value == 'undefined') return undefined // throw new Error("TableDataRow1 not found")
        return value as ForGetDataBySelectID[SelectID]
      }

      case 'TableRowItemAtBox': {
        const value = dataStore.TableRowItemAtBox.get(modelID)
        if (typeof value == 'undefined') return undefined // throw new Error("TableRowItemAtBox not found")
        return value as ForGetDataBySelectID[SelectID]
      }
      case 'TableDataRowItem1': {
        const value = dataStore.TableDataRowItem1.get(modelID)
        if (typeof value == 'undefined') return undefined // throw new Error("TableDataRowItem1 not found")
        return value as ForGetDataBySelectID[SelectID]
      }

      case 'BlockCategory1': {
        const value = dataStore.BlockCategory1.get(modelID)
        if (typeof value == 'undefined') return undefined // throw new Error("BlockCategory1 not found")
        return value as ForGetDataBySelectID[SelectID]
      }

      case 'Lead1': {
        const value = dataStore.Lead1.get(modelID)
        if (typeof value == 'undefined') return undefined // throw new Error("Lead1 not found")
        return value as ForGetDataBySelectID[SelectID]
      }

      case 'GroupFont1': {
        const value = dataStore.GroupFont1.get(modelID)
        if (typeof value == 'undefined') return undefined // throw new Error("GroupFont1 not found")
        return value as ForGetDataBySelectID[SelectID]
      }

      case 'WhatsAppBot1': {
        const value = dataStore.WhatsAppBot1.get(modelID)
        if (typeof value == 'undefined') return undefined // throw new Error("WhatsAppBot1 not found")
        return value as ForGetDataBySelectID[SelectID]
      }

      default: {
        const never: never = selectID
      }
    }
    throw new Error('unknown selectID')
  }
  const [data, setData] = useState(getData())

  useEffect(() => {
    setData(getData())
  }, [modelID])

  useEffect(() => {
    if (selectID && modelID) {
      callbacks[selectID].set(id, {
        entityID: modelID,
        callback: () => {
          setData(getData())
        },
      })
      return () => {
        callbacks[selectID].delete(id)
      }
    }
  }, [modelID])
  return data
}

export function getDataAtStoreSite<SelectID extends keyof ForGetDataBySelectID>({
  selectID,
  modelID,
}: {
  selectID: SelectID
  modelID: string
}) {
  switch (selectID) {
    case 'Site1': {
      const value = dataStore.Site1.get(modelID)
      if (typeof value == 'undefined') throw new Error('Site1 not found')
      return value as ForGetDataBySelectID[SelectID]
    }

    case 'UserSelect1': {
      const value = dataStore.UserSelect1.get(modelID)
      if (typeof value == 'undefined') throw new Error('UserSelect1 not found')
      return value as ForGetDataBySelectID[SelectID]
    }

    case 'TelegramChannel1': {
      const value = dataStore.TelegramChannel1.get(modelID)
      if (typeof value == 'undefined') throw new Error('TelegramChannel1 not found')
      return value as ForGetDataBySelectID[SelectID]
    }

    case 'TelegramGift1': {
      const value = dataStore.TelegramGift1.get(modelID)
      if (typeof value == 'undefined') throw new Error('TelegramGift1 not found')
      return value as ForGetDataBySelectID[SelectID]
    }

    case 'Image1': {
      const value = dataStore.Image1.get(modelID)
      if (typeof value == 'undefined') throw new Error('Image1 not found')
      return value as ForGetDataBySelectID[SelectID]
    }

    case 'PageOnlyWithFields': {
      const value = dataStore.PageOnlyWithFields.get(modelID)
      if (typeof value == 'undefined') throw new Error('PageOnlyWithFields not found')
      return value as ForGetDataBySelectID[SelectID]
    }
    case 'Page1': {
      const value = dataStore.Page1.get(modelID)
      if (typeof value == 'undefined') throw new Error('Page1 not found')
      return value as ForGetDataBySelectID[SelectID]
    }
    case 'PageForLink': {
      const value = dataStore.PageForLink.get(modelID)
      if (typeof value == 'undefined') throw new Error('PageForLink not found')
      return value as ForGetDataBySelectID[SelectID]
    }

    case 'Target1': {
      const value = dataStore.Target1.get(modelID)
      if (typeof value == 'undefined') throw new Error('Target1 not found')
      return value as ForGetDataBySelectID[SelectID]
    }

    case 'TelegramPersonalBot1': {
      const value = dataStore.TelegramPersonalBot1.get(modelID)
      if (typeof value == 'undefined') throw new Error('TelegramPersonalBot1 not found')
      return value as ForGetDataBySelectID[SelectID]
    }

    case 'PaidPlace1': {
      const value = dataStore.PaidPlace1.get(modelID)
      if (typeof value == 'undefined') throw new Error('PaidPlace1 not found')
      return value as ForGetDataBySelectID[SelectID]
    }

    case 'PaidPlaceOutcomeBalance1': {
      const value = dataStore.PaidPlaceOutcomeBalance1.get(modelID)
      if (typeof value == 'undefined') throw new Error('PaidPlaceOutcomeBalance1 not found')
      return value as ForGetDataBySelectID[SelectID]
    }

    case 'TelegramUser1': {
      const value = dataStore.TelegramUser1.get(modelID)
      if (typeof value == 'undefined') throw new Error('TelegramUser1 not found')
      return value as ForGetDataBySelectID[SelectID]
    }

    case 'Domain1': {
      const value = dataStore.Domain1.get(modelID)
      if (typeof value == 'undefined') throw new Error('Domain1 not found')
      return value as ForGetDataBySelectID[SelectID]
    }

    case 'SectionsPinned1': {
      const value = dataStore.SectionsPinned1.get(modelID)
      if (typeof value == 'undefined') throw new Error('SectionsPinned1 not found')
      return value as ForGetDataBySelectID[SelectID]
    }
    case 'SectionsPinnedID': {
      const value = dataStore.SectionsPinnedID.get(modelID)
      if (typeof value == 'undefined') throw new Error('SectionsPinnedID not found')
      return value as ForGetDataBySelectID[SelectID]
    }

    case 'Sections1': {
      const value = dataStore.Sections1.get(modelID)
      if (typeof value == 'undefined') throw new Error('Sections1 not found')
      return value as ForGetDataBySelectID[SelectID]
    }

    case 'Section1': {
      const value = dataStore.Section1.get(modelID)
      if (typeof value == 'undefined') throw new Error('Section1 not found')
      return value as ForGetDataBySelectID[SelectID]
    }
    case 'SectionID': {
      const value = dataStore.SectionID.get(modelID)
      if (typeof value == 'undefined') throw new Error('SectionID not found')
      return value as ForGetDataBySelectID[SelectID]
    }

    case 'PopupWithName': {
      const value = dataStore.PopupWithName.get(modelID)
      if (typeof value == 'undefined') throw new Error('PopupWithName not found')
      return value as ForGetDataBySelectID[SelectID]
    }
    case 'PopupID': {
      const value = dataStore.PopupID.get(modelID)
      if (typeof value == 'undefined') throw new Error('PopupID not found')
      return value as ForGetDataBySelectID[SelectID]
    }
    case 'Popup1': {
      const value = dataStore.Popup1.get(modelID)
      if (typeof value == 'undefined') throw new Error('Popup1 not found')
      return value as ForGetDataBySelectID[SelectID]
    }

    case 'BoxBlock1': {
      const value = dataStore.BoxBlock1.get(modelID)
      if (typeof value == 'undefined') throw new Error('BoxBlock1 not found')
      return value as ForGetDataBySelectID[SelectID]
    }

    case 'Box1': {
      const value = dataStore.Box1.get(modelID)
      if (typeof value == 'undefined') throw new Error('Box1 not found')
      return value as ForGetDataBySelectID[SelectID]
    }

    case 'ResponsiveBoxSetting1': {
      const value = dataStore.ResponsiveBoxSetting1.get(modelID)
      if (typeof value == 'undefined') throw new Error('ResponsiveBoxSetting1 not found')
      return value as ForGetDataBySelectID[SelectID]
    }

    case 'BoxSetting1': {
      const value = dataStore.BoxSetting1.get(modelID)
      if (typeof value == 'undefined') throw new Error('BoxSetting1 not found')
      return value as ForGetDataBySelectID[SelectID]
    }

    case 'BoxBackground1': {
      const value = dataStore.BoxBackground1.get(modelID)
      if (typeof value == 'undefined') throw new Error('BoxBackground1 not found')
      return value as ForGetDataBySelectID[SelectID]
    }

    case 'Color1': {
      const value = dataStore.Color1.get(modelID)
      if (typeof value == 'undefined') throw new Error('Color1 not found')
      return value as ForGetDataBySelectID[SelectID]
    }

    case 'BoxBorder1': {
      const value = dataStore.BoxBorder1.get(modelID)
      if (typeof value == 'undefined') throw new Error('BoxBorder1 not found')
      return value as ForGetDataBySelectID[SelectID]
    }

    case 'BoxShadow1': {
      const value = dataStore.BoxShadow1.get(modelID)
      if (typeof value == 'undefined') throw new Error('BoxShadow1 not found')
      return value as ForGetDataBySelectID[SelectID]
    }

    case 'Link1': {
      const value = dataStore.Link1.get(modelID)
      if (typeof value == 'undefined') throw new Error('Link1 not found')
      return value as ForGetDataBySelectID[SelectID]
    }

    case 'TextComponent1': {
      const value = dataStore.TextComponent1.get(modelID)
      if (typeof value == 'undefined') throw new Error('TextComponent1 not found')
      return value as ForGetDataBySelectID[SelectID]
    }

    case 'TextSettings1': {
      const value = dataStore.TextSettings1.get(modelID)
      if (typeof value == 'undefined') throw new Error('TextSettings1 not found')
      return value as ForGetDataBySelectID[SelectID]
    }

    case 'FontWeight1': {
      const value = dataStore.FontWeight1.get(modelID)
      if (typeof value == 'undefined') throw new Error('FontWeight1 not found')
      return value as ForGetDataBySelectID[SelectID]
    }

    case 'ImageComponent1': {
      const value = dataStore.ImageComponent1.get(modelID)
      if (typeof value == 'undefined') throw new Error('ImageComponent1 not found')
      return value as ForGetDataBySelectID[SelectID]
    }

    case 'FormComponent1': {
      const value = dataStore.FormComponent1.get(modelID)
      if (typeof value == 'undefined') throw new Error('FormComponent1 not found')
      return value as ForGetDataBySelectID[SelectID]
    }

    case 'Form1': {
      const value = dataStore.Form1.get(modelID)
      if (typeof value == 'undefined') throw new Error('Form1 not found')
      return value as ForGetDataBySelectID[SelectID]
    }

    case 'ExtraInput1': {
      const value = dataStore.ExtraInput1.get(modelID)
      if (typeof value == 'undefined') throw new Error('ExtraInput1 not found')
      return value as ForGetDataBySelectID[SelectID]
    }

    case 'QuizComponent1': {
      const value = dataStore.QuizComponent1.get(modelID)
      if (typeof value == 'undefined') throw new Error('QuizComponent1 not found')
      return value as ForGetDataBySelectID[SelectID]
    }

    case 'Quiz1': {
      const value = dataStore.Quiz1.get(modelID)
      if (typeof value == 'undefined') throw new Error('Quiz1 not found')
      return value as ForGetDataBySelectID[SelectID]
    }

    case 'QuizStep1': {
      const value = dataStore.QuizStep1.get(modelID)
      if (typeof value == 'undefined') throw new Error('QuizStep1 not found')
      return value as ForGetDataBySelectID[SelectID]
    }

    case 'QuizCheckboxStep1': {
      const value = dataStore.QuizCheckboxStep1.get(modelID)
      if (typeof value == 'undefined') throw new Error('QuizCheckboxStep1 not found')
      return value as ForGetDataBySelectID[SelectID]
    }

    case 'QuizCheckboxStepItem1': {
      const value = dataStore.QuizCheckboxStepItem1.get(modelID)
      if (typeof value == 'undefined') throw new Error('QuizCheckboxStepItem1 not found')
      return value as ForGetDataBySelectID[SelectID]
    }

    case 'QuizRadioStep1': {
      const value = dataStore.QuizRadioStep1.get(modelID)
      if (typeof value == 'undefined') throw new Error('QuizRadioStep1 not found')
      return value as ForGetDataBySelectID[SelectID]
    }

    case 'QuizRadioStepItem1': {
      const value = dataStore.QuizRadioStepItem1.get(modelID)
      if (typeof value == 'undefined') throw new Error('QuizRadioStepItem1 not found')
      return value as ForGetDataBySelectID[SelectID]
    }

    case 'QuizFieldInputStep1': {
      const value = dataStore.QuizFieldInputStep1.get(modelID)
      if (typeof value == 'undefined') throw new Error('QuizFieldInputStep1 not found')
      return value as ForGetDataBySelectID[SelectID]
    }

    case 'VideoComponent1': {
      const value = dataStore.VideoComponent1.get(modelID)
      if (typeof value == 'undefined') throw new Error('VideoComponent1 not found')
      return value as ForGetDataBySelectID[SelectID]
    }

    case 'FaqComponent1': {
      const value = dataStore.FaqComponent1.get(modelID)
      if (typeof value == 'undefined') throw new Error('FaqComponent1 not found')
      return value as ForGetDataBySelectID[SelectID]
    }

    case 'FaqComponentItem1': {
      const value = dataStore.FaqComponentItem1.get(modelID)
      if (typeof value == 'undefined') throw new Error('FaqComponentItem1 not found')
      return value as ForGetDataBySelectID[SelectID]
    }

    case 'MapComponent1': {
      const value = dataStore.MapComponent1.get(modelID)
      if (typeof value == 'undefined') throw new Error('MapComponent1 not found')
      return value as ForGetDataBySelectID[SelectID]
    }

    case 'MapComponentPoint1': {
      const value = dataStore.MapComponentPoint1.get(modelID)
      if (typeof value == 'undefined') throw new Error('MapComponentPoint1 not found')
      return value as ForGetDataBySelectID[SelectID]
    }

    case 'CodeComponent1': {
      const value = dataStore.CodeComponent1.get(modelID)
      if (typeof value == 'undefined') throw new Error('CodeComponent1 not found')
      return value as ForGetDataBySelectID[SelectID]
    }

    case 'WhatsAppBotComponent1': {
      const value = dataStore.WhatsAppBotComponent1.get(modelID)
      if (typeof value == 'undefined') throw new Error('WhatsAppBotComponent1 not found')
      return value as ForGetDataBySelectID[SelectID]
    }

    case 'WhatsAppBotLink1': {
      const value = dataStore.WhatsAppBotLink1.get(modelID)
      if (typeof value == 'undefined') throw new Error('WhatsAppBotLink1 not found')
      return value as ForGetDataBySelectID[SelectID]
    }

    case 'TableColumnSimple': {
      const value = dataStore.TableColumnSimple.get(modelID)
      if (typeof value == 'undefined') throw new Error('TableColumnSimple not found')
      return value as ForGetDataBySelectID[SelectID]
    }
    case 'TableColumnAtBoxAtSchema': {
      const value = dataStore.TableColumnAtBoxAtSchema.get(modelID)
      if (typeof value == 'undefined') throw new Error('TableColumnAtBoxAtSchema not found')
      return value as ForGetDataBySelectID[SelectID]
    }
    case 'TableColumnAtBox': {
      const value = dataStore.TableColumnAtBox.get(modelID)
      if (typeof value == 'undefined') throw new Error('TableColumnAtBox not found')
      return value as ForGetDataBySelectID[SelectID]
    }
    case 'TableColumn1': {
      const value = dataStore.TableColumn1.get(modelID)
      if (typeof value == 'undefined') throw new Error('TableColumn1 not found')
      return value as ForGetDataBySelectID[SelectID]
    }

    case 'TableAtBox': {
      const value = dataStore.TableAtBox.get(modelID)
      if (typeof value == 'undefined') throw new Error('TableAtBox not found')
      return value as ForGetDataBySelectID[SelectID]
    }
    case 'TableWithID': {
      const value = dataStore.TableWithID.get(modelID)
      if (typeof value == 'undefined') throw new Error('TableWithID not found')
      return value as ForGetDataBySelectID[SelectID]
    }
    case 'Table1': {
      const value = dataStore.Table1.get(modelID)
      if (typeof value == 'undefined') throw new Error('Table1 not found')
      return value as ForGetDataBySelectID[SelectID]
    }

    case 'TableConnectorAtBox': {
      const value = dataStore.TableConnectorAtBox.get(modelID)
      if (typeof value == 'undefined') throw new Error('TableConnectorAtBox not found')
      return value as ForGetDataBySelectID[SelectID]
    }
    case 'TableConnectorWithID': {
      const value = dataStore.TableConnectorWithID.get(modelID)
      if (typeof value == 'undefined') throw new Error('TableConnectorWithID not found')
      return value as ForGetDataBySelectID[SelectID]
    }
    case 'TableConnector1': {
      const value = dataStore.TableConnector1.get(modelID)
      if (typeof value == 'undefined') throw new Error('TableConnector1 not found')
      return value as ForGetDataBySelectID[SelectID]
    }

    case 'TableDataAtBox': {
      const value = dataStore.TableDataAtBox.get(modelID)
      if (typeof value == 'undefined') throw new Error('TableDataAtBox not found')
      return value as ForGetDataBySelectID[SelectID]
    }
    case 'TableDataPinnedToPage': {
      const value = dataStore.TableDataPinnedToPage.get(modelID)
      if (typeof value == 'undefined') throw new Error('TableDataPinnedToPage not found')
      return value as ForGetDataBySelectID[SelectID]
    }
    case 'TableData1': {
      const value = dataStore.TableData1.get(modelID)
      if (typeof value == 'undefined') throw new Error('TableData1 not found')
      return value as ForGetDataBySelectID[SelectID]
    }

    case 'TableRowAtBox': {
      const value = dataStore.TableRowAtBox.get(modelID)
      if (typeof value == 'undefined') throw new Error('TableRowAtBox not found')
      return value as ForGetDataBySelectID[SelectID]
    }
    case 'TableDataRowPinnedToPage': {
      const value = dataStore.TableDataRowPinnedToPage.get(modelID)
      if (typeof value == 'undefined') throw new Error('TableDataRowPinnedToPage not found')
      return value as ForGetDataBySelectID[SelectID]
    }
    case 'TableDataRow1': {
      const value = dataStore.TableDataRow1.get(modelID)
      if (typeof value == 'undefined') throw new Error('TableDataRow1 not found')
      return value as ForGetDataBySelectID[SelectID]
    }

    case 'TableRowItemAtBox': {
      const value = dataStore.TableRowItemAtBox.get(modelID)
      if (typeof value == 'undefined') throw new Error('TableRowItemAtBox not found')
      return value as ForGetDataBySelectID[SelectID]
    }
    case 'TableDataRowItem1': {
      const value = dataStore.TableDataRowItem1.get(modelID)
      if (typeof value == 'undefined') throw new Error('TableDataRowItem1 not found')
      return value as ForGetDataBySelectID[SelectID]
    }

    case 'BlockCategory1': {
      const value = dataStore.BlockCategory1.get(modelID)
      if (typeof value == 'undefined') throw new Error('BlockCategory1 not found')
      return value as ForGetDataBySelectID[SelectID]
    }

    case 'Lead1': {
      const value = dataStore.Lead1.get(modelID)
      if (typeof value == 'undefined') throw new Error('Lead1 not found')
      return value as ForGetDataBySelectID[SelectID]
    }

    case 'GroupFont1': {
      const value = dataStore.GroupFont1.get(modelID)
      if (typeof value == 'undefined') throw new Error('GroupFont1 not found')
      return value as ForGetDataBySelectID[SelectID]
    }

    case 'WhatsAppBot1': {
      const value = dataStore.WhatsAppBot1.get(modelID)
      if (typeof value == 'undefined') throw new Error('WhatsAppBot1 not found')
      return value as ForGetDataBySelectID[SelectID]
    }

    default: {
      const never: never = selectID
    }
  }
  throw new Error('unknown selectID')
}

const FrontendCallbackDataCenterSite = () => {
  return {
    get: <SelectID extends keyof ForGetDataBySelectID>({ selectID, modelID }: { selectID: SelectID; modelID: string }) => {
      const getData = () => {
        switch (selectID) {
          case 'Site1': {
            const value = dataStore.Site1.get(modelID)
            if (typeof value == 'undefined') throw new Error('Site1 not found')
            return value as ForGetDataBySelectID[SelectID]
          }

          case 'UserSelect1': {
            const value = dataStore.UserSelect1.get(modelID)
            if (typeof value == 'undefined') throw new Error('UserSelect1 not found')
            return value as ForGetDataBySelectID[SelectID]
          }

          case 'TelegramChannel1': {
            const value = dataStore.TelegramChannel1.get(modelID)
            if (typeof value == 'undefined') throw new Error('TelegramChannel1 not found')
            return value as ForGetDataBySelectID[SelectID]
          }

          case 'TelegramGift1': {
            const value = dataStore.TelegramGift1.get(modelID)
            if (typeof value == 'undefined') throw new Error('TelegramGift1 not found')
            return value as ForGetDataBySelectID[SelectID]
          }

          case 'Image1': {
            const value = dataStore.Image1.get(modelID)
            if (typeof value == 'undefined') throw new Error('Image1 not found')
            return value as ForGetDataBySelectID[SelectID]
          }

          case 'PageOnlyWithFields': {
            const value = dataStore.PageOnlyWithFields.get(modelID)
            if (typeof value == 'undefined') throw new Error('PageOnlyWithFields not found')
            return value as ForGetDataBySelectID[SelectID]
          }
          case 'Page1': {
            const value = dataStore.Page1.get(modelID)
            if (typeof value == 'undefined') throw new Error('Page1 not found')
            return value as ForGetDataBySelectID[SelectID]
          }
          case 'PageForLink': {
            const value = dataStore.PageForLink.get(modelID)
            if (typeof value == 'undefined') throw new Error('PageForLink not found')
            return value as ForGetDataBySelectID[SelectID]
          }

          case 'Target1': {
            const value = dataStore.Target1.get(modelID)
            if (typeof value == 'undefined') throw new Error('Target1 not found')
            return value as ForGetDataBySelectID[SelectID]
          }

          case 'TelegramPersonalBot1': {
            const value = dataStore.TelegramPersonalBot1.get(modelID)
            if (typeof value == 'undefined') throw new Error('TelegramPersonalBot1 not found')
            return value as ForGetDataBySelectID[SelectID]
          }

          case 'PaidPlace1': {
            const value = dataStore.PaidPlace1.get(modelID)
            if (typeof value == 'undefined') throw new Error('PaidPlace1 not found')
            return value as ForGetDataBySelectID[SelectID]
          }

          case 'PaidPlaceOutcomeBalance1': {
            const value = dataStore.PaidPlaceOutcomeBalance1.get(modelID)
            if (typeof value == 'undefined') throw new Error('PaidPlaceOutcomeBalance1 not found')
            return value as ForGetDataBySelectID[SelectID]
          }

          case 'TelegramUser1': {
            const value = dataStore.TelegramUser1.get(modelID)
            if (typeof value == 'undefined') throw new Error('TelegramUser1 not found')
            return value as ForGetDataBySelectID[SelectID]
          }

          case 'Domain1': {
            const value = dataStore.Domain1.get(modelID)
            if (typeof value == 'undefined') throw new Error('Domain1 not found')
            return value as ForGetDataBySelectID[SelectID]
          }

          case 'SectionsPinned1': {
            const value = dataStore.SectionsPinned1.get(modelID)
            if (typeof value == 'undefined') throw new Error('SectionsPinned1 not found')
            return value as ForGetDataBySelectID[SelectID]
          }
          case 'SectionsPinnedID': {
            const value = dataStore.SectionsPinnedID.get(modelID)
            if (typeof value == 'undefined') throw new Error('SectionsPinnedID not found')
            return value as ForGetDataBySelectID[SelectID]
          }

          case 'Sections1': {
            const value = dataStore.Sections1.get(modelID)
            if (typeof value == 'undefined') throw new Error('Sections1 not found')
            return value as ForGetDataBySelectID[SelectID]
          }

          case 'Section1': {
            const value = dataStore.Section1.get(modelID)
            if (typeof value == 'undefined') throw new Error('Section1 not found')
            return value as ForGetDataBySelectID[SelectID]
          }
          case 'SectionID': {
            const value = dataStore.SectionID.get(modelID)
            if (typeof value == 'undefined') throw new Error('SectionID not found')
            return value as ForGetDataBySelectID[SelectID]
          }

          case 'PopupWithName': {
            const value = dataStore.PopupWithName.get(modelID)
            if (typeof value == 'undefined') throw new Error('PopupWithName not found')
            return value as ForGetDataBySelectID[SelectID]
          }
          case 'PopupID': {
            const value = dataStore.PopupID.get(modelID)
            if (typeof value == 'undefined') throw new Error('PopupID not found')
            return value as ForGetDataBySelectID[SelectID]
          }
          case 'Popup1': {
            const value = dataStore.Popup1.get(modelID)
            if (typeof value == 'undefined') throw new Error('Popup1 not found')
            return value as ForGetDataBySelectID[SelectID]
          }

          case 'BoxBlock1': {
            const value = dataStore.BoxBlock1.get(modelID)
            if (typeof value == 'undefined') throw new Error('BoxBlock1 not found')
            return value as ForGetDataBySelectID[SelectID]
          }

          case 'Box1': {
            const value = dataStore.Box1.get(modelID)
            if (typeof value == 'undefined') throw new Error('Box1 not found')
            return value as ForGetDataBySelectID[SelectID]
          }

          case 'ResponsiveBoxSetting1': {
            const value = dataStore.ResponsiveBoxSetting1.get(modelID)
            if (typeof value == 'undefined') throw new Error('ResponsiveBoxSetting1 not found')
            return value as ForGetDataBySelectID[SelectID]
          }

          case 'BoxSetting1': {
            const value = dataStore.BoxSetting1.get(modelID)
            if (typeof value == 'undefined') throw new Error('BoxSetting1 not found')
            return value as ForGetDataBySelectID[SelectID]
          }

          case 'BoxBackground1': {
            const value = dataStore.BoxBackground1.get(modelID)
            if (typeof value == 'undefined') throw new Error('BoxBackground1 not found')
            return value as ForGetDataBySelectID[SelectID]
          }

          case 'Color1': {
            const value = dataStore.Color1.get(modelID)
            if (typeof value == 'undefined') throw new Error('Color1 not found')
            return value as ForGetDataBySelectID[SelectID]
          }

          case 'BoxBorder1': {
            const value = dataStore.BoxBorder1.get(modelID)
            if (typeof value == 'undefined') throw new Error('BoxBorder1 not found')
            return value as ForGetDataBySelectID[SelectID]
          }

          case 'BoxShadow1': {
            const value = dataStore.BoxShadow1.get(modelID)
            if (typeof value == 'undefined') throw new Error('BoxShadow1 not found')
            return value as ForGetDataBySelectID[SelectID]
          }

          case 'Link1': {
            const value = dataStore.Link1.get(modelID)
            if (typeof value == 'undefined') throw new Error('Link1 not found')
            return value as ForGetDataBySelectID[SelectID]
          }

          case 'TextComponent1': {
            const value = dataStore.TextComponent1.get(modelID)
            if (typeof value == 'undefined') throw new Error('TextComponent1 not found')
            return value as ForGetDataBySelectID[SelectID]
          }

          case 'TextSettings1': {
            const value = dataStore.TextSettings1.get(modelID)
            if (typeof value == 'undefined') throw new Error('TextSettings1 not found')
            return value as ForGetDataBySelectID[SelectID]
          }

          case 'FontWeight1': {
            const value = dataStore.FontWeight1.get(modelID)
            if (typeof value == 'undefined') throw new Error('FontWeight1 not found')
            return value as ForGetDataBySelectID[SelectID]
          }

          case 'ImageComponent1': {
            const value = dataStore.ImageComponent1.get(modelID)
            if (typeof value == 'undefined') throw new Error('ImageComponent1 not found')
            return value as ForGetDataBySelectID[SelectID]
          }

          case 'FormComponent1': {
            const value = dataStore.FormComponent1.get(modelID)
            if (typeof value == 'undefined') throw new Error('FormComponent1 not found')
            return value as ForGetDataBySelectID[SelectID]
          }

          case 'Form1': {
            const value = dataStore.Form1.get(modelID)
            if (typeof value == 'undefined') throw new Error('Form1 not found')
            return value as ForGetDataBySelectID[SelectID]
          }

          case 'ExtraInput1': {
            const value = dataStore.ExtraInput1.get(modelID)
            if (typeof value == 'undefined') throw new Error('ExtraInput1 not found')
            return value as ForGetDataBySelectID[SelectID]
          }

          case 'QuizComponent1': {
            const value = dataStore.QuizComponent1.get(modelID)
            if (typeof value == 'undefined') throw new Error('QuizComponent1 not found')
            return value as ForGetDataBySelectID[SelectID]
          }

          case 'Quiz1': {
            const value = dataStore.Quiz1.get(modelID)
            if (typeof value == 'undefined') throw new Error('Quiz1 not found')
            return value as ForGetDataBySelectID[SelectID]
          }

          case 'QuizStep1': {
            const value = dataStore.QuizStep1.get(modelID)
            if (typeof value == 'undefined') throw new Error('QuizStep1 not found')
            return value as ForGetDataBySelectID[SelectID]
          }

          case 'QuizCheckboxStep1': {
            const value = dataStore.QuizCheckboxStep1.get(modelID)
            if (typeof value == 'undefined') throw new Error('QuizCheckboxStep1 not found')
            return value as ForGetDataBySelectID[SelectID]
          }

          case 'QuizCheckboxStepItem1': {
            const value = dataStore.QuizCheckboxStepItem1.get(modelID)
            if (typeof value == 'undefined') throw new Error('QuizCheckboxStepItem1 not found')
            return value as ForGetDataBySelectID[SelectID]
          }

          case 'QuizRadioStep1': {
            const value = dataStore.QuizRadioStep1.get(modelID)
            if (typeof value == 'undefined') throw new Error('QuizRadioStep1 not found')
            return value as ForGetDataBySelectID[SelectID]
          }

          case 'QuizRadioStepItem1': {
            const value = dataStore.QuizRadioStepItem1.get(modelID)
            if (typeof value == 'undefined') throw new Error('QuizRadioStepItem1 not found')
            return value as ForGetDataBySelectID[SelectID]
          }

          case 'QuizFieldInputStep1': {
            const value = dataStore.QuizFieldInputStep1.get(modelID)
            if (typeof value == 'undefined') throw new Error('QuizFieldInputStep1 not found')
            return value as ForGetDataBySelectID[SelectID]
          }

          case 'VideoComponent1': {
            const value = dataStore.VideoComponent1.get(modelID)
            if (typeof value == 'undefined') throw new Error('VideoComponent1 not found')
            return value as ForGetDataBySelectID[SelectID]
          }

          case 'FaqComponent1': {
            const value = dataStore.FaqComponent1.get(modelID)
            if (typeof value == 'undefined') throw new Error('FaqComponent1 not found')
            return value as ForGetDataBySelectID[SelectID]
          }

          case 'FaqComponentItem1': {
            const value = dataStore.FaqComponentItem1.get(modelID)
            if (typeof value == 'undefined') throw new Error('FaqComponentItem1 not found')
            return value as ForGetDataBySelectID[SelectID]
          }

          case 'MapComponent1': {
            const value = dataStore.MapComponent1.get(modelID)
            if (typeof value == 'undefined') throw new Error('MapComponent1 not found')
            return value as ForGetDataBySelectID[SelectID]
          }

          case 'MapComponentPoint1': {
            const value = dataStore.MapComponentPoint1.get(modelID)
            if (typeof value == 'undefined') throw new Error('MapComponentPoint1 not found')
            return value as ForGetDataBySelectID[SelectID]
          }

          case 'CodeComponent1': {
            const value = dataStore.CodeComponent1.get(modelID)
            if (typeof value == 'undefined') throw new Error('CodeComponent1 not found')
            return value as ForGetDataBySelectID[SelectID]
          }

          case 'WhatsAppBotComponent1': {
            const value = dataStore.WhatsAppBotComponent1.get(modelID)
            if (typeof value == 'undefined') throw new Error('WhatsAppBotComponent1 not found')
            return value as ForGetDataBySelectID[SelectID]
          }

          case 'WhatsAppBotLink1': {
            const value = dataStore.WhatsAppBotLink1.get(modelID)
            if (typeof value == 'undefined') throw new Error('WhatsAppBotLink1 not found')
            return value as ForGetDataBySelectID[SelectID]
          }

          case 'TableColumnSimple': {
            const value = dataStore.TableColumnSimple.get(modelID)
            if (typeof value == 'undefined') throw new Error('TableColumnSimple not found')
            return value as ForGetDataBySelectID[SelectID]
          }
          case 'TableColumnAtBoxAtSchema': {
            const value = dataStore.TableColumnAtBoxAtSchema.get(modelID)
            if (typeof value == 'undefined') throw new Error('TableColumnAtBoxAtSchema not found')
            return value as ForGetDataBySelectID[SelectID]
          }
          case 'TableColumnAtBox': {
            const value = dataStore.TableColumnAtBox.get(modelID)
            if (typeof value == 'undefined') throw new Error('TableColumnAtBox not found')
            return value as ForGetDataBySelectID[SelectID]
          }
          case 'TableColumn1': {
            const value = dataStore.TableColumn1.get(modelID)
            if (typeof value == 'undefined') throw new Error('TableColumn1 not found')
            return value as ForGetDataBySelectID[SelectID]
          }

          case 'TableAtBox': {
            const value = dataStore.TableAtBox.get(modelID)
            if (typeof value == 'undefined') throw new Error('TableAtBox not found')
            return value as ForGetDataBySelectID[SelectID]
          }
          case 'TableWithID': {
            const value = dataStore.TableWithID.get(modelID)
            if (typeof value == 'undefined') throw new Error('TableWithID not found')
            return value as ForGetDataBySelectID[SelectID]
          }
          case 'Table1': {
            const value = dataStore.Table1.get(modelID)
            if (typeof value == 'undefined') throw new Error('Table1 not found')
            return value as ForGetDataBySelectID[SelectID]
          }

          case 'TableConnectorAtBox': {
            const value = dataStore.TableConnectorAtBox.get(modelID)
            if (typeof value == 'undefined') throw new Error('TableConnectorAtBox not found')
            return value as ForGetDataBySelectID[SelectID]
          }
          case 'TableConnectorWithID': {
            const value = dataStore.TableConnectorWithID.get(modelID)
            if (typeof value == 'undefined') throw new Error('TableConnectorWithID not found')
            return value as ForGetDataBySelectID[SelectID]
          }
          case 'TableConnector1': {
            const value = dataStore.TableConnector1.get(modelID)
            if (typeof value == 'undefined') throw new Error('TableConnector1 not found')
            return value as ForGetDataBySelectID[SelectID]
          }

          case 'TableDataAtBox': {
            const value = dataStore.TableDataAtBox.get(modelID)
            if (typeof value == 'undefined') throw new Error('TableDataAtBox not found')
            return value as ForGetDataBySelectID[SelectID]
          }
          case 'TableDataPinnedToPage': {
            const value = dataStore.TableDataPinnedToPage.get(modelID)
            if (typeof value == 'undefined') throw new Error('TableDataPinnedToPage not found')
            return value as ForGetDataBySelectID[SelectID]
          }
          case 'TableData1': {
            const value = dataStore.TableData1.get(modelID)
            if (typeof value == 'undefined') throw new Error('TableData1 not found')
            return value as ForGetDataBySelectID[SelectID]
          }

          case 'TableRowAtBox': {
            const value = dataStore.TableRowAtBox.get(modelID)
            if (typeof value == 'undefined') throw new Error('TableRowAtBox not found')
            return value as ForGetDataBySelectID[SelectID]
          }
          case 'TableDataRowPinnedToPage': {
            const value = dataStore.TableDataRowPinnedToPage.get(modelID)
            if (typeof value == 'undefined') throw new Error('TableDataRowPinnedToPage not found')
            return value as ForGetDataBySelectID[SelectID]
          }
          case 'TableDataRow1': {
            const value = dataStore.TableDataRow1.get(modelID)
            if (typeof value == 'undefined') throw new Error('TableDataRow1 not found')
            return value as ForGetDataBySelectID[SelectID]
          }

          case 'TableRowItemAtBox': {
            const value = dataStore.TableRowItemAtBox.get(modelID)
            if (typeof value == 'undefined') throw new Error('TableRowItemAtBox not found')
            return value as ForGetDataBySelectID[SelectID]
          }
          case 'TableDataRowItem1': {
            const value = dataStore.TableDataRowItem1.get(modelID)
            if (typeof value == 'undefined') throw new Error('TableDataRowItem1 not found')
            return value as ForGetDataBySelectID[SelectID]
          }

          case 'BlockCategory1': {
            const value = dataStore.BlockCategory1.get(modelID)
            if (typeof value == 'undefined') throw new Error('BlockCategory1 not found')
            return value as ForGetDataBySelectID[SelectID]
          }

          case 'Lead1': {
            const value = dataStore.Lead1.get(modelID)
            if (typeof value == 'undefined') throw new Error('Lead1 not found')
            return value as ForGetDataBySelectID[SelectID]
          }

          case 'GroupFont1': {
            const value = dataStore.GroupFont1.get(modelID)
            if (typeof value == 'undefined') throw new Error('GroupFont1 not found')
            return value as ForGetDataBySelectID[SelectID]
          }

          case 'WhatsAppBot1': {
            const value = dataStore.WhatsAppBot1.get(modelID)
            if (typeof value == 'undefined') throw new Error('WhatsAppBot1 not found')
            return value as ForGetDataBySelectID[SelectID]
          }

          default: {
            const never: never = selectID
          }
        }
        throw new Error('unknown selectID')
      }

      return getData()
    },
    subscribe: <SelectID extends keyof ForGetDataBySelectID>({
      selectID,
      modelID,
      callback,
    }: {
      selectID: SelectID
      modelID: string
      callback: () => void
    }) => {
      const id = 'id' + Math.random().toString(16).slice(2)
      callbacks[selectID].set(id, {
        entityID: modelID,
        callback: () => {
          callback()
        },
      })
      return () => {
        callbacks[selectID].delete(id)
      }
    },
  }
}

export const frontendCallbackDataCenterSite = FrontendCallbackDataCenterSite()

let socket: Socket<ServerToClientEventsSynchron, ClientToServerEventsSynchron>

let modelIDForConnect = ''
let userTokenForConnect = ''
let dataForConnect:
  | {
      modelID: string
      userToken: string
    }
  | undefined = undefined

if (typeof window !== 'undefined') {
  if (location.pathname.startsWith('/panel')) {
    console.log('--- runSynchronEngine Frontend ---')
    fetch('/api/synchronSocketEngineAtSite').finally(() => {
      socket = io({
        path: '/api/synchronSocketEngineAtSite',
        transports: ['websocket'],
      })

      document.addEventListener('visibilitychange', event => {
        if (document.visibilityState == 'visible') {
          if (!synchronFrontendEngineAtSite.getIsConnected()) {
            socket.connect()
            synchronFrontendEngineAtSite.emitConnect()
          }
          // console.log("tab is active")
        } else {
          // console.log("tab is inactive")
        }
      })

      socket.on('connect', () => {
        synchronFrontendEngineAtSite.emitConnect()
      })

      socket.on('connect_error', () => {
        synchronFrontendEngineAtSite.callback(false)
        synchronFrontendEngineAtSite.changeIsConnect(false)
      })
      socket.on('disconnect', () => {
        synchronFrontendEngineAtSite.callback(false)
        synchronFrontendEngineAtSite.changeIsConnect(false)
      })

      socket.on('getRootData', ({ data }) => {
        synchronFrontendEngineAtSite.callback(true)
        parseAndMoveToStoreData({ data })
        // clientStore.setState({ data })
      })
      socket.on('createdData', ({ data }) => {
        parseAndMoveToStoreData({ data })
      })
      socket.on('updatedData', ({ data }) => {
        parseAndMoveToStoreData({ data })

        data.SiteV1.Site1.map(entity => {
          callbacks.Site1.forEach(async (value, key) => {
            if (entity.id == value.entityID) value.callback()
          })
        })

        data.User.UserSelect1.map(entity => {
          callbacks.UserSelect1.forEach(async (value, key) => {
            if (entity.id == value.entityID) value.callback()
          })
        })

        data.TelegramChannel.TelegramChannel1.map(entity => {
          callbacks.TelegramChannel1.forEach(async (value, key) => {
            if (entity.id == value.entityID) value.callback()
          })
        })

        data.TelegramGift.TelegramGift1.map(entity => {
          callbacks.TelegramGift1.forEach(async (value, key) => {
            if (entity.id == value.entityID) value.callback()
          })
        })

        data.ImageV1.Image1.map(entity => {
          callbacks.Image1.forEach(async (value, key) => {
            if (entity.id == value.entityID) value.callback()
          })
        })

        data.PageV1.PageOnlyWithFields.map(entity => {
          callbacks.PageOnlyWithFields.forEach(async (value, key) => {
            if (entity.id == value.entityID) value.callback()
          })
        })
        data.PageV1.Page1.map(entity => {
          callbacks.Page1.forEach(async (value, key) => {
            if (entity.id == value.entityID) value.callback()
          })
        })
        data.PageV1.PageForLink.map(entity => {
          callbacks.PageForLink.forEach(async (value, key) => {
            if (entity.id == value.entityID) value.callback()
          })
        })

        data.Target.Target1.map(entity => {
          callbacks.Target1.forEach(async (value, key) => {
            if (entity.id == value.entityID) value.callback()
          })
        })

        data.TelegramPersonalBot.TelegramPersonalBot1.map(entity => {
          callbacks.TelegramPersonalBot1.forEach(async (value, key) => {
            if (entity.id == value.entityID) value.callback()
          })
        })

        data.PaidPlace.PaidPlace1.map(entity => {
          callbacks.PaidPlace1.forEach(async (value, key) => {
            if (entity.id == value.entityID) value.callback()
          })
        })

        data.PaidPlaceOutcomeBalance.PaidPlaceOutcomeBalance1.map(entity => {
          callbacks.PaidPlaceOutcomeBalance1.forEach(async (value, key) => {
            if (entity.id == value.entityID) value.callback()
          })
        })

        data.TelegramUser.TelegramUser1.map(entity => {
          callbacks.TelegramUser1.forEach(async (value, key) => {
            if (entity.id == value.entityID) value.callback()
          })
        })

        data.DomainV1.Domain1.map(entity => {
          callbacks.Domain1.forEach(async (value, key) => {
            if (entity.id == value.entityID) value.callback()
          })
        })

        data.SectionsPinned.SectionsPinned1.map(entity => {
          callbacks.SectionsPinned1.forEach(async (value, key) => {
            if (entity.id == value.entityID) value.callback()
          })
        })
        data.SectionsPinned.SectionsPinnedID.map(entity => {
          callbacks.SectionsPinnedID.forEach(async (value, key) => {
            if (entity.id == value.entityID) value.callback()
          })
        })

        data.SectionsV1.Sections1.map(entity => {
          callbacks.Sections1.forEach(async (value, key) => {
            if (entity.id == value.entityID) value.callback()
          })
        })

        data.SectionV1.Section1.map(entity => {
          callbacks.Section1.forEach(async (value, key) => {
            if (entity.id == value.entityID) value.callback()
          })
        })
        data.SectionV1.SectionID.map(entity => {
          callbacks.SectionID.forEach(async (value, key) => {
            if (entity.id == value.entityID) value.callback()
          })
        })

        data.PopupV1.PopupWithName.map(entity => {
          callbacks.PopupWithName.forEach(async (value, key) => {
            if (entity.id == value.entityID) value.callback()
          })
        })
        data.PopupV1.PopupID.map(entity => {
          callbacks.PopupID.forEach(async (value, key) => {
            if (entity.id == value.entityID) value.callback()
          })
        })
        data.PopupV1.Popup1.map(entity => {
          callbacks.Popup1.forEach(async (value, key) => {
            if (entity.id == value.entityID) value.callback()
          })
        })

        data.BoxBlock.BoxBlock1.map(entity => {
          callbacks.BoxBlock1.forEach(async (value, key) => {
            if (entity.id == value.entityID) value.callback()
          })
        })

        data.Box.Box1.map(entity => {
          callbacks.Box1.forEach(async (value, key) => {
            if (entity.id == value.entityID) value.callback()
          })
        })

        data.ResponsiveBoxSettings.ResponsiveBoxSetting1.map(entity => {
          callbacks.ResponsiveBoxSetting1.forEach(async (value, key) => {
            if (entity.id == value.entityID) value.callback()
          })
        })

        data.BoxSettings.BoxSetting1.map(entity => {
          callbacks.BoxSetting1.forEach(async (value, key) => {
            if (entity.id == value.entityID) value.callback()
          })
        })

        data.BoxBackground.BoxBackground1.map(entity => {
          callbacks.BoxBackground1.forEach(async (value, key) => {
            if (entity.id == value.entityID) value.callback()
          })
        })

        data.Color.Color1.map(entity => {
          callbacks.Color1.forEach(async (value, key) => {
            if (entity.id == value.entityID) value.callback()
          })
        })

        data.BoxBorder.BoxBorder1.map(entity => {
          callbacks.BoxBorder1.forEach(async (value, key) => {
            if (entity.id == value.entityID) value.callback()
          })
        })

        data.BoxShadow.BoxShadow1.map(entity => {
          callbacks.BoxShadow1.forEach(async (value, key) => {
            if (entity.id == value.entityID) value.callback()
          })
        })

        data.LinkV1.Link1.map(entity => {
          callbacks.Link1.forEach(async (value, key) => {
            if (entity.id == value.entityID) value.callback()
          })
        })

        data.TextComponent.TextComponent1.map(entity => {
          callbacks.TextComponent1.forEach(async (value, key) => {
            if (entity.id == value.entityID) value.callback()
          })
        })

        data.TextSettings.TextSettings1.map(entity => {
          callbacks.TextSettings1.forEach(async (value, key) => {
            if (entity.id == value.entityID) value.callback()
          })
        })

        data.FontWeight.FontWeight1.map(entity => {
          callbacks.FontWeight1.forEach(async (value, key) => {
            if (entity.id == value.entityID) value.callback()
          })
        })

        data.ImageComponent.ImageComponent1.map(entity => {
          callbacks.ImageComponent1.forEach(async (value, key) => {
            if (entity.id == value.entityID) value.callback()
          })
        })

        data.FormComponent.FormComponent1.map(entity => {
          callbacks.FormComponent1.forEach(async (value, key) => {
            if (entity.id == value.entityID) value.callback()
          })
        })

        data.FormV1.Form1.map(entity => {
          callbacks.Form1.forEach(async (value, key) => {
            if (entity.id == value.entityID) value.callback()
          })
        })

        data.ExtraInputV1.ExtraInput1.map(entity => {
          callbacks.ExtraInput1.forEach(async (value, key) => {
            if (entity.id == value.entityID) value.callback()
          })
        })

        data.QuizComponent.QuizComponent1.map(entity => {
          callbacks.QuizComponent1.forEach(async (value, key) => {
            if (entity.id == value.entityID) value.callback()
          })
        })

        data.QuizV1.Quiz1.map(entity => {
          callbacks.Quiz1.forEach(async (value, key) => {
            if (entity.id == value.entityID) value.callback()
          })
        })

        data.QuizV1StepV1.QuizStep1.map(entity => {
          callbacks.QuizStep1.forEach(async (value, key) => {
            if (entity.id == value.entityID) value.callback()
          })
        })

        data.QuizV1CheckboxStepV1.QuizCheckboxStep1.map(entity => {
          callbacks.QuizCheckboxStep1.forEach(async (value, key) => {
            if (entity.id == value.entityID) value.callback()
          })
        })

        data.QuizV1CheckboxItemV1.QuizCheckboxStepItem1.map(entity => {
          callbacks.QuizCheckboxStepItem1.forEach(async (value, key) => {
            if (entity.id == value.entityID) value.callback()
          })
        })

        data.QuizV1RadioStepV1.QuizRadioStep1.map(entity => {
          callbacks.QuizRadioStep1.forEach(async (value, key) => {
            if (entity.id == value.entityID) value.callback()
          })
        })

        data.QuizV1RadioItemV1.QuizRadioStepItem1.map(entity => {
          callbacks.QuizRadioStepItem1.forEach(async (value, key) => {
            if (entity.id == value.entityID) value.callback()
          })
        })

        data.QuizV1FieldInputStepV1.QuizFieldInputStep1.map(entity => {
          callbacks.QuizFieldInputStep1.forEach(async (value, key) => {
            if (entity.id == value.entityID) value.callback()
          })
        })

        data.VideoComponent.VideoComponent1.map(entity => {
          callbacks.VideoComponent1.forEach(async (value, key) => {
            if (entity.id == value.entityID) value.callback()
          })
        })

        data.FaqComponent.FaqComponent1.map(entity => {
          callbacks.FaqComponent1.forEach(async (value, key) => {
            if (entity.id == value.entityID) value.callback()
          })
        })

        data.FaqComponentItem.FaqComponentItem1.map(entity => {
          callbacks.FaqComponentItem1.forEach(async (value, key) => {
            if (entity.id == value.entityID) value.callback()
          })
        })

        data.MapComponent.MapComponent1.map(entity => {
          callbacks.MapComponent1.forEach(async (value, key) => {
            if (entity.id == value.entityID) value.callback()
          })
        })

        data.MapComponentPoint.MapComponentPoint1.map(entity => {
          callbacks.MapComponentPoint1.forEach(async (value, key) => {
            if (entity.id == value.entityID) value.callback()
          })
        })

        data.CodeComponent.CodeComponent1.map(entity => {
          callbacks.CodeComponent1.forEach(async (value, key) => {
            if (entity.id == value.entityID) value.callback()
          })
        })

        data.WBotComponent.WhatsAppBotComponent1.map(entity => {
          callbacks.WhatsAppBotComponent1.forEach(async (value, key) => {
            if (entity.id == value.entityID) value.callback()
          })
        })

        data.WhatsAppBotLink.WhatsAppBotLink1.map(entity => {
          callbacks.WhatsAppBotLink1.forEach(async (value, key) => {
            if (entity.id == value.entityID) value.callback()
          })
        })

        data.TableColumn.TableColumnSimple.map(entity => {
          callbacks.TableColumnSimple.forEach(async (value, key) => {
            if (entity.id == value.entityID) value.callback()
          })
        })
        data.TableColumn.TableColumnAtBoxAtSchema.map(entity => {
          callbacks.TableColumnAtBoxAtSchema.forEach(async (value, key) => {
            if (entity.id == value.entityID) value.callback()
          })
        })
        data.TableColumn.TableColumnAtBox.map(entity => {
          callbacks.TableColumnAtBox.forEach(async (value, key) => {
            if (entity.id == value.entityID) value.callback()
          })
        })
        data.TableColumn.TableColumn1.map(entity => {
          callbacks.TableColumn1.forEach(async (value, key) => {
            if (entity.id == value.entityID) value.callback()
          })
        })

        data.Table.TableAtBox.map(entity => {
          callbacks.TableAtBox.forEach(async (value, key) => {
            if (entity.id == value.entityID) value.callback()
          })
        })
        data.Table.TableWithID.map(entity => {
          callbacks.TableWithID.forEach(async (value, key) => {
            if (entity.id == value.entityID) value.callback()
          })
        })
        data.Table.Table1.map(entity => {
          callbacks.Table1.forEach(async (value, key) => {
            if (entity.id == value.entityID) value.callback()
          })
        })

        data.TableConnector.TableConnectorAtBox.map(entity => {
          callbacks.TableConnectorAtBox.forEach(async (value, key) => {
            if (entity.id == value.entityID) value.callback()
          })
        })
        data.TableConnector.TableConnectorWithID.map(entity => {
          callbacks.TableConnectorWithID.forEach(async (value, key) => {
            if (entity.id == value.entityID) value.callback()
          })
        })
        data.TableConnector.TableConnector1.map(entity => {
          callbacks.TableConnector1.forEach(async (value, key) => {
            if (entity.id == value.entityID) value.callback()
          })
        })

        data.TableData.TableDataAtBox.map(entity => {
          callbacks.TableDataAtBox.forEach(async (value, key) => {
            if (entity.id == value.entityID) value.callback()
          })
        })
        data.TableData.TableDataPinnedToPage.map(entity => {
          callbacks.TableDataPinnedToPage.forEach(async (value, key) => {
            if (entity.id == value.entityID) value.callback()
          })
        })
        data.TableData.TableData1.map(entity => {
          callbacks.TableData1.forEach(async (value, key) => {
            if (entity.id == value.entityID) value.callback()
          })
        })

        data.TableRow.TableRowAtBox.map(entity => {
          callbacks.TableRowAtBox.forEach(async (value, key) => {
            if (entity.id == value.entityID) value.callback()
          })
        })
        data.TableRow.TableDataRowPinnedToPage.map(entity => {
          callbacks.TableDataRowPinnedToPage.forEach(async (value, key) => {
            if (entity.id == value.entityID) value.callback()
          })
        })
        data.TableRow.TableDataRow1.map(entity => {
          callbacks.TableDataRow1.forEach(async (value, key) => {
            if (entity.id == value.entityID) value.callback()
          })
        })

        data.TableRowItem.TableRowItemAtBox.map(entity => {
          callbacks.TableRowItemAtBox.forEach(async (value, key) => {
            if (entity.id == value.entityID) value.callback()
          })
        })
        data.TableRowItem.TableDataRowItem1.map(entity => {
          callbacks.TableDataRowItem1.forEach(async (value, key) => {
            if (entity.id == value.entityID) value.callback()
          })
        })

        data.BlockCategory.BlockCategory1.map(entity => {
          callbacks.BlockCategory1.forEach(async (value, key) => {
            if (entity.id == value.entityID) value.callback()
          })
        })

        data.LeadV1.Lead1.map(entity => {
          callbacks.Lead1.forEach(async (value, key) => {
            if (entity.id == value.entityID) value.callback()
          })
        })

        data.GroupFont.GroupFont1.map(entity => {
          callbacks.GroupFont1.forEach(async (value, key) => {
            if (entity.id == value.entityID) value.callback()
          })
        })

        data.WhatsAppBot.WhatsAppBot1.map(entity => {
          callbacks.WhatsAppBot1.forEach(async (value, key) => {
            if (entity.id == value.entityID) value.callback()
          })
        })
      })
      socket.on('updatedDataPartial', ({ data }) => {
        parseAndMoveToStoreDataPartial({ data })

        data.SiteV1.Site1.map(entity => {
          callbacks.Site1.forEach(async (value, key) => {
            if (entity.id == value.entityID) value.callback()
          })
        })

        data.User.UserSelect1.map(entity => {
          callbacks.UserSelect1.forEach(async (value, key) => {
            if (entity.id == value.entityID) value.callback()
          })
        })

        data.TelegramChannel.TelegramChannel1.map(entity => {
          callbacks.TelegramChannel1.forEach(async (value, key) => {
            if (entity.id == value.entityID) value.callback()
          })
        })

        data.TelegramGift.TelegramGift1.map(entity => {
          callbacks.TelegramGift1.forEach(async (value, key) => {
            if (entity.id == value.entityID) value.callback()
          })
        })

        data.ImageV1.Image1.map(entity => {
          callbacks.Image1.forEach(async (value, key) => {
            if (entity.id == value.entityID) value.callback()
          })
        })

        data.PageV1.PageOnlyWithFields.map(entity => {
          callbacks.PageOnlyWithFields.forEach(async (value, key) => {
            if (entity.id == value.entityID) value.callback()
          })
        })
        data.PageV1.Page1.map(entity => {
          callbacks.Page1.forEach(async (value, key) => {
            if (entity.id == value.entityID) value.callback()
          })
        })
        data.PageV1.PageForLink.map(entity => {
          callbacks.PageForLink.forEach(async (value, key) => {
            if (entity.id == value.entityID) value.callback()
          })
        })

        data.Target.Target1.map(entity => {
          callbacks.Target1.forEach(async (value, key) => {
            if (entity.id == value.entityID) value.callback()
          })
        })

        data.TelegramPersonalBot.TelegramPersonalBot1.map(entity => {
          callbacks.TelegramPersonalBot1.forEach(async (value, key) => {
            if (entity.id == value.entityID) value.callback()
          })
        })

        data.PaidPlace.PaidPlace1.map(entity => {
          callbacks.PaidPlace1.forEach(async (value, key) => {
            if (entity.id == value.entityID) value.callback()
          })
        })

        data.PaidPlaceOutcomeBalance.PaidPlaceOutcomeBalance1.map(entity => {
          callbacks.PaidPlaceOutcomeBalance1.forEach(async (value, key) => {
            if (entity.id == value.entityID) value.callback()
          })
        })

        data.TelegramUser.TelegramUser1.map(entity => {
          callbacks.TelegramUser1.forEach(async (value, key) => {
            if (entity.id == value.entityID) value.callback()
          })
        })

        data.DomainV1.Domain1.map(entity => {
          callbacks.Domain1.forEach(async (value, key) => {
            if (entity.id == value.entityID) value.callback()
          })
        })

        data.SectionsPinned.SectionsPinned1.map(entity => {
          callbacks.SectionsPinned1.forEach(async (value, key) => {
            if (entity.id == value.entityID) value.callback()
          })
        })
        data.SectionsPinned.SectionsPinnedID.map(entity => {
          callbacks.SectionsPinnedID.forEach(async (value, key) => {
            if (entity.id == value.entityID) value.callback()
          })
        })

        data.SectionsV1.Sections1.map(entity => {
          callbacks.Sections1.forEach(async (value, key) => {
            if (entity.id == value.entityID) value.callback()
          })
        })

        data.SectionV1.Section1.map(entity => {
          callbacks.Section1.forEach(async (value, key) => {
            if (entity.id == value.entityID) value.callback()
          })
        })
        data.SectionV1.SectionID.map(entity => {
          callbacks.SectionID.forEach(async (value, key) => {
            if (entity.id == value.entityID) value.callback()
          })
        })

        data.PopupV1.PopupWithName.map(entity => {
          callbacks.PopupWithName.forEach(async (value, key) => {
            if (entity.id == value.entityID) value.callback()
          })
        })
        data.PopupV1.PopupID.map(entity => {
          callbacks.PopupID.forEach(async (value, key) => {
            if (entity.id == value.entityID) value.callback()
          })
        })
        data.PopupV1.Popup1.map(entity => {
          callbacks.Popup1.forEach(async (value, key) => {
            if (entity.id == value.entityID) value.callback()
          })
        })

        data.BoxBlock.BoxBlock1.map(entity => {
          callbacks.BoxBlock1.forEach(async (value, key) => {
            if (entity.id == value.entityID) value.callback()
          })
        })

        data.Box.Box1.map(entity => {
          callbacks.Box1.forEach(async (value, key) => {
            if (entity.id == value.entityID) value.callback()
          })
        })

        data.ResponsiveBoxSettings.ResponsiveBoxSetting1.map(entity => {
          callbacks.ResponsiveBoxSetting1.forEach(async (value, key) => {
            if (entity.id == value.entityID) value.callback()
          })
        })

        data.BoxSettings.BoxSetting1.map(entity => {
          callbacks.BoxSetting1.forEach(async (value, key) => {
            if (entity.id == value.entityID) value.callback()
          })
        })

        data.BoxBackground.BoxBackground1.map(entity => {
          callbacks.BoxBackground1.forEach(async (value, key) => {
            if (entity.id == value.entityID) value.callback()
          })
        })

        data.Color.Color1.map(entity => {
          callbacks.Color1.forEach(async (value, key) => {
            if (entity.id == value.entityID) value.callback()
          })
        })

        data.BoxBorder.BoxBorder1.map(entity => {
          callbacks.BoxBorder1.forEach(async (value, key) => {
            if (entity.id == value.entityID) value.callback()
          })
        })

        data.BoxShadow.BoxShadow1.map(entity => {
          callbacks.BoxShadow1.forEach(async (value, key) => {
            if (entity.id == value.entityID) value.callback()
          })
        })

        data.LinkV1.Link1.map(entity => {
          callbacks.Link1.forEach(async (value, key) => {
            if (entity.id == value.entityID) value.callback()
          })
        })

        data.TextComponent.TextComponent1.map(entity => {
          callbacks.TextComponent1.forEach(async (value, key) => {
            if (entity.id == value.entityID) value.callback()
          })
        })

        data.TextSettings.TextSettings1.map(entity => {
          callbacks.TextSettings1.forEach(async (value, key) => {
            if (entity.id == value.entityID) value.callback()
          })
        })

        data.FontWeight.FontWeight1.map(entity => {
          callbacks.FontWeight1.forEach(async (value, key) => {
            if (entity.id == value.entityID) value.callback()
          })
        })

        data.ImageComponent.ImageComponent1.map(entity => {
          callbacks.ImageComponent1.forEach(async (value, key) => {
            if (entity.id == value.entityID) value.callback()
          })
        })

        data.FormComponent.FormComponent1.map(entity => {
          callbacks.FormComponent1.forEach(async (value, key) => {
            if (entity.id == value.entityID) value.callback()
          })
        })

        data.FormV1.Form1.map(entity => {
          callbacks.Form1.forEach(async (value, key) => {
            if (entity.id == value.entityID) value.callback()
          })
        })

        data.ExtraInputV1.ExtraInput1.map(entity => {
          callbacks.ExtraInput1.forEach(async (value, key) => {
            if (entity.id == value.entityID) value.callback()
          })
        })

        data.QuizComponent.QuizComponent1.map(entity => {
          callbacks.QuizComponent1.forEach(async (value, key) => {
            if (entity.id == value.entityID) value.callback()
          })
        })

        data.QuizV1.Quiz1.map(entity => {
          callbacks.Quiz1.forEach(async (value, key) => {
            if (entity.id == value.entityID) value.callback()
          })
        })

        data.QuizV1StepV1.QuizStep1.map(entity => {
          callbacks.QuizStep1.forEach(async (value, key) => {
            if (entity.id == value.entityID) value.callback()
          })
        })

        data.QuizV1CheckboxStepV1.QuizCheckboxStep1.map(entity => {
          callbacks.QuizCheckboxStep1.forEach(async (value, key) => {
            if (entity.id == value.entityID) value.callback()
          })
        })

        data.QuizV1CheckboxItemV1.QuizCheckboxStepItem1.map(entity => {
          callbacks.QuizCheckboxStepItem1.forEach(async (value, key) => {
            if (entity.id == value.entityID) value.callback()
          })
        })

        data.QuizV1RadioStepV1.QuizRadioStep1.map(entity => {
          callbacks.QuizRadioStep1.forEach(async (value, key) => {
            if (entity.id == value.entityID) value.callback()
          })
        })

        data.QuizV1RadioItemV1.QuizRadioStepItem1.map(entity => {
          callbacks.QuizRadioStepItem1.forEach(async (value, key) => {
            if (entity.id == value.entityID) value.callback()
          })
        })

        data.QuizV1FieldInputStepV1.QuizFieldInputStep1.map(entity => {
          callbacks.QuizFieldInputStep1.forEach(async (value, key) => {
            if (entity.id == value.entityID) value.callback()
          })
        })

        data.VideoComponent.VideoComponent1.map(entity => {
          callbacks.VideoComponent1.forEach(async (value, key) => {
            if (entity.id == value.entityID) value.callback()
          })
        })

        data.FaqComponent.FaqComponent1.map(entity => {
          callbacks.FaqComponent1.forEach(async (value, key) => {
            if (entity.id == value.entityID) value.callback()
          })
        })

        data.FaqComponentItem.FaqComponentItem1.map(entity => {
          callbacks.FaqComponentItem1.forEach(async (value, key) => {
            if (entity.id == value.entityID) value.callback()
          })
        })

        data.MapComponent.MapComponent1.map(entity => {
          callbacks.MapComponent1.forEach(async (value, key) => {
            if (entity.id == value.entityID) value.callback()
          })
        })

        data.MapComponentPoint.MapComponentPoint1.map(entity => {
          callbacks.MapComponentPoint1.forEach(async (value, key) => {
            if (entity.id == value.entityID) value.callback()
          })
        })

        data.CodeComponent.CodeComponent1.map(entity => {
          callbacks.CodeComponent1.forEach(async (value, key) => {
            if (entity.id == value.entityID) value.callback()
          })
        })

        data.WBotComponent.WhatsAppBotComponent1.map(entity => {
          callbacks.WhatsAppBotComponent1.forEach(async (value, key) => {
            if (entity.id == value.entityID) value.callback()
          })
        })

        data.WhatsAppBotLink.WhatsAppBotLink1.map(entity => {
          callbacks.WhatsAppBotLink1.forEach(async (value, key) => {
            if (entity.id == value.entityID) value.callback()
          })
        })

        data.TableColumn.TableColumnSimple.map(entity => {
          callbacks.TableColumnSimple.forEach(async (value, key) => {
            if (entity.id == value.entityID) value.callback()
          })
        })
        data.TableColumn.TableColumnAtBoxAtSchema.map(entity => {
          callbacks.TableColumnAtBoxAtSchema.forEach(async (value, key) => {
            if (entity.id == value.entityID) value.callback()
          })
        })
        data.TableColumn.TableColumnAtBox.map(entity => {
          callbacks.TableColumnAtBox.forEach(async (value, key) => {
            if (entity.id == value.entityID) value.callback()
          })
        })
        data.TableColumn.TableColumn1.map(entity => {
          callbacks.TableColumn1.forEach(async (value, key) => {
            if (entity.id == value.entityID) value.callback()
          })
        })

        data.Table.TableAtBox.map(entity => {
          callbacks.TableAtBox.forEach(async (value, key) => {
            if (entity.id == value.entityID) value.callback()
          })
        })
        data.Table.TableWithID.map(entity => {
          callbacks.TableWithID.forEach(async (value, key) => {
            if (entity.id == value.entityID) value.callback()
          })
        })
        data.Table.Table1.map(entity => {
          callbacks.Table1.forEach(async (value, key) => {
            if (entity.id == value.entityID) value.callback()
          })
        })

        data.TableConnector.TableConnectorAtBox.map(entity => {
          callbacks.TableConnectorAtBox.forEach(async (value, key) => {
            if (entity.id == value.entityID) value.callback()
          })
        })
        data.TableConnector.TableConnectorWithID.map(entity => {
          callbacks.TableConnectorWithID.forEach(async (value, key) => {
            if (entity.id == value.entityID) value.callback()
          })
        })
        data.TableConnector.TableConnector1.map(entity => {
          callbacks.TableConnector1.forEach(async (value, key) => {
            if (entity.id == value.entityID) value.callback()
          })
        })

        data.TableData.TableDataAtBox.map(entity => {
          callbacks.TableDataAtBox.forEach(async (value, key) => {
            if (entity.id == value.entityID) value.callback()
          })
        })
        data.TableData.TableDataPinnedToPage.map(entity => {
          callbacks.TableDataPinnedToPage.forEach(async (value, key) => {
            if (entity.id == value.entityID) value.callback()
          })
        })
        data.TableData.TableData1.map(entity => {
          callbacks.TableData1.forEach(async (value, key) => {
            if (entity.id == value.entityID) value.callback()
          })
        })

        data.TableRow.TableRowAtBox.map(entity => {
          callbacks.TableRowAtBox.forEach(async (value, key) => {
            if (entity.id == value.entityID) value.callback()
          })
        })
        data.TableRow.TableDataRowPinnedToPage.map(entity => {
          callbacks.TableDataRowPinnedToPage.forEach(async (value, key) => {
            if (entity.id == value.entityID) value.callback()
          })
        })
        data.TableRow.TableDataRow1.map(entity => {
          callbacks.TableDataRow1.forEach(async (value, key) => {
            if (entity.id == value.entityID) value.callback()
          })
        })

        data.TableRowItem.TableRowItemAtBox.map(entity => {
          callbacks.TableRowItemAtBox.forEach(async (value, key) => {
            if (entity.id == value.entityID) value.callback()
          })
        })
        data.TableRowItem.TableDataRowItem1.map(entity => {
          callbacks.TableDataRowItem1.forEach(async (value, key) => {
            if (entity.id == value.entityID) value.callback()
          })
        })

        data.BlockCategory.BlockCategory1.map(entity => {
          callbacks.BlockCategory1.forEach(async (value, key) => {
            if (entity.id == value.entityID) value.callback()
          })
        })

        data.LeadV1.Lead1.map(entity => {
          callbacks.Lead1.forEach(async (value, key) => {
            if (entity.id == value.entityID) value.callback()
          })
        })

        data.GroupFont.GroupFont1.map(entity => {
          callbacks.GroupFont1.forEach(async (value, key) => {
            if (entity.id == value.entityID) value.callback()
          })
        })

        data.WhatsAppBot.WhatsAppBot1.map(entity => {
          callbacks.WhatsAppBot1.forEach(async (value, key) => {
            if (entity.id == value.entityID) value.callback()
          })
        })
      })
      if (dataForConnect) socket.emit('modelID', { modelID: dataForConnect.modelID, userToken: dataForConnect.userToken })
    })
  }
}

const SynchronFrontendEngine = () => {
  console.log('run SynchronFrontendEngine')

  let callbackRoot: (value: boolean) => void | undefined

  let currentModelID: string | undefined = undefined
  let userToken: string | undefined = undefined
  let connected = false

  const isNotConnected = ({ modelID }: { modelID: string }) =>
    !currentModelID || (typeof currentModelID == 'string' && currentModelID !== modelID) || !connected

  return {
    connect: ({
      callback,
      modelID,
      userToken: newUserToken,
    }: {
      callback: (value: boolean) => void
      modelID: string
      userToken: string
    }) => {
      userToken = newUserToken
      callbackRoot = callback
      if (socket) {
        if (isNotConnected({ modelID })) {
          connected = false
          socket.emit('modelID', { modelID, userToken })
        } else {
          callback(true)
        }
        currentModelID = modelID
      } else {
        dataForConnect = {
          modelID,
          userToken,
        }
      }
    },
    callback: (value: boolean) => {
      connected = value
      if (callbackRoot) callbackRoot(value)
    },
    getIsNotConnected: isNotConnected,
    getIsConnected: () => {
      return connected
    },
    changeIsConnect: (newConnected: boolean) => {
      connected = newConnected
    },
    emitConnect: () => {
      if (currentModelID && userToken) socket.emit('modelID', { modelID: currentModelID, userToken })
    },
    updatePartialData: {
      SystemDataWithStringID: ({
        id,
        data,
      }: {
        id: string
        data: Partial<{
          id: PrismaSelect['SystemDataWithStringID']['id']
          telegramFailSending: PrismaSelect['SystemDataWithStringID']['telegramFailSending']
        }>
      }) => {},
      DomainV1: ({
        id,
        data,
      }: {
        id: string
        data: Partial<{
          id: PrismaSelect['DomainV1']['id']
          domain: PrismaSelect['DomainV1']['domain']
          lastCertificateReleaseDate: PrismaSelect['DomainV1']['lastCertificateReleaseDate']
          userId: PrismaSelect['DomainV1']['userId']
        }>
      }) => {
        let dataDomain1: Partial<ForGetDataBySelectID['Domain1']> = {}

        if (typeof data['domain'] != 'undefined') dataDomain1['domain'] = data['domain']

        if (Object.keys(dataDomain1).length != 0) {
          const getEntityDomain1 = dataStore.Domain1.get(id)
          if (getEntityDomain1) {
            dataStore.Domain1.set(id, {
              ...getEntityDomain1,
              ...dataDomain1,
            })

            callbacks.Domain1.forEach(async (value, key) => {
              if (id == value.entityID) value.callback()
            })
          }
        }
      },
      TinkoffPayment: ({
        id,
        data,
      }: {
        id: string
        data: Partial<{
          id: PrismaSelect['TinkoffPayment']['id']
          createdAt: PrismaSelect['TinkoffPayment']['createdAt']
          updatedAt: PrismaSelect['TinkoffPayment']['updatedAt']
          userId: PrismaSelect['TinkoffPayment']['userId']
          amount: PrismaSelect['TinkoffPayment']['amount']
          requestInitData: PrismaSelect['TinkoffPayment']['requestInitData']
          responseInitData: PrismaSelect['TinkoffPayment']['responseInitData']
          paymentId: PrismaSelect['TinkoffPayment']['paymentId']
          token: PrismaSelect['TinkoffPayment']['token']
          confirmed: PrismaSelect['TinkoffPayment']['confirmed']
          confirmedNotificationData: PrismaSelect['TinkoffPayment']['confirmedNotificationData']
          confirmedAt: PrismaSelect['TinkoffPayment']['confirmedAt']
          authorized: PrismaSelect['TinkoffPayment']['authorized']
          authorizedNotificationData: PrismaSelect['TinkoffPayment']['authorizedNotificationData']
          authorizedAt: PrismaSelect['TinkoffPayment']['authorizedAt']
          rejected: PrismaSelect['TinkoffPayment']['rejected']
          rejectedNotificationData: PrismaSelect['TinkoffPayment']['rejectedNotificationData']
          rejectedAt: PrismaSelect['TinkoffPayment']['rejectedAt']
          refunded: PrismaSelect['TinkoffPayment']['refunded']
          refundedNotificationData: PrismaSelect['TinkoffPayment']['refundedNotificationData']
          refundedAt: PrismaSelect['TinkoffPayment']['refundedAt']
        }>
      }) => {},
      RobokassaPayment: ({
        id,
        data,
      }: {
        id: string
        data: Partial<{
          id: PrismaSelect['RobokassaPayment']['id']
          createdAt: PrismaSelect['RobokassaPayment']['createdAt']
          updatedAt: PrismaSelect['RobokassaPayment']['updatedAt']
          userId: PrismaSelect['RobokassaPayment']['userId']
          InvId: PrismaSelect['RobokassaPayment']['InvId']
          Recurring: PrismaSelect['RobokassaPayment']['Recurring']
          RecurringIsDisabled: PrismaSelect['RobokassaPayment']['RecurringIsDisabled']
          amount: PrismaSelect['RobokassaPayment']['amount']
          generatedPaymentURL: PrismaSelect['RobokassaPayment']['generatedPaymentURL']
          confirmed: PrismaSelect['RobokassaPayment']['confirmed']
          confirmedNotificationData: PrismaSelect['RobokassaPayment']['confirmedNotificationData']
          confirmedAt: PrismaSelect['RobokassaPayment']['confirmedAt']
        }>
      }) => {},
      IncomeBalance: ({
        id,
        data,
      }: {
        id: string
        data: Partial<{
          id: PrismaSelect['IncomeBalance']['id']
          createdAt: PrismaSelect['IncomeBalance']['createdAt']
          updatedAt: PrismaSelect['IncomeBalance']['updatedAt']
          userId: PrismaSelect['IncomeBalance']['userId']
          amount: PrismaSelect['IncomeBalance']['amount']
        }>
      }) => {},
      OutcomeBalance: ({
        id,
        data,
      }: {
        id: string
        data: Partial<{
          id: PrismaSelect['OutcomeBalance']['id']
          createdAt: PrismaSelect['OutcomeBalance']['createdAt']
          updatedAt: PrismaSelect['OutcomeBalance']['updatedAt']
          userId: PrismaSelect['OutcomeBalance']['userId']
          amount: PrismaSelect['OutcomeBalance']['amount']
        }>
      }) => {},
      PaidPlaceOutcomeBalance: ({
        id,
        data,
      }: {
        id: string
        data: Partial<{
          id: PrismaSelect['PaidPlaceOutcomeBalance']['id']
          createdAt: PrismaSelect['PaidPlaceOutcomeBalance']['createdAt']
          updatedAt: PrismaSelect['PaidPlaceOutcomeBalance']['updatedAt']
          userId: PrismaSelect['PaidPlaceOutcomeBalance']['userId']
          amount: PrismaSelect['PaidPlaceOutcomeBalance']['amount']
          paidPlaceId: PrismaSelect['PaidPlaceOutcomeBalance']['paidPlaceId']
          start: PrismaSelect['PaidPlaceOutcomeBalance']['start']
          end: PrismaSelect['PaidPlaceOutcomeBalance']['end']
        }>
      }) => {
        let dataPaidPlaceOutcomeBalance1: Partial<ForGetDataBySelectID['PaidPlaceOutcomeBalance1']> = {}

        if (Object.keys(dataPaidPlaceOutcomeBalance1).length != 0) {
          const getEntityPaidPlaceOutcomeBalance1 = dataStore.PaidPlaceOutcomeBalance1.get(id)
          if (getEntityPaidPlaceOutcomeBalance1) {
            dataStore.PaidPlaceOutcomeBalance1.set(id, {
              ...getEntityPaidPlaceOutcomeBalance1,
              ...dataPaidPlaceOutcomeBalance1,
            })

            callbacks.PaidPlaceOutcomeBalance1.forEach(async (value, key) => {
              if (id == value.entityID) value.callback()
            })
          }
        }
      },
      PartnerIncome: ({
        id,
        data,
      }: {
        id: string
        data: Partial<{
          id: PrismaSelect['PartnerIncome']['id']
          createdAt: PrismaSelect['PartnerIncome']['createdAt']
          updatedAt: PrismaSelect['PartnerIncome']['updatedAt']
          amount: PrismaSelect['PartnerIncome']['amount']
          paidPlaceOutcomeBalanceID: PrismaSelect['PartnerIncome']['paidPlaceOutcomeBalanceID']
          partnerID: PrismaSelect['PartnerIncome']['partnerID']
        }>
      }) => {},
      PartnerOutcome: ({
        id,
        data,
      }: {
        id: string
        data: Partial<{
          id: PrismaSelect['PartnerOutcome']['id']
          createdAt: PrismaSelect['PartnerOutcome']['createdAt']
          updatedAt: PrismaSelect['PartnerOutcome']['updatedAt']
          amount: PrismaSelect['PartnerOutcome']['amount']
          partnerID: PrismaSelect['PartnerOutcome']['partnerID']
        }>
      }) => {},
      Partner: ({
        id,
        data,
      }: {
        id: string
        data: Partial<{
          id: PrismaSelect['Partner']['id']
          createdAt: PrismaSelect['Partner']['createdAt']
          updatedAt: PrismaSelect['Partner']['updatedAt']
          monthPayment: PrismaSelect['Partner']['monthPayment']
          yearPayment: PrismaSelect['Partner']['yearPayment']
          monthPercent: PrismaSelect['Partner']['monthPercent']
          yearPercent: PrismaSelect['Partner']['yearPercent']
          balance: PrismaSelect['Partner']['balance']
          code: PrismaSelect['Partner']['code']
          partnerUserOwnerID: PrismaSelect['Partner']['partnerUserOwnerID']
        }>
      }) => {},
      GenerateGPTOutcomeBalance: ({
        id,
        data,
      }: {
        id: string
        data: Partial<{
          id: PrismaSelect['GenerateGPTOutcomeBalance']['id']
          createdAt: PrismaSelect['GenerateGPTOutcomeBalance']['createdAt']
          updatedAt: PrismaSelect['GenerateGPTOutcomeBalance']['updatedAt']
          userId: PrismaSelect['GenerateGPTOutcomeBalance']['userId']
          dayMonthYear: PrismaSelect['GenerateGPTOutcomeBalance']['dayMonthYear']
          amount: PrismaSelect['GenerateGPTOutcomeBalance']['amount']
        }>
      }) => {},
      User: ({
        id,
        data,
      }: {
        id: string
        data: Partial<{
          id: PrismaSelect['User']['id']
          createdAt: PrismaSelect['User']['createdAt']
          login: PrismaSelect['User']['login']
          password: PrismaSelect['User']['password']
          recoveryMailCode: PrismaSelect['User']['recoveryMailCode']
          recoverySentAt: PrismaSelect['User']['recoverySentAt']
          pinnedToPartnerID: PrismaSelect['User']['pinnedToPartnerID']
          mailConfirmed: PrismaSelect['User']['mailConfirmed']
          confirmationMailCode: PrismaSelect['User']['confirmationMailCode']
          timeUserUsedFullFreeFunctional: PrismaSelect['User']['timeUserUsedFullFreeFunctional']
          lastDateRobokassaRecurringPaymentInit: PrismaSelect['User']['lastDateRobokassaRecurringPaymentInit']
          balance: PrismaSelect['User']['balance']
          monthPayment: PrismaSelect['User']['monthPayment']
          paymentForYearPerMonth: PrismaSelect['User']['paymentForYearPerMonth']
          dailyPayment: PrismaSelect['User']['dailyPayment']
          paid: PrismaSelect['User']['paid']
          lastPaymentTime: PrismaSelect['User']['lastPaymentTime']
          unlimited: PrismaSelect['User']['unlimited']
          blocked: PrismaSelect['User']['blocked']
          isAdmin: PrismaSelect['User']['isAdmin']
        }>
      }) => {
        let dataUserSelect1: Partial<ForGetDataBySelectID['UserSelect1']> = {}

        if (typeof data['login'] != 'undefined') dataUserSelect1['login'] = data['login']
        if (typeof data['isAdmin'] != 'undefined') dataUserSelect1['isAdmin'] = data['isAdmin']

        if (Object.keys(dataUserSelect1).length != 0) {
          const getEntityUserSelect1 = dataStore.UserSelect1.get(id)
          if (getEntityUserSelect1) {
            dataStore.UserSelect1.set(id, {
              ...getEntityUserSelect1,
              ...dataUserSelect1,
            })

            callbacks.UserSelect1.forEach(async (value, key) => {
              if (id == value.entityID) value.callback()
            })
          }
        }
      },
      TelegramUser: ({
        id,
        data,
      }: {
        id: string
        data: Partial<{
          id: PrismaSelect['TelegramUser']['id']
          createdAt: PrismaSelect['TelegramUser']['createdAt']
          chatID: PrismaSelect['TelegramUser']['chatID']
          userID: PrismaSelect['TelegramUser']['userID']
          userName: PrismaSelect['TelegramUser']['userName']
          firstName: PrismaSelect['TelegramUser']['firstName']
          lastName: PrismaSelect['TelegramUser']['lastName']
        }>
      }) => {
        let dataTelegramUser1: Partial<ForGetDataBySelectID['TelegramUser1']> = {}

        if (typeof data['userName'] != 'undefined') dataTelegramUser1['userName'] = data['userName']
        if (typeof data['firstName'] != 'undefined') dataTelegramUser1['firstName'] = data['firstName']
        if (typeof data['lastName'] != 'undefined') dataTelegramUser1['lastName'] = data['lastName']

        if (Object.keys(dataTelegramUser1).length != 0) {
          const getEntityTelegramUser1 = dataStore.TelegramUser1.get(id)
          if (getEntityTelegramUser1) {
            dataStore.TelegramUser1.set(id, {
              ...getEntityTelegramUser1,
              ...dataTelegramUser1,
            })

            callbacks.TelegramUser1.forEach(async (value, key) => {
              if (id == value.entityID) value.callback()
            })
          }
        }
      },
      TelegramNotification: ({
        id,
        data,
      }: {
        id: string
        data: Partial<{
          id: PrismaSelect['TelegramNotification']['id']
          createdAt: PrismaSelect['TelegramNotification']['createdAt']
          telegramUserID: PrismaSelect['TelegramNotification']['telegramUserID']
          message: PrismaSelect['TelegramNotification']['message']
          failedSending: PrismaSelect['TelegramNotification']['failedSending']
          failedSendingResponseJSON: PrismaSelect['TelegramNotification']['failedSendingResponseJSON']
        }>
      }) => {},
      Color: ({
        id,
        data,
      }: {
        id: string
        data: Partial<{
          createdAt: PrismaSelect['Color']['createdAt']
          updatedAt: PrismaSelect['Color']['updatedAt']
          id: PrismaSelect['Color']['id']
          siteV1Id: PrismaSelect['Color']['siteV1Id']
          name: PrismaSelect['Color']['name']
          viewName: PrismaSelect['Color']['viewName']
          value: PrismaSelect['Color']['value']
          originalID: PrismaSelect['Color']['originalID']
        }>
      }) => {
        let dataColor1: Partial<ForGetDataBySelectID['Color1']> = {}

        if (typeof data['name'] != 'undefined') dataColor1['name'] = data['name']
        if (typeof data['viewName'] != 'undefined') dataColor1['viewName'] = data['viewName']
        if (typeof data['value'] != 'undefined') dataColor1['value'] = data['value']

        if (Object.keys(dataColor1).length != 0) {
          const getEntityColor1 = dataStore.Color1.get(id)
          if (getEntityColor1) {
            dataStore.Color1.set(id, {
              ...getEntityColor1,
              ...dataColor1,
            })

            callbacks.Color1.forEach(async (value, key) => {
              if (id == value.entityID) value.callback()
            })
          }
        }
      },
      CompanyPhone: ({
        id,
        data,
      }: {
        id: string
        data: Partial<{
          id: PrismaSelect['CompanyPhone']['id']
          siteV1Id: PrismaSelect['CompanyPhone']['siteV1Id']
          phone: PrismaSelect['CompanyPhone']['phone']
          text: PrismaSelect['CompanyPhone']['text']
        }>
      }) => {},
      CompanyAddress: ({
        id,
        data,
      }: {
        id: string
        data: Partial<{
          id: PrismaSelect['CompanyAddress']['id']
          siteV1Id: PrismaSelect['CompanyAddress']['siteV1Id']
          address: PrismaSelect['CompanyAddress']['address']
          addressLng: PrismaSelect['CompanyAddress']['addressLng']
          addressLat: PrismaSelect['CompanyAddress']['addressLat']
        }>
      }) => {},
      PageV1: ({
        id,
        data,
      }: {
        id: string
        data: Partial<{
          id: PrismaSelect['PageV1']['id']
          order: PrismaSelect['PageV1']['order']
          createdAt: PrismaSelect['PageV1']['createdAt']
          updatedAt: PrismaSelect['PageV1']['updatedAt']
          pathname: PrismaSelect['PageV1']['pathname']
          hidden: PrismaSelect['PageV1']['hidden']
          title: PrismaSelect['PageV1']['title']
          description: PrismaSelect['PageV1']['description']
          siteV1Id: PrismaSelect['PageV1']['siteV1Id']
          showFooterSections: PrismaSelect['PageV1']['showFooterSections']
          showHeaderSections: PrismaSelect['PageV1']['showHeaderSections']
          pinTableID: PrismaSelect['PageV1']['pinTableID']
        }>
      }) => {
        let dataPageOnlyWithFields: Partial<ForGetDataBySelectID['PageOnlyWithFields']> = {}

        if (typeof data['pathname'] != 'undefined') dataPageOnlyWithFields['pathname'] = data['pathname']
        if (typeof data['title'] != 'undefined') dataPageOnlyWithFields['title'] = data['title']
        if (typeof data['description'] != 'undefined') dataPageOnlyWithFields['description'] = data['description']

        if (Object.keys(dataPageOnlyWithFields).length != 0) {
          const getEntityPageOnlyWithFields = dataStore.PageOnlyWithFields.get(id)
          if (getEntityPageOnlyWithFields) {
            dataStore.PageOnlyWithFields.set(id, {
              ...getEntityPageOnlyWithFields,
              ...dataPageOnlyWithFields,
            })

            callbacks.PageOnlyWithFields.forEach(async (value, key) => {
              if (id == value.entityID) value.callback()
            })
          }
        }

        let dataPage1: Partial<ForGetDataBySelectID['Page1']> = {}

        if (typeof data['order'] != 'undefined') dataPage1['order'] = data['order']
        if (typeof data['pathname'] != 'undefined') dataPage1['pathname'] = data['pathname']
        if (typeof data['title'] != 'undefined') dataPage1['title'] = data['title']
        if (typeof data['description'] != 'undefined') dataPage1['description'] = data['description']
        if (typeof data['showFooterSections'] != 'undefined') dataPage1['showFooterSections'] = data['showFooterSections']
        if (typeof data['showHeaderSections'] != 'undefined') dataPage1['showHeaderSections'] = data['showHeaderSections']

        if (Object.keys(dataPage1).length != 0) {
          const getEntityPage1 = dataStore.Page1.get(id)
          if (getEntityPage1) {
            dataStore.Page1.set(id, {
              ...getEntityPage1,
              ...dataPage1,
            })

            callbacks.Page1.forEach(async (value, key) => {
              if (id == value.entityID) value.callback()
            })
          }
        }

        let dataPageForLink: Partial<ForGetDataBySelectID['PageForLink']> = {}

        if (typeof data['pathname'] != 'undefined') dataPageForLink['pathname'] = data['pathname']

        if (Object.keys(dataPageForLink).length != 0) {
          const getEntityPageForLink = dataStore.PageForLink.get(id)
          if (getEntityPageForLink) {
            dataStore.PageForLink.set(id, {
              ...getEntityPageForLink,
              ...dataPageForLink,
            })

            callbacks.PageForLink.forEach(async (value, key) => {
              if (id == value.entityID) value.callback()
            })
          }
        }
      },
      SectionsPinned: ({
        id,
        data,
      }: {
        id: string
        data: Partial<{
          id: PrismaSelect['SectionsPinned']['id']
          pageId: PrismaSelect['SectionsPinned']['pageId']
          footerSectionsId: PrismaSelect['SectionsPinned']['footerSectionsId']
          headerSectionsId: PrismaSelect['SectionsPinned']['headerSectionsId']
          order: PrismaSelect['SectionsPinned']['order']
          sectionsCollectionId: PrismaSelect['SectionsPinned']['sectionsCollectionId']
          isPinned: PrismaSelect['SectionsPinned']['isPinned']
        }>
      }) => {
        let dataSectionsPinned1: Partial<ForGetDataBySelectID['SectionsPinned1']> = {}

        if (typeof data['order'] != 'undefined') dataSectionsPinned1['order'] = data['order']
        if (typeof data['isPinned'] != 'undefined') dataSectionsPinned1['isPinned'] = data['isPinned']

        if (Object.keys(dataSectionsPinned1).length != 0) {
          const getEntitySectionsPinned1 = dataStore.SectionsPinned1.get(id)
          if (getEntitySectionsPinned1) {
            dataStore.SectionsPinned1.set(id, {
              ...getEntitySectionsPinned1,
              ...dataSectionsPinned1,
            })

            callbacks.SectionsPinned1.forEach(async (value, key) => {
              if (id == value.entityID) value.callback()
            })
          }
        }

        let dataSectionsPinnedID: Partial<ForGetDataBySelectID['SectionsPinnedID']> = {}

        if (Object.keys(dataSectionsPinnedID).length != 0) {
          const getEntitySectionsPinnedID = dataStore.SectionsPinnedID.get(id)
          if (getEntitySectionsPinnedID) {
            dataStore.SectionsPinnedID.set(id, {
              ...getEntitySectionsPinnedID,
              ...dataSectionsPinnedID,
            })

            callbacks.SectionsPinnedID.forEach(async (value, key) => {
              if (id == value.entityID) value.callback()
            })
          }
        }
      },
      SectionsV1: ({
        id,
        data,
      }: {
        id: string
        data: Partial<{
          createdAt: PrismaSelect['SectionsV1']['createdAt']
          siteV1Id: PrismaSelect['SectionsV1']['siteV1Id']
          id: PrismaSelect['SectionsV1']['id']
        }>
      }) => {
        let dataSections1: Partial<ForGetDataBySelectID['Sections1']> = {}

        if (Object.keys(dataSections1).length != 0) {
          const getEntitySections1 = dataStore.Sections1.get(id)
          if (getEntitySections1) {
            dataStore.Sections1.set(id, {
              ...getEntitySections1,
              ...dataSections1,
            })

            callbacks.Sections1.forEach(async (value, key) => {
              if (id == value.entityID) value.callback()
            })
          }
        }
      },
      SectionV1: ({
        id,
        data,
      }: {
        id: string
        data: Partial<{
          order: PrismaSelect['SectionV1']['order']
          id: PrismaSelect['SectionV1']['id']
          createdAt: PrismaSelect['SectionV1']['createdAt']
          updatedAt: PrismaSelect['SectionV1']['updatedAt']
          hidden: PrismaSelect['SectionV1']['hidden']
          sectionParentsId: PrismaSelect['SectionV1']['sectionParentsId']
          linkText: PrismaSelect['SectionV1']['linkText']
          showLinkInHeader: PrismaSelect['SectionV1']['showLinkInHeader']
          popupId: PrismaSelect['SectionV1']['popupId']
          boxBlockId: PrismaSelect['SectionV1']['boxBlockId']
        }>
      }) => {
        let dataSection1: Partial<ForGetDataBySelectID['Section1']> = {}

        if (typeof data['order'] != 'undefined') dataSection1['order'] = data['order']

        if (Object.keys(dataSection1).length != 0) {
          const getEntitySection1 = dataStore.Section1.get(id)
          if (getEntitySection1) {
            dataStore.Section1.set(id, {
              ...getEntitySection1,
              ...dataSection1,
            })

            callbacks.Section1.forEach(async (value, key) => {
              if (id == value.entityID) value.callback()
            })
          }
        }

        let dataSectionID: Partial<ForGetDataBySelectID['SectionID']> = {}

        if (Object.keys(dataSectionID).length != 0) {
          const getEntitySectionID = dataStore.SectionID.get(id)
          if (getEntitySectionID) {
            dataStore.SectionID.set(id, {
              ...getEntitySectionID,
              ...dataSectionID,
            })

            callbacks.SectionID.forEach(async (value, key) => {
              if (id == value.entityID) value.callback()
            })
          }
        }
      },
      PaidPlace: ({
        id,
        data,
      }: {
        id: string
        data: Partial<{
          createdAt: PrismaSelect['PaidPlace']['createdAt']
          updatedAt: PrismaSelect['PaidPlace']['updatedAt']
          id: PrismaSelect['PaidPlace']['id']
          name: PrismaSelect['PaidPlace']['name']
          userId: PrismaSelect['PaidPlace']['userId']
          isArchive: PrismaSelect['PaidPlace']['isArchive']
          isFree: PrismaSelect['PaidPlace']['isFree']
          paidUntil: PrismaSelect['PaidPlace']['paidUntil']
          notifiedAboutPaymentBeforeThreeDays: PrismaSelect['PaidPlace']['notifiedAboutPaymentBeforeThreeDays']
          notifiedAboutPaymentBeforeTwoDays: PrismaSelect['PaidPlace']['notifiedAboutPaymentBeforeTwoDays']
          notifiedAboutPaymentBeforeOneDays: PrismaSelect['PaidPlace']['notifiedAboutPaymentBeforeOneDays']
          notifiedAboutPaymentBeforeZeroDays: PrismaSelect['PaidPlace']['notifiedAboutPaymentBeforeZeroDays']
        }>
      }) => {
        let dataPaidPlace1: Partial<ForGetDataBySelectID['PaidPlace1']> = {}

        if (typeof data['isFree'] != 'undefined') dataPaidPlace1['isFree'] = data['isFree']
        if (typeof data['paidUntil'] != 'undefined') dataPaidPlace1['paidUntil'] = data['paidUntil']

        if (Object.keys(dataPaidPlace1).length != 0) {
          const getEntityPaidPlace1 = dataStore.PaidPlace1.get(id)
          if (getEntityPaidPlace1) {
            dataStore.PaidPlace1.set(id, {
              ...getEntityPaidPlace1,
              ...dataPaidPlace1,
            })

            callbacks.PaidPlace1.forEach(async (value, key) => {
              if (id == value.entityID) value.callback()
            })
          }
        }
      },
      TelegramUnsubsribeButWantsGift: ({
        id,
        data,
      }: {
        id: string
        data: Partial<{
          createdAt: PrismaSelect['TelegramUnsubsribeButWantsGift']['createdAt']
          updatedAt: PrismaSelect['TelegramUnsubsribeButWantsGift']['updatedAt']
          id: PrismaSelect['TelegramUnsubsribeButWantsGift']['id']
          userBigID: PrismaSelect['TelegramUnsubsribeButWantsGift']['userBigID']
          telegramGiftID: PrismaSelect['TelegramUnsubsribeButWantsGift']['telegramGiftID']
        }>
      }) => {},
      TelegramGiftRecipient: ({
        id,
        data,
      }: {
        id: string
        data: Partial<{
          createdAt: PrismaSelect['TelegramGiftRecipient']['createdAt']
          updatedAt: PrismaSelect['TelegramGiftRecipient']['updatedAt']
          id: PrismaSelect['TelegramGiftRecipient']['id']
          userBigID: PrismaSelect['TelegramGiftRecipient']['userBigID']
          userChatID: PrismaSelect['TelegramGiftRecipient']['userChatID']
          subscribed: PrismaSelect['TelegramGiftRecipient']['subscribed']
          goalIsLaunched: PrismaSelect['TelegramGiftRecipient']['goalIsLaunched']
          telegramGiftID: PrismaSelect['TelegramGiftRecipient']['telegramGiftID']
        }>
      }) => {},
      TelegramGift: ({
        id,
        data,
      }: {
        id: string
        data: Partial<{
          createdAt: PrismaSelect['TelegramGift']['createdAt']
          updatedAt: PrismaSelect['TelegramGift']['updatedAt']
          id: PrismaSelect['TelegramGift']['id']
          messageStringBigID: PrismaSelect['TelegramGift']['messageStringBigID']
          postBodyText: PrismaSelect['TelegramGift']['postBodyText']
          postLinkText: PrismaSelect['TelegramGift']['postLinkText']
          postImageID: PrismaSelect['TelegramGift']['postImageID']
          botBodyText: PrismaSelect['TelegramGift']['botBodyText']
          botLinkText: PrismaSelect['TelegramGift']['botLinkText']
          botDenyText: PrismaSelect['TelegramGift']['botDenyText']
          botPageID: PrismaSelect['TelegramGift']['botPageID']
          botImageID: PrismaSelect['TelegramGift']['botImageID']
          telegramChannelID: PrismaSelect['TelegramGift']['telegramChannelID']
          targetID: PrismaSelect['TelegramGift']['targetID']
          botID: PrismaSelect['TelegramGift']['botID']
        }>
      }) => {
        let dataTelegramGift1: Partial<ForGetDataBySelectID['TelegramGift1']> = {}

        if (typeof data['messageStringBigID'] != 'undefined')
          dataTelegramGift1['messageStringBigID'] = data['messageStringBigID']
        if (typeof data['postBodyText'] != 'undefined') dataTelegramGift1['postBodyText'] = data['postBodyText']
        if (typeof data['postLinkText'] != 'undefined') dataTelegramGift1['postLinkText'] = data['postLinkText']
        if (typeof data['botBodyText'] != 'undefined') dataTelegramGift1['botBodyText'] = data['botBodyText']
        if (typeof data['botLinkText'] != 'undefined') dataTelegramGift1['botLinkText'] = data['botLinkText']
        if (typeof data['botDenyText'] != 'undefined') dataTelegramGift1['botDenyText'] = data['botDenyText']

        if (Object.keys(dataTelegramGift1).length != 0) {
          const getEntityTelegramGift1 = dataStore.TelegramGift1.get(id)
          if (getEntityTelegramGift1) {
            dataStore.TelegramGift1.set(id, {
              ...getEntityTelegramGift1,
              ...dataTelegramGift1,
            })

            callbacks.TelegramGift1.forEach(async (value, key) => {
              if (id == value.entityID) value.callback()
            })
          }
        }
      },
      TelegramChannel: ({
        id,
        data,
      }: {
        id: string
        data: Partial<{
          createdAt: PrismaSelect['TelegramChannel']['createdAt']
          updatedAt: PrismaSelect['TelegramChannel']['updatedAt']
          id: PrismaSelect['TelegramChannel']['id']
          channelBigChatID: PrismaSelect['TelegramChannel']['channelBigChatID']
          channelTitle: PrismaSelect['TelegramChannel']['channelTitle']
          channelUserName: PrismaSelect['TelegramChannel']['channelUserName']
          siteID: PrismaSelect['TelegramChannel']['siteID']
        }>
      }) => {
        let dataTelegramChannel1: Partial<ForGetDataBySelectID['TelegramChannel1']> = {}

        if (typeof data['channelTitle'] != 'undefined') dataTelegramChannel1['channelTitle'] = data['channelTitle']
        if (typeof data['channelUserName'] != 'undefined') dataTelegramChannel1['channelUserName'] = data['channelUserName']

        if (Object.keys(dataTelegramChannel1).length != 0) {
          const getEntityTelegramChannel1 = dataStore.TelegramChannel1.get(id)
          if (getEntityTelegramChannel1) {
            dataStore.TelegramChannel1.set(id, {
              ...getEntityTelegramChannel1,
              ...dataTelegramChannel1,
            })

            callbacks.TelegramChannel1.forEach(async (value, key) => {
              if (id == value.entityID) value.callback()
            })
          }
        }
      },
      TelegramPersonalBot: ({
        id,
        data,
      }: {
        id: string
        data: Partial<{
          createdAt: PrismaSelect['TelegramPersonalBot']['createdAt']
          updatedAt: PrismaSelect['TelegramPersonalBot']['updatedAt']
          id: PrismaSelect['TelegramPersonalBot']['id']
          errorAtLaunch: PrismaSelect['TelegramPersonalBot']['errorAtLaunch']
          botID: PrismaSelect['TelegramPersonalBot']['botID']
          apiToken: PrismaSelect['TelegramPersonalBot']['apiToken']
          botName: PrismaSelect['TelegramPersonalBot']['botName']
          first_name: PrismaSelect['TelegramPersonalBot']['first_name']
          last_name: PrismaSelect['TelegramPersonalBot']['last_name']
          isDev: PrismaSelect['TelegramPersonalBot']['isDev']
          telegramChannelID: PrismaSelect['TelegramPersonalBot']['telegramChannelID']
        }>
      }) => {
        let dataTelegramPersonalBot1: Partial<ForGetDataBySelectID['TelegramPersonalBot1']> = {}

        if (typeof data['errorAtLaunch'] != 'undefined') dataTelegramPersonalBot1['errorAtLaunch'] = data['errorAtLaunch']
        if (typeof data['botName'] != 'undefined') dataTelegramPersonalBot1['botName'] = data['botName']
        if (typeof data['first_name'] != 'undefined') dataTelegramPersonalBot1['first_name'] = data['first_name']
        if (typeof data['last_name'] != 'undefined') dataTelegramPersonalBot1['last_name'] = data['last_name']

        if (Object.keys(dataTelegramPersonalBot1).length != 0) {
          const getEntityTelegramPersonalBot1 = dataStore.TelegramPersonalBot1.get(id)
          if (getEntityTelegramPersonalBot1) {
            dataStore.TelegramPersonalBot1.set(id, {
              ...getEntityTelegramPersonalBot1,
              ...dataTelegramPersonalBot1,
            })

            callbacks.TelegramPersonalBot1.forEach(async (value, key) => {
              if (id == value.entityID) value.callback()
            })
          }
        }
      },
      BlockCategory: ({
        id,
        data,
      }: {
        id: string
        data: Partial<{
          createdAt: PrismaSelect['BlockCategory']['createdAt']
          updatedAt: PrismaSelect['BlockCategory']['updatedAt']
          id: PrismaSelect['BlockCategory']['id']
          name: PrismaSelect['BlockCategory']['name']
          siteID: PrismaSelect['BlockCategory']['siteID']
        }>
      }) => {
        let dataBlockCategory1: Partial<ForGetDataBySelectID['BlockCategory1']> = {}

        if (typeof data['name'] != 'undefined') dataBlockCategory1['name'] = data['name']

        if (Object.keys(dataBlockCategory1).length != 0) {
          const getEntityBlockCategory1 = dataStore.BlockCategory1.get(id)
          if (getEntityBlockCategory1) {
            dataStore.BlockCategory1.set(id, {
              ...getEntityBlockCategory1,
              ...dataBlockCategory1,
            })

            callbacks.BlockCategory1.forEach(async (value, key) => {
              if (id == value.entityID) value.callback()
            })
          }
        }
      },
      SiteV1: ({
        id,
        data,
      }: {
        id: string
        data: Partial<{
          createdAt: PrismaSelect['SiteV1']['createdAt']
          updatedAt: PrismaSelect['SiteV1']['updatedAt']
          id: PrismaSelect['SiteV1']['id']
          bitrixAddLeadURL: PrismaSelect['SiteV1']['bitrixAddLeadURL']
          userId: PrismaSelect['SiteV1']['userId']
          moveToUserId: PrismaSelect['SiteV1']['moveToUserId']
          lastCacheUpdate: PrismaSelect['SiteV1']['lastCacheUpdate']
          telegramSiteNotificationConnectCode: PrismaSelect['SiteV1']['telegramSiteNotificationConnectCode']
          telegramSiteToChannelConfirmCode: PrismaSelect['SiteV1']['telegramSiteToChannelConfirmCode']
          telegramSiteToTelegramUserConfirmCode: PrismaSelect['SiteV1']['telegramSiteToTelegramUserConfirmCode']
          telegramGiftUserID: PrismaSelect['SiteV1']['telegramGiftUserID']
          withBlockGroups: PrismaSelect['SiteV1']['withBlockGroups']
          isTemplate: PrismaSelect['SiteV1']['isTemplate']
          templatePictureId: PrismaSelect['SiteV1']['templatePictureId']
          paidPlaceID: PrismaSelect['SiteV1']['paidPlaceID']
          leadEmail: PrismaSelect['SiteV1']['leadEmail']
          adminHidLabel: PrismaSelect['SiteV1']['adminHidLabel']
          faviconId: PrismaSelect['SiteV1']['faviconId']
          logoText: PrismaSelect['SiteV1']['logoText']
          logoSubText: PrismaSelect['SiteV1']['logoSubText']
          logoId: PrismaSelect['SiteV1']['logoId']
          customScript: PrismaSelect['SiteV1']['customScript']
          headScript: PrismaSelect['SiteV1']['headScript']
          name: PrismaSelect['SiteV1']['name']
          yandexMetrikaId: PrismaSelect['SiteV1']['yandexMetrikaId']
          metrikaApiKey: PrismaSelect['SiteV1']['metrikaApiKey']
          vkontaktePixelId: PrismaSelect['SiteV1']['vkontaktePixelId']
          domainV1Id: PrismaSelect['SiteV1']['domainV1Id']
          mainColorId: PrismaSelect['SiteV1']['mainColorId']
        }>
      }) => {
        let dataSite1: Partial<ForGetDataBySelectID['Site1']> = {}

        if (typeof data['createdAt'] != 'undefined') dataSite1['createdAt'] = data['createdAt']
        if (typeof data['bitrixAddLeadURL'] != 'undefined') dataSite1['bitrixAddLeadURL'] = data['bitrixAddLeadURL']
        if (typeof data['userId'] != 'undefined') dataSite1['userId'] = data['userId']
        if (typeof data['lastCacheUpdate'] != 'undefined') dataSite1['lastCacheUpdate'] = data['lastCacheUpdate']
        if (typeof data['telegramSiteNotificationConnectCode'] != 'undefined')
          dataSite1['telegramSiteNotificationConnectCode'] = data['telegramSiteNotificationConnectCode']
        if (typeof data['telegramSiteToChannelConfirmCode'] != 'undefined')
          dataSite1['telegramSiteToChannelConfirmCode'] = data['telegramSiteToChannelConfirmCode']
        if (typeof data['withBlockGroups'] != 'undefined') dataSite1['withBlockGroups'] = data['withBlockGroups']
        if (typeof data['isTemplate'] != 'undefined') dataSite1['isTemplate'] = data['isTemplate']
        if (typeof data['leadEmail'] != 'undefined') dataSite1['leadEmail'] = data['leadEmail']
        if (typeof data['logoText'] != 'undefined') dataSite1['logoText'] = data['logoText']
        if (typeof data['logoSubText'] != 'undefined') dataSite1['logoSubText'] = data['logoSubText']
        if (typeof data['customScript'] != 'undefined') dataSite1['customScript'] = data['customScript']
        if (typeof data['headScript'] != 'undefined') dataSite1['headScript'] = data['headScript']
        if (typeof data['name'] != 'undefined') dataSite1['name'] = data['name']
        if (typeof data['yandexMetrikaId'] != 'undefined') dataSite1['yandexMetrikaId'] = data['yandexMetrikaId']
        if (typeof data['metrikaApiKey'] != 'undefined') dataSite1['metrikaApiKey'] = data['metrikaApiKey']
        if (typeof data['vkontaktePixelId'] != 'undefined') dataSite1['vkontaktePixelId'] = data['vkontaktePixelId']

        if (Object.keys(dataSite1).length != 0) {
          const getEntitySite1 = dataStore.Site1.get(id)
          if (getEntitySite1) {
            dataStore.Site1.set(id, {
              ...getEntitySite1,
              ...dataSite1,
            })

            callbacks.Site1.forEach(async (value, key) => {
              if (id == value.entityID) value.callback()
            })
          }
        }
      },
      WhatsAppBot: ({
        id,
        data,
      }: {
        id: string
        data: Partial<{
          id: PrismaSelect['WhatsAppBot']['id']
          createdAt: PrismaSelect['WhatsAppBot']['createdAt']
          updatedAt: PrismaSelect['WhatsAppBot']['updatedAt']
          siteID: PrismaSelect['WhatsAppBot']['siteID']
          phone: PrismaSelect['WhatsAppBot']['phone']
          qrCode: PrismaSelect['WhatsAppBot']['qrCode']
          connected: PrismaSelect['WhatsAppBot']['connected']
        }>
      }) => {
        let dataWhatsAppBot1: Partial<ForGetDataBySelectID['WhatsAppBot1']> = {}

        if (typeof data['phone'] != 'undefined') dataWhatsAppBot1['phone'] = data['phone']
        if (typeof data['qrCode'] != 'undefined') dataWhatsAppBot1['qrCode'] = data['qrCode']
        if (typeof data['connected'] != 'undefined') dataWhatsAppBot1['connected'] = data['connected']

        if (Object.keys(dataWhatsAppBot1).length != 0) {
          const getEntityWhatsAppBot1 = dataStore.WhatsAppBot1.get(id)
          if (getEntityWhatsAppBot1) {
            dataStore.WhatsAppBot1.set(id, {
              ...getEntityWhatsAppBot1,
              ...dataWhatsAppBot1,
            })

            callbacks.WhatsAppBot1.forEach(async (value, key) => {
              if (id == value.entityID) value.callback()
            })
          }
        }
      },
      WhatsAppBotLink: ({
        id,
        data,
      }: {
        id: string
        data: Partial<{
          id: PrismaSelect['WhatsAppBotLink']['id']
          createdAt: PrismaSelect['WhatsAppBotLink']['createdAt']
          updatedAt: PrismaSelect['WhatsAppBotLink']['updatedAt']
          text: PrismaSelect['WhatsAppBotLink']['text']
          whatsAppBotID: PrismaSelect['WhatsAppBotLink']['whatsAppBotID']
          targetID: PrismaSelect['WhatsAppBotLink']['targetID']
        }>
      }) => {
        let dataWhatsAppBotLink1: Partial<ForGetDataBySelectID['WhatsAppBotLink1']> = {}

        if (typeof data['text'] != 'undefined') dataWhatsAppBotLink1['text'] = data['text']

        if (Object.keys(dataWhatsAppBotLink1).length != 0) {
          const getEntityWhatsAppBotLink1 = dataStore.WhatsAppBotLink1.get(id)
          if (getEntityWhatsAppBotLink1) {
            dataStore.WhatsAppBotLink1.set(id, {
              ...getEntityWhatsAppBotLink1,
              ...dataWhatsAppBotLink1,
            })

            callbacks.WhatsAppBotLink1.forEach(async (value, key) => {
              if (id == value.entityID) value.callback()
            })
          }
        }
      },
      WhatsAppBotTarget: ({
        id,
        data,
      }: {
        id: string
        data: Partial<{
          id: PrismaSelect['WhatsAppBotTarget']['id']
          createdAt: PrismaSelect['WhatsAppBotTarget']['createdAt']
          updatedAt: PrismaSelect['WhatsAppBotTarget']['updatedAt']
          triggeredAt: PrismaSelect['WhatsAppBotTarget']['triggeredAt']
          whatsAppBotLinkID: PrismaSelect['WhatsAppBotTarget']['whatsAppBotLinkID']
          metrikaID: PrismaSelect['WhatsAppBotTarget']['metrikaID']
        }>
      }) => {},
      WhatsAppMetrikaUserShortID: ({
        id,
        data,
      }: {
        id: string
        data: Partial<{
          id: PrismaSelect['WhatsAppMetrikaUserShortID']['id']
          createdAt: PrismaSelect['WhatsAppMetrikaUserShortID']['createdAt']
          updatedAt: PrismaSelect['WhatsAppMetrikaUserShortID']['updatedAt']
          whatsAppBotLinkID: PrismaSelect['WhatsAppMetrikaUserShortID']['whatsAppBotLinkID']
          triggeredAt: PrismaSelect['WhatsAppMetrikaUserShortID']['triggeredAt']
          metrikaID: PrismaSelect['WhatsAppMetrikaUserShortID']['metrikaID']
          shortCodeID: PrismaSelect['WhatsAppMetrikaUserShortID']['shortCodeID']
        }>
      }) => {},
      TableConnector: ({
        id,
        data,
      }: {
        id: string
        data: Partial<{
          id: PrismaSelect['TableConnector']['id']
          createdAt: PrismaSelect['TableConnector']['createdAt']
          updatedAt: PrismaSelect['TableConnector']['updatedAt']
          siteID: PrismaSelect['TableConnector']['siteID']
          tableSchemaID: PrismaSelect['TableConnector']['tableSchemaID']
          tableDataID: PrismaSelect['TableConnector']['tableDataID']
        }>
      }) => {
        let dataTableConnectorAtBox: Partial<ForGetDataBySelectID['TableConnectorAtBox']> = {}

        if (Object.keys(dataTableConnectorAtBox).length != 0) {
          const getEntityTableConnectorAtBox = dataStore.TableConnectorAtBox.get(id)
          if (getEntityTableConnectorAtBox) {
            dataStore.TableConnectorAtBox.set(id, {
              ...getEntityTableConnectorAtBox,
              ...dataTableConnectorAtBox,
            })

            callbacks.TableConnectorAtBox.forEach(async (value, key) => {
              if (id == value.entityID) value.callback()
            })
          }
        }

        let dataTableConnectorWithID: Partial<ForGetDataBySelectID['TableConnectorWithID']> = {}

        if (Object.keys(dataTableConnectorWithID).length != 0) {
          const getEntityTableConnectorWithID = dataStore.TableConnectorWithID.get(id)
          if (getEntityTableConnectorWithID) {
            dataStore.TableConnectorWithID.set(id, {
              ...getEntityTableConnectorWithID,
              ...dataTableConnectorWithID,
            })

            callbacks.TableConnectorWithID.forEach(async (value, key) => {
              if (id == value.entityID) value.callback()
            })
          }
        }

        let dataTableConnector1: Partial<ForGetDataBySelectID['TableConnector1']> = {}

        if (Object.keys(dataTableConnector1).length != 0) {
          const getEntityTableConnector1 = dataStore.TableConnector1.get(id)
          if (getEntityTableConnector1) {
            dataStore.TableConnector1.set(id, {
              ...getEntityTableConnector1,
              ...dataTableConnector1,
            })

            callbacks.TableConnector1.forEach(async (value, key) => {
              if (id == value.entityID) value.callback()
            })
          }
        }
      },
      Table: ({
        id,
        data,
      }: {
        id: string
        data: Partial<{
          id: PrismaSelect['Table']['id']
          createdAt: PrismaSelect['Table']['createdAt']
          updatedAt: PrismaSelect['Table']['updatedAt']
          name: PrismaSelect['Table']['name']
          siteID: PrismaSelect['Table']['siteID']
        }>
      }) => {
        let dataTableAtBox: Partial<ForGetDataBySelectID['TableAtBox']> = {}

        if (typeof data['name'] != 'undefined') dataTableAtBox['name'] = data['name']

        if (Object.keys(dataTableAtBox).length != 0) {
          const getEntityTableAtBox = dataStore.TableAtBox.get(id)
          if (getEntityTableAtBox) {
            dataStore.TableAtBox.set(id, {
              ...getEntityTableAtBox,
              ...dataTableAtBox,
            })

            callbacks.TableAtBox.forEach(async (value, key) => {
              if (id == value.entityID) value.callback()
            })
          }
        }

        let dataTableWithID: Partial<ForGetDataBySelectID['TableWithID']> = {}

        if (Object.keys(dataTableWithID).length != 0) {
          const getEntityTableWithID = dataStore.TableWithID.get(id)
          if (getEntityTableWithID) {
            dataStore.TableWithID.set(id, {
              ...getEntityTableWithID,
              ...dataTableWithID,
            })

            callbacks.TableWithID.forEach(async (value, key) => {
              if (id == value.entityID) value.callback()
            })
          }
        }

        let dataTable1: Partial<ForGetDataBySelectID['Table1']> = {}

        if (typeof data['name'] != 'undefined') dataTable1['name'] = data['name']

        if (Object.keys(dataTable1).length != 0) {
          const getEntityTable1 = dataStore.Table1.get(id)
          if (getEntityTable1) {
            dataStore.Table1.set(id, {
              ...getEntityTable1,
              ...dataTable1,
            })

            callbacks.Table1.forEach(async (value, key) => {
              if (id == value.entityID) value.callback()
            })
          }
        }
      },
      TableColumn: ({
        id,
        data,
      }: {
        id: string
        data: Partial<{
          id: PrismaSelect['TableColumn']['id']
          createdAt: PrismaSelect['TableColumn']['createdAt']
          updatedAt: PrismaSelect['TableColumn']['updatedAt']
          motherTableID: PrismaSelect['TableColumn']['motherTableID']
          name: PrismaSelect['TableColumn']['name']
          order: PrismaSelect['TableColumn']['order']
          width: PrismaSelect['TableColumn']['width']
          type: PrismaSelect['TableColumn']['type']
          columnTableSchemaID: PrismaSelect['TableColumn']['columnTableSchemaID']
        }>
      }) => {
        let dataTableColumnSimple: Partial<ForGetDataBySelectID['TableColumnSimple']> = {}

        if (typeof data['name'] != 'undefined') dataTableColumnSimple['name'] = data['name']
        if (typeof data['order'] != 'undefined') dataTableColumnSimple['order'] = data['order']
        if (typeof data['width'] != 'undefined') dataTableColumnSimple['width'] = data['width']
        if (typeof data['type'] != 'undefined') dataTableColumnSimple['type'] = data['type']

        if (Object.keys(dataTableColumnSimple).length != 0) {
          const getEntityTableColumnSimple = dataStore.TableColumnSimple.get(id)
          if (getEntityTableColumnSimple) {
            dataStore.TableColumnSimple.set(id, {
              ...getEntityTableColumnSimple,
              ...dataTableColumnSimple,
            })

            callbacks.TableColumnSimple.forEach(async (value, key) => {
              if (id == value.entityID) value.callback()
            })
          }
        }

        let dataTableColumnAtBoxAtSchema: Partial<ForGetDataBySelectID['TableColumnAtBoxAtSchema']> = {}

        if (typeof data['name'] != 'undefined') dataTableColumnAtBoxAtSchema['name'] = data['name']
        if (typeof data['order'] != 'undefined') dataTableColumnAtBoxAtSchema['order'] = data['order']
        if (typeof data['width'] != 'undefined') dataTableColumnAtBoxAtSchema['width'] = data['width']
        if (typeof data['type'] != 'undefined') dataTableColumnAtBoxAtSchema['type'] = data['type']

        if (Object.keys(dataTableColumnAtBoxAtSchema).length != 0) {
          const getEntityTableColumnAtBoxAtSchema = dataStore.TableColumnAtBoxAtSchema.get(id)
          if (getEntityTableColumnAtBoxAtSchema) {
            dataStore.TableColumnAtBoxAtSchema.set(id, {
              ...getEntityTableColumnAtBoxAtSchema,
              ...dataTableColumnAtBoxAtSchema,
            })

            callbacks.TableColumnAtBoxAtSchema.forEach(async (value, key) => {
              if (id == value.entityID) value.callback()
            })
          }
        }

        let dataTableColumnAtBox: Partial<ForGetDataBySelectID['TableColumnAtBox']> = {}

        if (typeof data['motherTableID'] != 'undefined') dataTableColumnAtBox['motherTableID'] = data['motherTableID']
        if (typeof data['name'] != 'undefined') dataTableColumnAtBox['name'] = data['name']
        if (typeof data['type'] != 'undefined') dataTableColumnAtBox['type'] = data['type']

        if (Object.keys(dataTableColumnAtBox).length != 0) {
          const getEntityTableColumnAtBox = dataStore.TableColumnAtBox.get(id)
          if (getEntityTableColumnAtBox) {
            dataStore.TableColumnAtBox.set(id, {
              ...getEntityTableColumnAtBox,
              ...dataTableColumnAtBox,
            })

            callbacks.TableColumnAtBox.forEach(async (value, key) => {
              if (id == value.entityID) value.callback()
            })
          }
        }

        let dataTableColumn1: Partial<ForGetDataBySelectID['TableColumn1']> = {}

        if (typeof data['name'] != 'undefined') dataTableColumn1['name'] = data['name']
        if (typeof data['order'] != 'undefined') dataTableColumn1['order'] = data['order']
        if (typeof data['width'] != 'undefined') dataTableColumn1['width'] = data['width']
        if (typeof data['type'] != 'undefined') dataTableColumn1['type'] = data['type']

        if (Object.keys(dataTableColumn1).length != 0) {
          const getEntityTableColumn1 = dataStore.TableColumn1.get(id)
          if (getEntityTableColumn1) {
            dataStore.TableColumn1.set(id, {
              ...getEntityTableColumn1,
              ...dataTableColumn1,
            })

            callbacks.TableColumn1.forEach(async (value, key) => {
              if (id == value.entityID) value.callback()
            })
          }
        }
      },
      TableData: ({
        id,
        data,
      }: {
        id: string
        data: Partial<{
          id: PrismaSelect['TableData']['id']
          createdAt: PrismaSelect['TableData']['createdAt']
          updatedAt: PrismaSelect['TableData']['updatedAt']
          pinnedToTableID: PrismaSelect['TableData']['pinnedToTableID']
          siteID: PrismaSelect['TableData']['siteID']
        }>
      }) => {
        let dataTableDataAtBox: Partial<ForGetDataBySelectID['TableDataAtBox']> = {}

        if (Object.keys(dataTableDataAtBox).length != 0) {
          const getEntityTableDataAtBox = dataStore.TableDataAtBox.get(id)
          if (getEntityTableDataAtBox) {
            dataStore.TableDataAtBox.set(id, {
              ...getEntityTableDataAtBox,
              ...dataTableDataAtBox,
            })

            callbacks.TableDataAtBox.forEach(async (value, key) => {
              if (id == value.entityID) value.callback()
            })
          }
        }

        let dataTableDataPinnedToPage: Partial<ForGetDataBySelectID['TableDataPinnedToPage']> = {}

        if (Object.keys(dataTableDataPinnedToPage).length != 0) {
          const getEntityTableDataPinnedToPage = dataStore.TableDataPinnedToPage.get(id)
          if (getEntityTableDataPinnedToPage) {
            dataStore.TableDataPinnedToPage.set(id, {
              ...getEntityTableDataPinnedToPage,
              ...dataTableDataPinnedToPage,
            })

            callbacks.TableDataPinnedToPage.forEach(async (value, key) => {
              if (id == value.entityID) value.callback()
            })
          }
        }

        let dataTableData1: Partial<ForGetDataBySelectID['TableData1']> = {}

        if (Object.keys(dataTableData1).length != 0) {
          const getEntityTableData1 = dataStore.TableData1.get(id)
          if (getEntityTableData1) {
            dataStore.TableData1.set(id, {
              ...getEntityTableData1,
              ...dataTableData1,
            })

            callbacks.TableData1.forEach(async (value, key) => {
              if (id == value.entityID) value.callback()
            })
          }
        }
      },
      TableRow: ({
        id,
        data,
      }: {
        id: string
        data: Partial<{
          id: PrismaSelect['TableRow']['id']
          createdAt: PrismaSelect['TableRow']['createdAt']
          updatedAt: PrismaSelect['TableRow']['updatedAt']
          slug: PrismaSelect['TableRow']['slug']
          tableDataID: PrismaSelect['TableRow']['tableDataID']
          order: PrismaSelect['TableRow']['order']
        }>
      }) => {
        let dataTableRowAtBox: Partial<ForGetDataBySelectID['TableRowAtBox']> = {}

        if (typeof data['slug'] != 'undefined') dataTableRowAtBox['slug'] = data['slug']

        if (Object.keys(dataTableRowAtBox).length != 0) {
          const getEntityTableRowAtBox = dataStore.TableRowAtBox.get(id)
          if (getEntityTableRowAtBox) {
            dataStore.TableRowAtBox.set(id, {
              ...getEntityTableRowAtBox,
              ...dataTableRowAtBox,
            })

            callbacks.TableRowAtBox.forEach(async (value, key) => {
              if (id == value.entityID) value.callback()
            })
          }
        }

        let dataTableDataRowPinnedToPage: Partial<ForGetDataBySelectID['TableDataRowPinnedToPage']> = {}

        if (typeof data['slug'] != 'undefined') dataTableDataRowPinnedToPage['slug'] = data['slug']

        if (Object.keys(dataTableDataRowPinnedToPage).length != 0) {
          const getEntityTableDataRowPinnedToPage = dataStore.TableDataRowPinnedToPage.get(id)
          if (getEntityTableDataRowPinnedToPage) {
            dataStore.TableDataRowPinnedToPage.set(id, {
              ...getEntityTableDataRowPinnedToPage,
              ...dataTableDataRowPinnedToPage,
            })

            callbacks.TableDataRowPinnedToPage.forEach(async (value, key) => {
              if (id == value.entityID) value.callback()
            })
          }
        }

        let dataTableDataRow1: Partial<ForGetDataBySelectID['TableDataRow1']> = {}

        if (typeof data['slug'] != 'undefined') dataTableDataRow1['slug'] = data['slug']

        if (Object.keys(dataTableDataRow1).length != 0) {
          const getEntityTableDataRow1 = dataStore.TableDataRow1.get(id)
          if (getEntityTableDataRow1) {
            dataStore.TableDataRow1.set(id, {
              ...getEntityTableDataRow1,
              ...dataTableDataRow1,
            })

            callbacks.TableDataRow1.forEach(async (value, key) => {
              if (id == value.entityID) value.callback()
            })
          }
        }
      },
      TableRowItem: ({
        id,
        data,
      }: {
        id: string
        data: Partial<{
          id: PrismaSelect['TableRowItem']['id']
          createdAt: PrismaSelect['TableRowItem']['createdAt']
          updatedAt: PrismaSelect['TableRowItem']['updatedAt']
          text: PrismaSelect['TableRowItem']['text']
          number: PrismaSelect['TableRowItem']['number']
          imageID: PrismaSelect['TableRowItem']['imageID']
          tableDataID: PrismaSelect['TableRowItem']['tableDataID']
          tableColumnID: PrismaSelect['TableRowItem']['tableColumnID']
          tableRowID: PrismaSelect['TableRowItem']['tableRowID']
        }>
      }) => {
        let dataTableRowItemAtBox: Partial<ForGetDataBySelectID['TableRowItemAtBox']> = {}

        if (typeof data['text'] != 'undefined') dataTableRowItemAtBox['text'] = data['text']
        if (typeof data['number'] != 'undefined') dataTableRowItemAtBox['number'] = data['number']
        if (typeof data['tableColumnID'] != 'undefined') dataTableRowItemAtBox['tableColumnID'] = data['tableColumnID']

        if (Object.keys(dataTableRowItemAtBox).length != 0) {
          const getEntityTableRowItemAtBox = dataStore.TableRowItemAtBox.get(id)
          if (getEntityTableRowItemAtBox) {
            dataStore.TableRowItemAtBox.set(id, {
              ...getEntityTableRowItemAtBox,
              ...dataTableRowItemAtBox,
            })

            callbacks.TableRowItemAtBox.forEach(async (value, key) => {
              if (id == value.entityID) value.callback()
            })
          }
        }

        let dataTableDataRowItem1: Partial<ForGetDataBySelectID['TableDataRowItem1']> = {}

        if (typeof data['text'] != 'undefined') dataTableDataRowItem1['text'] = data['text']
        if (typeof data['number'] != 'undefined') dataTableDataRowItem1['number'] = data['number']
        if (typeof data['tableColumnID'] != 'undefined') dataTableDataRowItem1['tableColumnID'] = data['tableColumnID']

        if (Object.keys(dataTableDataRowItem1).length != 0) {
          const getEntityTableDataRowItem1 = dataStore.TableDataRowItem1.get(id)
          if (getEntityTableDataRowItem1) {
            dataStore.TableDataRowItem1.set(id, {
              ...getEntityTableDataRowItem1,
              ...dataTableDataRowItem1,
            })

            callbacks.TableDataRowItem1.forEach(async (value, key) => {
              if (id == value.entityID) value.callback()
            })
          }
        }
      },
      CountVisit: ({
        id,
        data,
      }: {
        id: string
        data: Partial<{
          id: PrismaSelect['CountVisit']['id']
          createdAt: PrismaSelect['CountVisit']['createdAt']
          updatedAt: PrismaSelect['CountVisit']['updatedAt']
          monthYear: PrismaSelect['CountVisit']['monthYear']
          count: PrismaSelect['CountVisit']['count']
          siteID: PrismaSelect['CountVisit']['siteID']
        }>
      }) => {},
      GroupFont: ({
        id,
        data,
      }: {
        id: string
        data: Partial<{
          id: PrismaSelect['GroupFont']['id']
          createdAt: PrismaSelect['GroupFont']['createdAt']
          updatedAt: PrismaSelect['GroupFont']['updatedAt']
          name: PrismaSelect['GroupFont']['name']
          siteID: PrismaSelect['GroupFont']['siteID']
        }>
      }) => {
        let dataGroupFont1: Partial<ForGetDataBySelectID['GroupFont1']> = {}

        if (typeof data['name'] != 'undefined') dataGroupFont1['name'] = data['name']

        if (Object.keys(dataGroupFont1).length != 0) {
          const getEntityGroupFont1 = dataStore.GroupFont1.get(id)
          if (getEntityGroupFont1) {
            dataStore.GroupFont1.set(id, {
              ...getEntityGroupFont1,
              ...dataGroupFont1,
            })

            callbacks.GroupFont1.forEach(async (value, key) => {
              if (id == value.entityID) value.callback()
            })
          }
        }
      },
      FontWeight: ({
        id,
        data,
      }: {
        id: string
        data: Partial<{
          id: PrismaSelect['FontWeight']['id']
          createdAt: PrismaSelect['FontWeight']['createdAt']
          updatedAt: PrismaSelect['FontWeight']['updatedAt']
          siteID: PrismaSelect['FontWeight']['siteID']
          previewName: PrismaSelect['FontWeight']['previewName']
          name: PrismaSelect['FontWeight']['name']
          folder: PrismaSelect['FontWeight']['folder']
          size: PrismaSelect['FontWeight']['size']
          groupFontID: PrismaSelect['FontWeight']['groupFontID']
        }>
      }) => {
        let dataFontWeight1: Partial<ForGetDataBySelectID['FontWeight1']> = {}

        if (typeof data['previewName'] != 'undefined') dataFontWeight1['previewName'] = data['previewName']
        if (typeof data['name'] != 'undefined') dataFontWeight1['name'] = data['name']
        if (typeof data['folder'] != 'undefined') dataFontWeight1['folder'] = data['folder']
        if (typeof data['size'] != 'undefined') dataFontWeight1['size'] = data['size']

        if (Object.keys(dataFontWeight1).length != 0) {
          const getEntityFontWeight1 = dataStore.FontWeight1.get(id)
          if (getEntityFontWeight1) {
            dataStore.FontWeight1.set(id, {
              ...getEntityFontWeight1,
              ...dataFontWeight1,
            })

            callbacks.FontWeight1.forEach(async (value, key) => {
              if (id == value.entityID) value.callback()
            })
          }
        }
      },
      BoxBlock: ({
        id,
        data,
      }: {
        id: string
        data: Partial<{
          id: PrismaSelect['BoxBlock']['id']
          createdAt: PrismaSelect['BoxBlock']['createdAt']
          updatedAt: PrismaSelect['BoxBlock']['updatedAt']
          siteId: PrismaSelect['BoxBlock']['siteId']
          boxId: PrismaSelect['BoxBlock']['boxId']
        }>
      }) => {
        let dataBoxBlock1: Partial<ForGetDataBySelectID['BoxBlock1']> = {}

        if (Object.keys(dataBoxBlock1).length != 0) {
          const getEntityBoxBlock1 = dataStore.BoxBlock1.get(id)
          if (getEntityBoxBlock1) {
            dataStore.BoxBlock1.set(id, {
              ...getEntityBoxBlock1,
              ...dataBoxBlock1,
            })

            callbacks.BoxBlock1.forEach(async (value, key) => {
              if (id == value.entityID) value.callback()
            })
          }
        }
      },
      Box: ({
        id,
        data,
      }: {
        id: string
        data: Partial<{
          id: PrismaSelect['Box']['id']
          createdAt: PrismaSelect['Box']['createdAt']
          updatedAt: PrismaSelect['Box']['updatedAt']
          siteId: PrismaSelect['Box']['siteId']
          parentBoxId: PrismaSelect['Box']['parentBoxId']
          widthType: PrismaSelect['Box']['widthType']
          widthTypeMobileResponsiveMode: PrismaSelect['Box']['widthTypeMobileResponsiveMode']
          widthTypeTabletResponsiveMode: PrismaSelect['Box']['widthTypeTabletResponsiveMode']
          widthTypeDesktopResponsiveMode: PrismaSelect['Box']['widthTypeDesktopResponsiveMode']
          heightType: PrismaSelect['Box']['heightType']
          heightTypeMobileResponsiveMode: PrismaSelect['Box']['heightTypeMobileResponsiveMode']
          heightTypeTabletResponsiveMode: PrismaSelect['Box']['heightTypeTabletResponsiveMode']
          heightTypeDesktopResponsiveMode: PrismaSelect['Box']['heightTypeDesktopResponsiveMode']
          positionTypeMobileResponsiveMode: PrismaSelect['Box']['positionTypeMobileResponsiveMode']
          positionTypeTabletResponsiveMode: PrismaSelect['Box']['positionTypeTabletResponsiveMode']
          positionTypeDesktopResponsiveMode: PrismaSelect['Box']['positionTypeDesktopResponsiveMode']
          hiddenMobileResponsiveMode: PrismaSelect['Box']['hiddenMobileResponsiveMode']
          hiddenTabletResponsiveMode: PrismaSelect['Box']['hiddenTabletResponsiveMode']
          hiddenDesktopResponsiveMode: PrismaSelect['Box']['hiddenDesktopResponsiveMode']
          overflowHiddenMobileResponsiveMode: PrismaSelect['Box']['overflowHiddenMobileResponsiveMode']
          overflowHiddenTabletResponsiveMode: PrismaSelect['Box']['overflowHiddenTabletResponsiveMode']
          overflowHiddenDesktopResponsiveMode: PrismaSelect['Box']['overflowHiddenDesktopResponsiveMode']
          gapMobileResponsiveMode: PrismaSelect['Box']['gapMobileResponsiveMode']
          gapTabletResponsiveMode: PrismaSelect['Box']['gapTabletResponsiveMode']
          gapDesktopResponsiveMode: PrismaSelect['Box']['gapDesktopResponsiveMode']
          widthMobileResponsiveMode: PrismaSelect['Box']['widthMobileResponsiveMode']
          widthTabletResponsiveMode: PrismaSelect['Box']['widthTabletResponsiveMode']
          widthDesktopResponsiveMode: PrismaSelect['Box']['widthDesktopResponsiveMode']
          heightMobileResponsiveMode: PrismaSelect['Box']['heightMobileResponsiveMode']
          heightTabletResponsiveMode: PrismaSelect['Box']['heightTabletResponsiveMode']
          heightDesktopResponsiveMode: PrismaSelect['Box']['heightDesktopResponsiveMode']
          marginMobileResponsiveMode: PrismaSelect['Box']['marginMobileResponsiveMode']
          marginTabletResponsiveMode: PrismaSelect['Box']['marginTabletResponsiveMode']
          marginDesktopResponsiveMode: PrismaSelect['Box']['marginDesktopResponsiveMode']
          paddingMobileResponsiveMode: PrismaSelect['Box']['paddingMobileResponsiveMode']
          paddingTabletResponsiveMode: PrismaSelect['Box']['paddingTabletResponsiveMode']
          paddingDesktopResponsiveMode: PrismaSelect['Box']['paddingDesktopResponsiveMode']
          positionMobileResponsiveMode: PrismaSelect['Box']['positionMobileResponsiveMode']
          positionTabletResponsiveMode: PrismaSelect['Box']['positionTabletResponsiveMode']
          positionDesktopResponsiveMode: PrismaSelect['Box']['positionDesktopResponsiveMode']
          backgroundMobileResponsiveMode: PrismaSelect['Box']['backgroundMobileResponsiveMode']
          backgroundTabletResponsiveMode: PrismaSelect['Box']['backgroundTabletResponsiveMode']
          backgroundDesktopResponsiveMode: PrismaSelect['Box']['backgroundDesktopResponsiveMode']
          borderRadiusMobileResponsiveMode: PrismaSelect['Box']['borderRadiusMobileResponsiveMode']
          borderRadiusTabletResponsiveMode: PrismaSelect['Box']['borderRadiusTabletResponsiveMode']
          borderRadiusDesktopResponsiveMode: PrismaSelect['Box']['borderRadiusDesktopResponsiveMode']
          borderMobileResponsiveMode: PrismaSelect['Box']['borderMobileResponsiveMode']
          borderTabletResponsiveMode: PrismaSelect['Box']['borderTabletResponsiveMode']
          borderDesktopResponsiveMode: PrismaSelect['Box']['borderDesktopResponsiveMode']
          shadowMobileResponsiveMode: PrismaSelect['Box']['shadowMobileResponsiveMode']
          shadowTabletResponsiveMode: PrismaSelect['Box']['shadowTabletResponsiveMode']
          shadowDesktopResponsiveMode: PrismaSelect['Box']['shadowDesktopResponsiveMode']
          responsiveBoxSettingsId: PrismaSelect['Box']['responsiveBoxSettingsId']
          text: PrismaSelect['Box']['text']
          isSliderShell: PrismaSelect['Box']['isSliderShell']
          isSlider: PrismaSelect['Box']['isSlider']
          isSliderArrowNext: PrismaSelect['Box']['isSliderArrowNext']
          isSliderArrowPrev: PrismaSelect['Box']['isSliderArrowPrev']
          isClosePopup: PrismaSelect['Box']['isClosePopup']
          isInput: PrismaSelect['Box']['isInput']
          tableColumnDataOutputID: PrismaSelect['Box']['tableColumnDataOutputID']
          pinTableID: PrismaSelect['Box']['pinTableID']
          tableImageIsCover: PrismaSelect['Box']['tableImageIsCover']
        }>
      }) => {
        let dataBox1: Partial<ForGetDataBySelectID['Box1']> = {}

        if (typeof data['siteId'] != 'undefined') dataBox1['siteId'] = data['siteId']
        if (typeof data['parentBoxId'] != 'undefined') dataBox1['parentBoxId'] = data['parentBoxId']
        if (typeof data['widthType'] != 'undefined') dataBox1['widthType'] = data['widthType']
        if (typeof data['widthTypeMobileResponsiveMode'] != 'undefined')
          dataBox1['widthTypeMobileResponsiveMode'] = data['widthTypeMobileResponsiveMode']
        if (typeof data['widthTypeTabletResponsiveMode'] != 'undefined')
          dataBox1['widthTypeTabletResponsiveMode'] = data['widthTypeTabletResponsiveMode']
        if (typeof data['widthTypeDesktopResponsiveMode'] != 'undefined')
          dataBox1['widthTypeDesktopResponsiveMode'] = data['widthTypeDesktopResponsiveMode']
        if (typeof data['heightType'] != 'undefined') dataBox1['heightType'] = data['heightType']
        if (typeof data['heightTypeMobileResponsiveMode'] != 'undefined')
          dataBox1['heightTypeMobileResponsiveMode'] = data['heightTypeMobileResponsiveMode']
        if (typeof data['heightTypeTabletResponsiveMode'] != 'undefined')
          dataBox1['heightTypeTabletResponsiveMode'] = data['heightTypeTabletResponsiveMode']
        if (typeof data['heightTypeDesktopResponsiveMode'] != 'undefined')
          dataBox1['heightTypeDesktopResponsiveMode'] = data['heightTypeDesktopResponsiveMode']
        if (typeof data['positionTypeMobileResponsiveMode'] != 'undefined')
          dataBox1['positionTypeMobileResponsiveMode'] = data['positionTypeMobileResponsiveMode']
        if (typeof data['positionTypeTabletResponsiveMode'] != 'undefined')
          dataBox1['positionTypeTabletResponsiveMode'] = data['positionTypeTabletResponsiveMode']
        if (typeof data['positionTypeDesktopResponsiveMode'] != 'undefined')
          dataBox1['positionTypeDesktopResponsiveMode'] = data['positionTypeDesktopResponsiveMode']
        if (typeof data['hiddenMobileResponsiveMode'] != 'undefined')
          dataBox1['hiddenMobileResponsiveMode'] = data['hiddenMobileResponsiveMode']
        if (typeof data['hiddenTabletResponsiveMode'] != 'undefined')
          dataBox1['hiddenTabletResponsiveMode'] = data['hiddenTabletResponsiveMode']
        if (typeof data['hiddenDesktopResponsiveMode'] != 'undefined')
          dataBox1['hiddenDesktopResponsiveMode'] = data['hiddenDesktopResponsiveMode']
        if (typeof data['overflowHiddenMobileResponsiveMode'] != 'undefined')
          dataBox1['overflowHiddenMobileResponsiveMode'] = data['overflowHiddenMobileResponsiveMode']
        if (typeof data['overflowHiddenTabletResponsiveMode'] != 'undefined')
          dataBox1['overflowHiddenTabletResponsiveMode'] = data['overflowHiddenTabletResponsiveMode']
        if (typeof data['overflowHiddenDesktopResponsiveMode'] != 'undefined')
          dataBox1['overflowHiddenDesktopResponsiveMode'] = data['overflowHiddenDesktopResponsiveMode']
        if (typeof data['gapMobileResponsiveMode'] != 'undefined')
          dataBox1['gapMobileResponsiveMode'] = data['gapMobileResponsiveMode']
        if (typeof data['gapTabletResponsiveMode'] != 'undefined')
          dataBox1['gapTabletResponsiveMode'] = data['gapTabletResponsiveMode']
        if (typeof data['gapDesktopResponsiveMode'] != 'undefined')
          dataBox1['gapDesktopResponsiveMode'] = data['gapDesktopResponsiveMode']
        if (typeof data['widthMobileResponsiveMode'] != 'undefined')
          dataBox1['widthMobileResponsiveMode'] = data['widthMobileResponsiveMode']
        if (typeof data['widthTabletResponsiveMode'] != 'undefined')
          dataBox1['widthTabletResponsiveMode'] = data['widthTabletResponsiveMode']
        if (typeof data['widthDesktopResponsiveMode'] != 'undefined')
          dataBox1['widthDesktopResponsiveMode'] = data['widthDesktopResponsiveMode']
        if (typeof data['heightMobileResponsiveMode'] != 'undefined')
          dataBox1['heightMobileResponsiveMode'] = data['heightMobileResponsiveMode']
        if (typeof data['heightTabletResponsiveMode'] != 'undefined')
          dataBox1['heightTabletResponsiveMode'] = data['heightTabletResponsiveMode']
        if (typeof data['heightDesktopResponsiveMode'] != 'undefined')
          dataBox1['heightDesktopResponsiveMode'] = data['heightDesktopResponsiveMode']
        if (typeof data['marginMobileResponsiveMode'] != 'undefined')
          dataBox1['marginMobileResponsiveMode'] = data['marginMobileResponsiveMode']
        if (typeof data['marginTabletResponsiveMode'] != 'undefined')
          dataBox1['marginTabletResponsiveMode'] = data['marginTabletResponsiveMode']
        if (typeof data['marginDesktopResponsiveMode'] != 'undefined')
          dataBox1['marginDesktopResponsiveMode'] = data['marginDesktopResponsiveMode']
        if (typeof data['paddingMobileResponsiveMode'] != 'undefined')
          dataBox1['paddingMobileResponsiveMode'] = data['paddingMobileResponsiveMode']
        if (typeof data['paddingTabletResponsiveMode'] != 'undefined')
          dataBox1['paddingTabletResponsiveMode'] = data['paddingTabletResponsiveMode']
        if (typeof data['paddingDesktopResponsiveMode'] != 'undefined')
          dataBox1['paddingDesktopResponsiveMode'] = data['paddingDesktopResponsiveMode']
        if (typeof data['positionMobileResponsiveMode'] != 'undefined')
          dataBox1['positionMobileResponsiveMode'] = data['positionMobileResponsiveMode']
        if (typeof data['positionTabletResponsiveMode'] != 'undefined')
          dataBox1['positionTabletResponsiveMode'] = data['positionTabletResponsiveMode']
        if (typeof data['positionDesktopResponsiveMode'] != 'undefined')
          dataBox1['positionDesktopResponsiveMode'] = data['positionDesktopResponsiveMode']
        if (typeof data['backgroundMobileResponsiveMode'] != 'undefined')
          dataBox1['backgroundMobileResponsiveMode'] = data['backgroundMobileResponsiveMode']
        if (typeof data['backgroundTabletResponsiveMode'] != 'undefined')
          dataBox1['backgroundTabletResponsiveMode'] = data['backgroundTabletResponsiveMode']
        if (typeof data['backgroundDesktopResponsiveMode'] != 'undefined')
          dataBox1['backgroundDesktopResponsiveMode'] = data['backgroundDesktopResponsiveMode']
        if (typeof data['borderRadiusMobileResponsiveMode'] != 'undefined')
          dataBox1['borderRadiusMobileResponsiveMode'] = data['borderRadiusMobileResponsiveMode']
        if (typeof data['borderRadiusTabletResponsiveMode'] != 'undefined')
          dataBox1['borderRadiusTabletResponsiveMode'] = data['borderRadiusTabletResponsiveMode']
        if (typeof data['borderRadiusDesktopResponsiveMode'] != 'undefined')
          dataBox1['borderRadiusDesktopResponsiveMode'] = data['borderRadiusDesktopResponsiveMode']
        if (typeof data['borderMobileResponsiveMode'] != 'undefined')
          dataBox1['borderMobileResponsiveMode'] = data['borderMobileResponsiveMode']
        if (typeof data['borderTabletResponsiveMode'] != 'undefined')
          dataBox1['borderTabletResponsiveMode'] = data['borderTabletResponsiveMode']
        if (typeof data['borderDesktopResponsiveMode'] != 'undefined')
          dataBox1['borderDesktopResponsiveMode'] = data['borderDesktopResponsiveMode']
        if (typeof data['shadowMobileResponsiveMode'] != 'undefined')
          dataBox1['shadowMobileResponsiveMode'] = data['shadowMobileResponsiveMode']
        if (typeof data['shadowTabletResponsiveMode'] != 'undefined')
          dataBox1['shadowTabletResponsiveMode'] = data['shadowTabletResponsiveMode']
        if (typeof data['shadowDesktopResponsiveMode'] != 'undefined')
          dataBox1['shadowDesktopResponsiveMode'] = data['shadowDesktopResponsiveMode']
        if (typeof data['isSliderShell'] != 'undefined') dataBox1['isSliderShell'] = data['isSliderShell']
        if (typeof data['isSlider'] != 'undefined') dataBox1['isSlider'] = data['isSlider']
        if (typeof data['isSliderArrowNext'] != 'undefined') dataBox1['isSliderArrowNext'] = data['isSliderArrowNext']
        if (typeof data['isSliderArrowPrev'] != 'undefined') dataBox1['isSliderArrowPrev'] = data['isSliderArrowPrev']
        if (typeof data['isClosePopup'] != 'undefined') dataBox1['isClosePopup'] = data['isClosePopup']
        if (typeof data['isInput'] != 'undefined') dataBox1['isInput'] = data['isInput']
        if (typeof data['tableColumnDataOutputID'] != 'undefined')
          dataBox1['tableColumnDataOutputID'] = data['tableColumnDataOutputID']
        if (typeof data['tableImageIsCover'] != 'undefined') dataBox1['tableImageIsCover'] = data['tableImageIsCover']

        if (Object.keys(dataBox1).length != 0) {
          const getEntityBox1 = dataStore.Box1.get(id)
          if (getEntityBox1) {
            dataStore.Box1.set(id, {
              ...getEntityBox1,
              ...dataBox1,
            })

            callbacks.Box1.forEach(async (value, key) => {
              if (id == value.entityID) value.callback()
            })
          }
        }
      },
      ResponsiveBoxSettings: ({
        id,
        data,
      }: {
        id: string
        data: Partial<{
          id: PrismaSelect['ResponsiveBoxSettings']['id']
          createdAt: PrismaSelect['ResponsiveBoxSettings']['createdAt']
          updatedAt: PrismaSelect['ResponsiveBoxSettings']['updatedAt']
          desktopBoxSettingsId: PrismaSelect['ResponsiveBoxSettings']['desktopBoxSettingsId']
          tabletBoxSettingsId: PrismaSelect['ResponsiveBoxSettings']['tabletBoxSettingsId']
          mobileBoxSettingsId: PrismaSelect['ResponsiveBoxSettings']['mobileBoxSettingsId']
        }>
      }) => {
        let dataResponsiveBoxSetting1: Partial<ForGetDataBySelectID['ResponsiveBoxSetting1']> = {}

        if (Object.keys(dataResponsiveBoxSetting1).length != 0) {
          const getEntityResponsiveBoxSetting1 = dataStore.ResponsiveBoxSetting1.get(id)
          if (getEntityResponsiveBoxSetting1) {
            dataStore.ResponsiveBoxSetting1.set(id, {
              ...getEntityResponsiveBoxSetting1,
              ...dataResponsiveBoxSetting1,
            })

            callbacks.ResponsiveBoxSetting1.forEach(async (value, key) => {
              if (id == value.entityID) value.callback()
            })
          }
        }
      },
      BoxSettings: ({
        id,
        data,
      }: {
        id: string
        data: Partial<{
          id: PrismaSelect['BoxSettings']['id']
          createdAt: PrismaSelect['BoxSettings']['createdAt']
          updatedAt: PrismaSelect['BoxSettings']['updatedAt']
          widthType: PrismaSelect['BoxSettings']['widthType']
          heightType: PrismaSelect['BoxSettings']['heightType']
          positionType: PrismaSelect['BoxSettings']['positionType']
          positionX: PrismaSelect['BoxSettings']['positionX']
          positionY: PrismaSelect['BoxSettings']['positionY']
          marginTop: PrismaSelect['BoxSettings']['marginTop']
          marginLeft: PrismaSelect['BoxSettings']['marginLeft']
          marginBottom: PrismaSelect['BoxSettings']['marginBottom']
          marginRight: PrismaSelect['BoxSettings']['marginRight']
          paddingTop: PrismaSelect['BoxSettings']['paddingTop']
          paddingLeft: PrismaSelect['BoxSettings']['paddingLeft']
          paddingBottom: PrismaSelect['BoxSettings']['paddingBottom']
          paddingRight: PrismaSelect['BoxSettings']['paddingRight']
          borderRadiusLeftTop: PrismaSelect['BoxSettings']['borderRadiusLeftTop']
          borderRadiusLeftBottom: PrismaSelect['BoxSettings']['borderRadiusLeftBottom']
          borderRadiusRightTop: PrismaSelect['BoxSettings']['borderRadiusRightTop']
          borderRadiusRightBottom: PrismaSelect['BoxSettings']['borderRadiusRightBottom']
          width: PrismaSelect['BoxSettings']['width']
          height: PrismaSelect['BoxSettings']['height']
          hidden: PrismaSelect['BoxSettings']['hidden']
          isOverflowHidden: PrismaSelect['BoxSettings']['isOverflowHidden']
          vector: PrismaSelect['BoxSettings']['vector']
          horizontalPosition: PrismaSelect['BoxSettings']['horizontalPosition']
          verticalPosition: PrismaSelect['BoxSettings']['verticalPosition']
          gap: PrismaSelect['BoxSettings']['gap']
          shadowId: PrismaSelect['BoxSettings']['shadowId']
          order: PrismaSelect['BoxSettings']['order']
        }>
      }) => {
        let dataBoxSetting1: Partial<ForGetDataBySelectID['BoxSetting1']> = {}

        if (typeof data['widthType'] != 'undefined') dataBoxSetting1['widthType'] = data['widthType']
        if (typeof data['heightType'] != 'undefined') dataBoxSetting1['heightType'] = data['heightType']
        if (typeof data['positionType'] != 'undefined') dataBoxSetting1['positionType'] = data['positionType']
        if (typeof data['positionX'] != 'undefined') dataBoxSetting1['positionX'] = data['positionX']
        if (typeof data['positionY'] != 'undefined') dataBoxSetting1['positionY'] = data['positionY']
        if (typeof data['marginTop'] != 'undefined') dataBoxSetting1['marginTop'] = data['marginTop']
        if (typeof data['marginLeft'] != 'undefined') dataBoxSetting1['marginLeft'] = data['marginLeft']
        if (typeof data['marginBottom'] != 'undefined') dataBoxSetting1['marginBottom'] = data['marginBottom']
        if (typeof data['marginRight'] != 'undefined') dataBoxSetting1['marginRight'] = data['marginRight']
        if (typeof data['paddingTop'] != 'undefined') dataBoxSetting1['paddingTop'] = data['paddingTop']
        if (typeof data['paddingLeft'] != 'undefined') dataBoxSetting1['paddingLeft'] = data['paddingLeft']
        if (typeof data['paddingBottom'] != 'undefined') dataBoxSetting1['paddingBottom'] = data['paddingBottom']
        if (typeof data['paddingRight'] != 'undefined') dataBoxSetting1['paddingRight'] = data['paddingRight']
        if (typeof data['borderRadiusLeftTop'] != 'undefined')
          dataBoxSetting1['borderRadiusLeftTop'] = data['borderRadiusLeftTop']
        if (typeof data['borderRadiusLeftBottom'] != 'undefined')
          dataBoxSetting1['borderRadiusLeftBottom'] = data['borderRadiusLeftBottom']
        if (typeof data['borderRadiusRightTop'] != 'undefined')
          dataBoxSetting1['borderRadiusRightTop'] = data['borderRadiusRightTop']
        if (typeof data['borderRadiusRightBottom'] != 'undefined')
          dataBoxSetting1['borderRadiusRightBottom'] = data['borderRadiusRightBottom']
        if (typeof data['width'] != 'undefined') dataBoxSetting1['width'] = data['width']
        if (typeof data['height'] != 'undefined') dataBoxSetting1['height'] = data['height']
        if (typeof data['hidden'] != 'undefined') dataBoxSetting1['hidden'] = data['hidden']
        if (typeof data['isOverflowHidden'] != 'undefined') dataBoxSetting1['isOverflowHidden'] = data['isOverflowHidden']
        if (typeof data['vector'] != 'undefined') dataBoxSetting1['vector'] = data['vector']
        if (typeof data['horizontalPosition'] != 'undefined') dataBoxSetting1['horizontalPosition'] = data['horizontalPosition']
        if (typeof data['verticalPosition'] != 'undefined') dataBoxSetting1['verticalPosition'] = data['verticalPosition']
        if (typeof data['gap'] != 'undefined') dataBoxSetting1['gap'] = data['gap']
        if (typeof data['order'] != 'undefined') dataBoxSetting1['order'] = data['order']

        if (Object.keys(dataBoxSetting1).length != 0) {
          const getEntityBoxSetting1 = dataStore.BoxSetting1.get(id)
          if (getEntityBoxSetting1) {
            dataStore.BoxSetting1.set(id, {
              ...getEntityBoxSetting1,
              ...dataBoxSetting1,
            })

            callbacks.BoxSetting1.forEach(async (value, key) => {
              if (id == value.entityID) value.callback()
            })
          }
        }
      },
      BoxBorder: ({
        id,
        data,
      }: {
        id: string
        data: Partial<{
          id: PrismaSelect['BoxBorder']['id']
          createdAt: PrismaSelect['BoxBorder']['createdAt']
          updatedAt: PrismaSelect['BoxBorder']['updatedAt']
          top: PrismaSelect['BoxBorder']['top']
          right: PrismaSelect['BoxBorder']['right']
          bottom: PrismaSelect['BoxBorder']['bottom']
          left: PrismaSelect['BoxBorder']['left']
          colorId: PrismaSelect['BoxBorder']['colorId']
          boxSettingsId: PrismaSelect['BoxBorder']['boxSettingsId']
          siteId: PrismaSelect['BoxBorder']['siteId']
        }>
      }) => {
        let dataBoxBorder1: Partial<ForGetDataBySelectID['BoxBorder1']> = {}

        if (typeof data['top'] != 'undefined') dataBoxBorder1['top'] = data['top']
        if (typeof data['right'] != 'undefined') dataBoxBorder1['right'] = data['right']
        if (typeof data['bottom'] != 'undefined') dataBoxBorder1['bottom'] = data['bottom']
        if (typeof data['left'] != 'undefined') dataBoxBorder1['left'] = data['left']

        if (Object.keys(dataBoxBorder1).length != 0) {
          const getEntityBoxBorder1 = dataStore.BoxBorder1.get(id)
          if (getEntityBoxBorder1) {
            dataStore.BoxBorder1.set(id, {
              ...getEntityBoxBorder1,
              ...dataBoxBorder1,
            })

            callbacks.BoxBorder1.forEach(async (value, key) => {
              if (id == value.entityID) value.callback()
            })
          }
        }
      },
      BoxShadow: ({
        id,
        data,
      }: {
        id: string
        data: Partial<{
          id: PrismaSelect['BoxShadow']['id']
          createdAt: PrismaSelect['BoxShadow']['createdAt']
          updatedAt: PrismaSelect['BoxShadow']['updatedAt']
          originalID: PrismaSelect['BoxShadow']['originalID']
          viewName: PrismaSelect['BoxShadow']['viewName']
          xShift: PrismaSelect['BoxShadow']['xShift']
          yShift: PrismaSelect['BoxShadow']['yShift']
          blur: PrismaSelect['BoxShadow']['blur']
          spread: PrismaSelect['BoxShadow']['spread']
          colorId: PrismaSelect['BoxShadow']['colorId']
          siteId: PrismaSelect['BoxShadow']['siteId']
        }>
      }) => {
        let dataBoxShadow1: Partial<ForGetDataBySelectID['BoxShadow1']> = {}

        if (typeof data['viewName'] != 'undefined') dataBoxShadow1['viewName'] = data['viewName']
        if (typeof data['xShift'] != 'undefined') dataBoxShadow1['xShift'] = data['xShift']
        if (typeof data['yShift'] != 'undefined') dataBoxShadow1['yShift'] = data['yShift']
        if (typeof data['blur'] != 'undefined') dataBoxShadow1['blur'] = data['blur']
        if (typeof data['spread'] != 'undefined') dataBoxShadow1['spread'] = data['spread']

        if (Object.keys(dataBoxShadow1).length != 0) {
          const getEntityBoxShadow1 = dataStore.BoxShadow1.get(id)
          if (getEntityBoxShadow1) {
            dataStore.BoxShadow1.set(id, {
              ...getEntityBoxShadow1,
              ...dataBoxShadow1,
            })

            callbacks.BoxShadow1.forEach(async (value, key) => {
              if (id == value.entityID) value.callback()
            })
          }
        }
      },
      BoxBackground: ({
        id,
        data,
      }: {
        id: string
        data: Partial<{
          id: PrismaSelect['BoxBackground']['id']
          createdAt: PrismaSelect['BoxBackground']['createdAt']
          updatedAt: PrismaSelect['BoxBackground']['updatedAt']
          siteId: PrismaSelect['BoxBackground']['siteId']
          boxSettingsId: PrismaSelect['BoxBackground']['boxSettingsId']
          positionX: PrismaSelect['BoxBackground']['positionX']
          positionY: PrismaSelect['BoxBackground']['positionY']
          width: PrismaSelect['BoxBackground']['width']
          height: PrismaSelect['BoxBackground']['height']
          imageId: PrismaSelect['BoxBackground']['imageId']
          colorId: PrismaSelect['BoxBackground']['colorId']
          verticalPosition: PrismaSelect['BoxBackground']['verticalPosition']
        }>
      }) => {
        let dataBoxBackground1: Partial<ForGetDataBySelectID['BoxBackground1']> = {}

        if (typeof data['positionX'] != 'undefined') dataBoxBackground1['positionX'] = data['positionX']
        if (typeof data['positionY'] != 'undefined') dataBoxBackground1['positionY'] = data['positionY']
        if (typeof data['width'] != 'undefined') dataBoxBackground1['width'] = data['width']
        if (typeof data['height'] != 'undefined') dataBoxBackground1['height'] = data['height']
        if (typeof data['verticalPosition'] != 'undefined') dataBoxBackground1['verticalPosition'] = data['verticalPosition']

        if (Object.keys(dataBoxBackground1).length != 0) {
          const getEntityBoxBackground1 = dataStore.BoxBackground1.get(id)
          if (getEntityBoxBackground1) {
            dataStore.BoxBackground1.set(id, {
              ...getEntityBoxBackground1,
              ...dataBoxBackground1,
            })

            callbacks.BoxBackground1.forEach(async (value, key) => {
              if (id == value.entityID) value.callback()
            })
          }
        }
      },
      TextComponent: ({
        id,
        data,
      }: {
        id: string
        data: Partial<{
          id: PrismaSelect['TextComponent']['id']
          createdAt: PrismaSelect['TextComponent']['createdAt']
          updatedAt: PrismaSelect['TextComponent']['updatedAt']
          text: PrismaSelect['TextComponent']['text']
          boxId: PrismaSelect['TextComponent']['boxId']
          type: PrismaSelect['TextComponent']['type']
          alignMobileResponsiveMode: PrismaSelect['TextComponent']['alignMobileResponsiveMode']
          alignTabletResponsiveMode: PrismaSelect['TextComponent']['alignTabletResponsiveMode']
          alignDesktopResponsiveMode: PrismaSelect['TextComponent']['alignDesktopResponsiveMode']
          alignMobile: PrismaSelect['TextComponent']['alignMobile']
          alignTablet: PrismaSelect['TextComponent']['alignTablet']
          alignDesktop: PrismaSelect['TextComponent']['alignDesktop']
          textSettingsId: PrismaSelect['TextComponent']['textSettingsId']
        }>
      }) => {
        let dataTextComponent1: Partial<ForGetDataBySelectID['TextComponent1']> = {}

        if (typeof data['text'] != 'undefined') dataTextComponent1['text'] = data['text']
        if (typeof data['type'] != 'undefined') dataTextComponent1['type'] = data['type']
        if (typeof data['alignMobileResponsiveMode'] != 'undefined')
          dataTextComponent1['alignMobileResponsiveMode'] = data['alignMobileResponsiveMode']
        if (typeof data['alignTabletResponsiveMode'] != 'undefined')
          dataTextComponent1['alignTabletResponsiveMode'] = data['alignTabletResponsiveMode']
        if (typeof data['alignDesktopResponsiveMode'] != 'undefined')
          dataTextComponent1['alignDesktopResponsiveMode'] = data['alignDesktopResponsiveMode']
        if (typeof data['alignMobile'] != 'undefined') dataTextComponent1['alignMobile'] = data['alignMobile']
        if (typeof data['alignTablet'] != 'undefined') dataTextComponent1['alignTablet'] = data['alignTablet']
        if (typeof data['alignDesktop'] != 'undefined') dataTextComponent1['alignDesktop'] = data['alignDesktop']

        if (Object.keys(dataTextComponent1).length != 0) {
          const getEntityTextComponent1 = dataStore.TextComponent1.get(id)
          if (getEntityTextComponent1) {
            dataStore.TextComponent1.set(id, {
              ...getEntityTextComponent1,
              ...dataTextComponent1,
            })

            callbacks.TextComponent1.forEach(async (value, key) => {
              if (id == value.entityID) value.callback()
            })
          }
        }
      },
      TextSettings: ({
        id,
        data,
      }: {
        id: string
        data: Partial<{
          id: PrismaSelect['TextSettings']['id']
          createdAt: PrismaSelect['TextSettings']['createdAt']
          updatedAt: PrismaSelect['TextSettings']['updatedAt']
          name: PrismaSelect['TextSettings']['name']
          lib: PrismaSelect['TextSettings']['lib']
          siteId: PrismaSelect['TextSettings']['siteId']
          fontSizeMobileResponsiveMode: PrismaSelect['TextSettings']['fontSizeMobileResponsiveMode']
          fontSizeTabletResponsiveMode: PrismaSelect['TextSettings']['fontSizeTabletResponsiveMode']
          fontSizeDesktopResponsiveMode: PrismaSelect['TextSettings']['fontSizeDesktopResponsiveMode']
          fontSizeMobile: PrismaSelect['TextSettings']['fontSizeMobile']
          fontSizeTablet: PrismaSelect['TextSettings']['fontSizeTablet']
          fontSizeDesktop: PrismaSelect['TextSettings']['fontSizeDesktop']
          lineHeightMobileResponsiveMode: PrismaSelect['TextSettings']['lineHeightMobileResponsiveMode']
          lineHeightTabletResponsiveMode: PrismaSelect['TextSettings']['lineHeightTabletResponsiveMode']
          lineHeightDesktopResponsiveMode: PrismaSelect['TextSettings']['lineHeightDesktopResponsiveMode']
          lineHeightMobile: PrismaSelect['TextSettings']['lineHeightMobile']
          lineHeightTablet: PrismaSelect['TextSettings']['lineHeightTablet']
          lineHeightDesktop: PrismaSelect['TextSettings']['lineHeightDesktop']
          fontWeightMobileResponsiveMode: PrismaSelect['TextSettings']['fontWeightMobileResponsiveMode']
          fontWeightTabletResponsiveMode: PrismaSelect['TextSettings']['fontWeightTabletResponsiveMode']
          fontWeightDesktopResponsiveMode: PrismaSelect['TextSettings']['fontWeightDesktopResponsiveMode']
          fontWeightMobileID: PrismaSelect['TextSettings']['fontWeightMobileID']
          fontWeightTabletID: PrismaSelect['TextSettings']['fontWeightTabletID']
          fontWeightDesktopID: PrismaSelect['TextSettings']['fontWeightDesktopID']
        }>
      }) => {
        let dataTextSettings1: Partial<ForGetDataBySelectID['TextSettings1']> = {}

        if (typeof data['name'] != 'undefined') dataTextSettings1['name'] = data['name']
        if (typeof data['lib'] != 'undefined') dataTextSettings1['lib'] = data['lib']
        if (typeof data['siteId'] != 'undefined') dataTextSettings1['siteId'] = data['siteId']
        if (typeof data['fontSizeMobileResponsiveMode'] != 'undefined')
          dataTextSettings1['fontSizeMobileResponsiveMode'] = data['fontSizeMobileResponsiveMode']
        if (typeof data['fontSizeTabletResponsiveMode'] != 'undefined')
          dataTextSettings1['fontSizeTabletResponsiveMode'] = data['fontSizeTabletResponsiveMode']
        if (typeof data['fontSizeDesktopResponsiveMode'] != 'undefined')
          dataTextSettings1['fontSizeDesktopResponsiveMode'] = data['fontSizeDesktopResponsiveMode']
        if (typeof data['fontSizeMobile'] != 'undefined') dataTextSettings1['fontSizeMobile'] = data['fontSizeMobile']
        if (typeof data['fontSizeTablet'] != 'undefined') dataTextSettings1['fontSizeTablet'] = data['fontSizeTablet']
        if (typeof data['fontSizeDesktop'] != 'undefined') dataTextSettings1['fontSizeDesktop'] = data['fontSizeDesktop']
        if (typeof data['lineHeightMobileResponsiveMode'] != 'undefined')
          dataTextSettings1['lineHeightMobileResponsiveMode'] = data['lineHeightMobileResponsiveMode']
        if (typeof data['lineHeightTabletResponsiveMode'] != 'undefined')
          dataTextSettings1['lineHeightTabletResponsiveMode'] = data['lineHeightTabletResponsiveMode']
        if (typeof data['lineHeightDesktopResponsiveMode'] != 'undefined')
          dataTextSettings1['lineHeightDesktopResponsiveMode'] = data['lineHeightDesktopResponsiveMode']
        if (typeof data['lineHeightMobile'] != 'undefined') dataTextSettings1['lineHeightMobile'] = data['lineHeightMobile']
        if (typeof data['lineHeightTablet'] != 'undefined') dataTextSettings1['lineHeightTablet'] = data['lineHeightTablet']
        if (typeof data['lineHeightDesktop'] != 'undefined') dataTextSettings1['lineHeightDesktop'] = data['lineHeightDesktop']
        if (typeof data['fontWeightMobileResponsiveMode'] != 'undefined')
          dataTextSettings1['fontWeightMobileResponsiveMode'] = data['fontWeightMobileResponsiveMode']
        if (typeof data['fontWeightTabletResponsiveMode'] != 'undefined')
          dataTextSettings1['fontWeightTabletResponsiveMode'] = data['fontWeightTabletResponsiveMode']
        if (typeof data['fontWeightDesktopResponsiveMode'] != 'undefined')
          dataTextSettings1['fontWeightDesktopResponsiveMode'] = data['fontWeightDesktopResponsiveMode']

        if (Object.keys(dataTextSettings1).length != 0) {
          const getEntityTextSettings1 = dataStore.TextSettings1.get(id)
          if (getEntityTextSettings1) {
            dataStore.TextSettings1.set(id, {
              ...getEntityTextSettings1,
              ...dataTextSettings1,
            })

            callbacks.TextSettings1.forEach(async (value, key) => {
              if (id == value.entityID) value.callback()
            })
          }
        }
      },
      ImageComponent: ({
        id,
        data,
      }: {
        id: string
        data: Partial<{
          id: PrismaSelect['ImageComponent']['id']
          createdAt: PrismaSelect['ImageComponent']['createdAt']
          updatedAt: PrismaSelect['ImageComponent']['updatedAt']
          boxId: PrismaSelect['ImageComponent']['boxId']
          imageId: PrismaSelect['ImageComponent']['imageId']
          width: PrismaSelect['ImageComponent']['width']
          height: PrismaSelect['ImageComponent']['height']
          positionX: PrismaSelect['ImageComponent']['positionX']
          positionY: PrismaSelect['ImageComponent']['positionY']
          shellWidth: PrismaSelect['ImageComponent']['shellWidth']
          shellHeight: PrismaSelect['ImageComponent']['shellHeight']
          isCover: PrismaSelect['ImageComponent']['isCover']
        }>
      }) => {
        let dataImageComponent1: Partial<ForGetDataBySelectID['ImageComponent1']> = {}

        if (typeof data['width'] != 'undefined') dataImageComponent1['width'] = data['width']
        if (typeof data['height'] != 'undefined') dataImageComponent1['height'] = data['height']
        if (typeof data['positionX'] != 'undefined') dataImageComponent1['positionX'] = data['positionX']
        if (typeof data['positionY'] != 'undefined') dataImageComponent1['positionY'] = data['positionY']
        if (typeof data['shellWidth'] != 'undefined') dataImageComponent1['shellWidth'] = data['shellWidth']
        if (typeof data['shellHeight'] != 'undefined') dataImageComponent1['shellHeight'] = data['shellHeight']
        if (typeof data['isCover'] != 'undefined') dataImageComponent1['isCover'] = data['isCover']

        if (Object.keys(dataImageComponent1).length != 0) {
          const getEntityImageComponent1 = dataStore.ImageComponent1.get(id)
          if (getEntityImageComponent1) {
            dataStore.ImageComponent1.set(id, {
              ...getEntityImageComponent1,
              ...dataImageComponent1,
            })

            callbacks.ImageComponent1.forEach(async (value, key) => {
              if (id == value.entityID) value.callback()
            })
          }
        }
      },
      FormComponent: ({
        id,
        data,
      }: {
        id: string
        data: Partial<{
          id: PrismaSelect['FormComponent']['id']
          createdAt: PrismaSelect['FormComponent']['createdAt']
          updatedAt: PrismaSelect['FormComponent']['updatedAt']
          boxId: PrismaSelect['FormComponent']['boxId']
          formId: PrismaSelect['FormComponent']['formId']
        }>
      }) => {
        let dataFormComponent1: Partial<ForGetDataBySelectID['FormComponent1']> = {}

        if (Object.keys(dataFormComponent1).length != 0) {
          const getEntityFormComponent1 = dataStore.FormComponent1.get(id)
          if (getEntityFormComponent1) {
            dataStore.FormComponent1.set(id, {
              ...getEntityFormComponent1,
              ...dataFormComponent1,
            })

            callbacks.FormComponent1.forEach(async (value, key) => {
              if (id == value.entityID) value.callback()
            })
          }
        }
      },
      QuizComponent: ({
        id,
        data,
      }: {
        id: string
        data: Partial<{
          id: PrismaSelect['QuizComponent']['id']
          createdAt: PrismaSelect['QuizComponent']['createdAt']
          updatedAt: PrismaSelect['QuizComponent']['updatedAt']
          boxId: PrismaSelect['QuizComponent']['boxId']
          quizId: PrismaSelect['QuizComponent']['quizId']
        }>
      }) => {
        let dataQuizComponent1: Partial<ForGetDataBySelectID['QuizComponent1']> = {}

        if (Object.keys(dataQuizComponent1).length != 0) {
          const getEntityQuizComponent1 = dataStore.QuizComponent1.get(id)
          if (getEntityQuizComponent1) {
            dataStore.QuizComponent1.set(id, {
              ...getEntityQuizComponent1,
              ...dataQuizComponent1,
            })

            callbacks.QuizComponent1.forEach(async (value, key) => {
              if (id == value.entityID) value.callback()
            })
          }
        }
      },
      VideoComponent: ({
        id,
        data,
      }: {
        id: string
        data: Partial<{
          id: PrismaSelect['VideoComponent']['id']
          createdAt: PrismaSelect['VideoComponent']['createdAt']
          updatedAt: PrismaSelect['VideoComponent']['updatedAt']
          boxId: PrismaSelect['VideoComponent']['boxId']
          videoURL: PrismaSelect['VideoComponent']['videoURL']
        }>
      }) => {
        let dataVideoComponent1: Partial<ForGetDataBySelectID['VideoComponent1']> = {}

        if (typeof data['videoURL'] != 'undefined') dataVideoComponent1['videoURL'] = data['videoURL']

        if (Object.keys(dataVideoComponent1).length != 0) {
          const getEntityVideoComponent1 = dataStore.VideoComponent1.get(id)
          if (getEntityVideoComponent1) {
            dataStore.VideoComponent1.set(id, {
              ...getEntityVideoComponent1,
              ...dataVideoComponent1,
            })

            callbacks.VideoComponent1.forEach(async (value, key) => {
              if (id == value.entityID) value.callback()
            })
          }
        }
      },
      FaqComponent: ({
        id,
        data,
      }: {
        id: string
        data: Partial<{
          id: PrismaSelect['FaqComponent']['id']
          createdAt: PrismaSelect['FaqComponent']['createdAt']
          updatedAt: PrismaSelect['FaqComponent']['updatedAt']
          boxId: PrismaSelect['FaqComponent']['boxId']
        }>
      }) => {
        let dataFaqComponent1: Partial<ForGetDataBySelectID['FaqComponent1']> = {}

        if (Object.keys(dataFaqComponent1).length != 0) {
          const getEntityFaqComponent1 = dataStore.FaqComponent1.get(id)
          if (getEntityFaqComponent1) {
            dataStore.FaqComponent1.set(id, {
              ...getEntityFaqComponent1,
              ...dataFaqComponent1,
            })

            callbacks.FaqComponent1.forEach(async (value, key) => {
              if (id == value.entityID) value.callback()
            })
          }
        }
      },
      FaqComponentItem: ({
        id,
        data,
      }: {
        id: string
        data: Partial<{
          id: PrismaSelect['FaqComponentItem']['id']
          faqComponentId: PrismaSelect['FaqComponentItem']['faqComponentId']
          createdAt: PrismaSelect['FaqComponentItem']['createdAt']
          updatedAt: PrismaSelect['FaqComponentItem']['updatedAt']
          order: PrismaSelect['FaqComponentItem']['order']
          question: PrismaSelect['FaqComponentItem']['question']
          answer: PrismaSelect['FaqComponentItem']['answer']
        }>
      }) => {
        let dataFaqComponentItem1: Partial<ForGetDataBySelectID['FaqComponentItem1']> = {}

        if (typeof data['order'] != 'undefined') dataFaqComponentItem1['order'] = data['order']
        if (typeof data['question'] != 'undefined') dataFaqComponentItem1['question'] = data['question']
        if (typeof data['answer'] != 'undefined') dataFaqComponentItem1['answer'] = data['answer']

        if (Object.keys(dataFaqComponentItem1).length != 0) {
          const getEntityFaqComponentItem1 = dataStore.FaqComponentItem1.get(id)
          if (getEntityFaqComponentItem1) {
            dataStore.FaqComponentItem1.set(id, {
              ...getEntityFaqComponentItem1,
              ...dataFaqComponentItem1,
            })

            callbacks.FaqComponentItem1.forEach(async (value, key) => {
              if (id == value.entityID) value.callback()
            })
          }
        }
      },
      MapComponent: ({
        id,
        data,
      }: {
        id: string
        data: Partial<{
          id: PrismaSelect['MapComponent']['id']
          createdAt: PrismaSelect['MapComponent']['createdAt']
          updatedAt: PrismaSelect['MapComponent']['updatedAt']
          boxId: PrismaSelect['MapComponent']['boxId']
          zoom: PrismaSelect['MapComponent']['zoom']
          zoomFloat: PrismaSelect['MapComponent']['zoomFloat']
          centerLat: PrismaSelect['MapComponent']['centerLat']
          centerLng: PrismaSelect['MapComponent']['centerLng']
        }>
      }) => {
        let dataMapComponent1: Partial<ForGetDataBySelectID['MapComponent1']> = {}

        if (typeof data['zoomFloat'] != 'undefined') dataMapComponent1['zoomFloat'] = data['zoomFloat']
        if (typeof data['centerLat'] != 'undefined') dataMapComponent1['centerLat'] = data['centerLat']
        if (typeof data['centerLng'] != 'undefined') dataMapComponent1['centerLng'] = data['centerLng']

        if (Object.keys(dataMapComponent1).length != 0) {
          const getEntityMapComponent1 = dataStore.MapComponent1.get(id)
          if (getEntityMapComponent1) {
            dataStore.MapComponent1.set(id, {
              ...getEntityMapComponent1,
              ...dataMapComponent1,
            })

            callbacks.MapComponent1.forEach(async (value, key) => {
              if (id == value.entityID) value.callback()
            })
          }
        }
      },
      CodeComponent: ({
        id,
        data,
      }: {
        id: string
        data: Partial<{
          id: PrismaSelect['CodeComponent']['id']
          createdAt: PrismaSelect['CodeComponent']['createdAt']
          updatedAt: PrismaSelect['CodeComponent']['updatedAt']
          boxId: PrismaSelect['CodeComponent']['boxId']
          code: PrismaSelect['CodeComponent']['code']
        }>
      }) => {
        let dataCodeComponent1: Partial<ForGetDataBySelectID['CodeComponent1']> = {}

        if (typeof data['code'] != 'undefined') dataCodeComponent1['code'] = data['code']

        if (Object.keys(dataCodeComponent1).length != 0) {
          const getEntityCodeComponent1 = dataStore.CodeComponent1.get(id)
          if (getEntityCodeComponent1) {
            dataStore.CodeComponent1.set(id, {
              ...getEntityCodeComponent1,
              ...dataCodeComponent1,
            })

            callbacks.CodeComponent1.forEach(async (value, key) => {
              if (id == value.entityID) value.callback()
            })
          }
        }
      },
      WBotComponent: ({
        id,
        data,
      }: {
        id: string
        data: Partial<{
          id: PrismaSelect['WBotComponent']['id']
          createdAt: PrismaSelect['WBotComponent']['createdAt']
          updatedAt: PrismaSelect['WBotComponent']['updatedAt']
          boxId: PrismaSelect['WBotComponent']['boxId']
          linkID: PrismaSelect['WBotComponent']['linkID']
        }>
      }) => {
        let dataWhatsAppBotComponent1: Partial<ForGetDataBySelectID['WhatsAppBotComponent1']> = {}

        if (Object.keys(dataWhatsAppBotComponent1).length != 0) {
          const getEntityWhatsAppBotComponent1 = dataStore.WhatsAppBotComponent1.get(id)
          if (getEntityWhatsAppBotComponent1) {
            dataStore.WhatsAppBotComponent1.set(id, {
              ...getEntityWhatsAppBotComponent1,
              ...dataWhatsAppBotComponent1,
            })

            callbacks.WhatsAppBotComponent1.forEach(async (value, key) => {
              if (id == value.entityID) value.callback()
            })
          }
        }
      },
      MapComponentPoint: ({
        id,
        data,
      }: {
        id: string
        data: Partial<{
          id: PrismaSelect['MapComponentPoint']['id']
          mapComponentId: PrismaSelect['MapComponentPoint']['mapComponentId']
          createdAt: PrismaSelect['MapComponentPoint']['createdAt']
          updatedAt: PrismaSelect['MapComponentPoint']['updatedAt']
          lat: PrismaSelect['MapComponentPoint']['lat']
          lng: PrismaSelect['MapComponentPoint']['lng']
          linkID: PrismaSelect['MapComponentPoint']['linkID']
          text: PrismaSelect['MapComponentPoint']['text']
        }>
      }) => {
        let dataMapComponentPoint1: Partial<ForGetDataBySelectID['MapComponentPoint1']> = {}

        if (typeof data['lat'] != 'undefined') dataMapComponentPoint1['lat'] = data['lat']
        if (typeof data['lng'] != 'undefined') dataMapComponentPoint1['lng'] = data['lng']

        if (Object.keys(dataMapComponentPoint1).length != 0) {
          const getEntityMapComponentPoint1 = dataStore.MapComponentPoint1.get(id)
          if (getEntityMapComponentPoint1) {
            dataStore.MapComponentPoint1.set(id, {
              ...getEntityMapComponentPoint1,
              ...dataMapComponentPoint1,
            })

            callbacks.MapComponentPoint1.forEach(async (value, key) => {
              if (id == value.entityID) value.callback()
            })
          }
        }
      },
      PopupV1: ({
        id,
        data,
      }: {
        id: string
        data: Partial<{
          id: PrismaSelect['PopupV1']['id']
          createdAt: PrismaSelect['PopupV1']['createdAt']
          name: PrismaSelect['PopupV1']['name']
          siteV1Id: PrismaSelect['PopupV1']['siteV1Id']
          formId: PrismaSelect['PopupV1']['formId']
          quizV1Id: PrismaSelect['PopupV1']['quizV1Id']
          verticalPosition: PrismaSelect['PopupV1']['verticalPosition']
          horizontalPosition: PrismaSelect['PopupV1']['horizontalPosition']
          boxId: PrismaSelect['PopupV1']['boxId']
          boxBlockId: PrismaSelect['PopupV1']['boxBlockId']
        }>
      }) => {
        let dataPopupWithName: Partial<ForGetDataBySelectID['PopupWithName']> = {}

        if (typeof data['name'] != 'undefined') dataPopupWithName['name'] = data['name']

        if (Object.keys(dataPopupWithName).length != 0) {
          const getEntityPopupWithName = dataStore.PopupWithName.get(id)
          if (getEntityPopupWithName) {
            dataStore.PopupWithName.set(id, {
              ...getEntityPopupWithName,
              ...dataPopupWithName,
            })

            callbacks.PopupWithName.forEach(async (value, key) => {
              if (id == value.entityID) value.callback()
            })
          }
        }

        let dataPopupID: Partial<ForGetDataBySelectID['PopupID']> = {}

        if (Object.keys(dataPopupID).length != 0) {
          const getEntityPopupID = dataStore.PopupID.get(id)
          if (getEntityPopupID) {
            dataStore.PopupID.set(id, {
              ...getEntityPopupID,
              ...dataPopupID,
            })

            callbacks.PopupID.forEach(async (value, key) => {
              if (id == value.entityID) value.callback()
            })
          }
        }

        let dataPopup1: Partial<ForGetDataBySelectID['Popup1']> = {}

        if (typeof data['name'] != 'undefined') dataPopup1['name'] = data['name']
        if (typeof data['verticalPosition'] != 'undefined') dataPopup1['verticalPosition'] = data['verticalPosition']
        if (typeof data['horizontalPosition'] != 'undefined') dataPopup1['horizontalPosition'] = data['horizontalPosition']

        if (Object.keys(dataPopup1).length != 0) {
          const getEntityPopup1 = dataStore.Popup1.get(id)
          if (getEntityPopup1) {
            dataStore.Popup1.set(id, {
              ...getEntityPopup1,
              ...dataPopup1,
            })

            callbacks.Popup1.forEach(async (value, key) => {
              if (id == value.entityID) value.callback()
            })
          }
        }
      },
      LinkV1: ({
        id,
        data,
      }: {
        id: string
        data: Partial<{
          type: PrismaSelect['LinkV1']['type']
          id: PrismaSelect['LinkV1']['id']
          createdAt: PrismaSelect['LinkV1']['createdAt']
          updatedAt: PrismaSelect['LinkV1']['updatedAt']
          textLink: PrismaSelect['LinkV1']['textLink']
          boxId: PrismaSelect['LinkV1']['boxId']
          pageId: PrismaSelect['LinkV1']['pageId']
          sectionCollectionId: PrismaSelect['LinkV1']['sectionCollectionId']
          sectionId: PrismaSelect['LinkV1']['sectionId']
          popupId: PrismaSelect['LinkV1']['popupId']
          popupData: PrismaSelect['LinkV1']['popupData']
          url: PrismaSelect['LinkV1']['url']
        }>
      }) => {
        let dataLink1: Partial<ForGetDataBySelectID['Link1']> = {}

        if (typeof data['popupData'] != 'undefined') dataLink1['popupData'] = data['popupData']
        if (typeof data['url'] != 'undefined') dataLink1['url'] = data['url']

        if (Object.keys(dataLink1).length != 0) {
          const getEntityLink1 = dataStore.Link1.get(id)
          if (getEntityLink1) {
            dataStore.Link1.set(id, {
              ...getEntityLink1,
              ...dataLink1,
            })

            callbacks.Link1.forEach(async (value, key) => {
              if (id == value.entityID) value.callback()
            })
          }
        }
      },
      ImageV1: ({
        id,
        data,
      }: {
        id: string
        data: Partial<{
          type: PrismaSelect['ImageV1']['type']
          id: PrismaSelect['ImageV1']['id']
          name: PrismaSelect['ImageV1']['name']
          folder: PrismaSelect['ImageV1']['folder']
          size: PrismaSelect['ImageV1']['size']
          createdAt: PrismaSelect['ImageV1']['createdAt']
          width: PrismaSelect['ImageV1']['width']
          height: PrismaSelect['ImageV1']['height']
          originalID: PrismaSelect['ImageV1']['originalID']
          isS3: PrismaSelect['ImageV1']['isS3']
          siteId: PrismaSelect['ImageV1']['siteId']
        }>
      }) => {
        let dataImage1: Partial<ForGetDataBySelectID['Image1']> = {}

        if (typeof data['name'] != 'undefined') dataImage1['name'] = data['name']
        if (typeof data['folder'] != 'undefined') dataImage1['folder'] = data['folder']
        if (typeof data['size'] != 'undefined') dataImage1['size'] = data['size']

        if (Object.keys(dataImage1).length != 0) {
          const getEntityImage1 = dataStore.Image1.get(id)
          if (getEntityImage1) {
            dataStore.Image1.set(id, {
              ...getEntityImage1,
              ...dataImage1,
            })

            callbacks.Image1.forEach(async (value, key) => {
              if (id == value.entityID) value.callback()
            })
          }
        }
      },
      FormV1: ({
        id,
        data,
      }: {
        id: string
        data: Partial<{
          id: PrismaSelect['FormV1']['id']
          createdAt: PrismaSelect['FormV1']['createdAt']
          updatedAt: PrismaSelect['FormV1']['updatedAt']
          siteId: PrismaSelect['FormV1']['siteId']
          title: PrismaSelect['FormV1']['title']
          description: PrismaSelect['FormV1']['description']
          formButtonText: PrismaSelect['FormV1']['formButtonText']
          name: PrismaSelect['FormV1']['name']
          targetID: PrismaSelect['FormV1']['targetID']
          linkID: PrismaSelect['FormV1']['linkID']
        }>
      }) => {
        let dataForm1: Partial<ForGetDataBySelectID['Form1']> = {}

        if (typeof data['title'] != 'undefined') dataForm1['title'] = data['title']
        if (typeof data['description'] != 'undefined') dataForm1['description'] = data['description']
        if (typeof data['formButtonText'] != 'undefined') dataForm1['formButtonText'] = data['formButtonText']
        if (typeof data['name'] != 'undefined') dataForm1['name'] = data['name']

        if (Object.keys(dataForm1).length != 0) {
          const getEntityForm1 = dataStore.Form1.get(id)
          if (getEntityForm1) {
            dataStore.Form1.set(id, {
              ...getEntityForm1,
              ...dataForm1,
            })

            callbacks.Form1.forEach(async (value, key) => {
              if (id == value.entityID) value.callback()
            })
          }
        }
      },
      ExtraInputV1: ({
        id,
        data,
      }: {
        id: string
        data: Partial<{
          id: PrismaSelect['ExtraInputV1']['id']
          formV1Id: PrismaSelect['ExtraInputV1']['formV1Id']
          order: PrismaSelect['ExtraInputV1']['order']
          placeholder: PrismaSelect['ExtraInputV1']['placeholder']
          bitrixFieldName: PrismaSelect['ExtraInputV1']['bitrixFieldName']
          type: PrismaSelect['ExtraInputV1']['type']
          isRequired: PrismaSelect['ExtraInputV1']['isRequired']
        }>
      }) => {
        let dataExtraInput1: Partial<ForGetDataBySelectID['ExtraInput1']> = {}

        if (typeof data['order'] != 'undefined') dataExtraInput1['order'] = data['order']
        if (typeof data['placeholder'] != 'undefined') dataExtraInput1['placeholder'] = data['placeholder']
        if (typeof data['bitrixFieldName'] != 'undefined') dataExtraInput1['bitrixFieldName'] = data['bitrixFieldName']
        if (typeof data['type'] != 'undefined') dataExtraInput1['type'] = data['type']
        if (typeof data['isRequired'] != 'undefined') dataExtraInput1['isRequired'] = data['isRequired']

        if (Object.keys(dataExtraInput1).length != 0) {
          const getEntityExtraInput1 = dataStore.ExtraInput1.get(id)
          if (getEntityExtraInput1) {
            dataStore.ExtraInput1.set(id, {
              ...getEntityExtraInput1,
              ...dataExtraInput1,
            })

            callbacks.ExtraInput1.forEach(async (value, key) => {
              if (id == value.entityID) value.callback()
            })
          }
        }
      },
      QuizV1: ({
        id,
        data,
      }: {
        id: string
        data: Partial<{
          id: PrismaSelect['QuizV1']['id']
          siteId: PrismaSelect['QuizV1']['siteId']
          createdAt: PrismaSelect['QuizV1']['createdAt']
          updatedAt: PrismaSelect['QuizV1']['updatedAt']
          name: PrismaSelect['QuizV1']['name']
          title: PrismaSelect['QuizV1']['title']
          description: PrismaSelect['QuizV1']['description']
          formId: PrismaSelect['QuizV1']['formId']
          mainColorID: PrismaSelect['QuizV1']['mainColorID']
          textColorID: PrismaSelect['QuizV1']['textColorID']
          buttonTextColorID: PrismaSelect['QuizV1']['buttonTextColorID']
        }>
      }) => {
        let dataQuiz1: Partial<ForGetDataBySelectID['Quiz1']> = {}

        if (typeof data['name'] != 'undefined') dataQuiz1['name'] = data['name']
        if (typeof data['title'] != 'undefined') dataQuiz1['title'] = data['title']
        if (typeof data['description'] != 'undefined') dataQuiz1['description'] = data['description']

        if (Object.keys(dataQuiz1).length != 0) {
          const getEntityQuiz1 = dataStore.Quiz1.get(id)
          if (getEntityQuiz1) {
            dataStore.Quiz1.set(id, {
              ...getEntityQuiz1,
              ...dataQuiz1,
            })

            callbacks.Quiz1.forEach(async (value, key) => {
              if (id == value.entityID) value.callback()
            })
          }
        }
      },
      QuizV1StepV1: ({
        id,
        data,
      }: {
        id: string
        data: Partial<{
          id: PrismaSelect['QuizV1StepV1']['id']
          order: PrismaSelect['QuizV1StepV1']['order']
          quizV1Id: PrismaSelect['QuizV1StepV1']['quizV1Id']
          isItemWithImage: PrismaSelect['QuizV1StepV1']['isItemWithImage']
        }>
      }) => {
        let dataQuizStep1: Partial<ForGetDataBySelectID['QuizStep1']> = {}

        if (typeof data['order'] != 'undefined') dataQuizStep1['order'] = data['order']
        if (typeof data['isItemWithImage'] != 'undefined') dataQuizStep1['isItemWithImage'] = data['isItemWithImage']

        if (Object.keys(dataQuizStep1).length != 0) {
          const getEntityQuizStep1 = dataStore.QuizStep1.get(id)
          if (getEntityQuizStep1) {
            dataStore.QuizStep1.set(id, {
              ...getEntityQuizStep1,
              ...dataQuizStep1,
            })

            callbacks.QuizStep1.forEach(async (value, key) => {
              if (id == value.entityID) value.callback()
            })
          }
        }
      },
      QuizV1FieldInputStepV1: ({
        id,
        data,
      }: {
        id: string
        data: Partial<{
          type: PrismaSelect['QuizV1FieldInputStepV1']['type']
          order: PrismaSelect['QuizV1FieldInputStepV1']['order']
          id: PrismaSelect['QuizV1FieldInputStepV1']['id']
          createdAt: PrismaSelect['QuizV1FieldInputStepV1']['createdAt']
          updatedAt: PrismaSelect['QuizV1FieldInputStepV1']['updatedAt']
          title: PrismaSelect['QuizV1FieldInputStepV1']['title']
          placeholder: PrismaSelect['QuizV1FieldInputStepV1']['placeholder']
          quizStepV1Id: PrismaSelect['QuizV1FieldInputStepV1']['quizStepV1Id']
        }>
      }) => {
        let dataQuizFieldInputStep1: Partial<ForGetDataBySelectID['QuizFieldInputStep1']> = {}

        if (typeof data['title'] != 'undefined') dataQuizFieldInputStep1['title'] = data['title']
        if (typeof data['placeholder'] != 'undefined') dataQuizFieldInputStep1['placeholder'] = data['placeholder']

        if (Object.keys(dataQuizFieldInputStep1).length != 0) {
          const getEntityQuizFieldInputStep1 = dataStore.QuizFieldInputStep1.get(id)
          if (getEntityQuizFieldInputStep1) {
            dataStore.QuizFieldInputStep1.set(id, {
              ...getEntityQuizFieldInputStep1,
              ...dataQuizFieldInputStep1,
            })

            callbacks.QuizFieldInputStep1.forEach(async (value, key) => {
              if (id == value.entityID) value.callback()
            })
          }
        }
      },
      QuizV1CheckboxStepV1: ({
        id,
        data,
      }: {
        id: string
        data: Partial<{
          type: PrismaSelect['QuizV1CheckboxStepV1']['type']
          order: PrismaSelect['QuizV1CheckboxStepV1']['order']
          id: PrismaSelect['QuizV1CheckboxStepV1']['id']
          createdAt: PrismaSelect['QuizV1CheckboxStepV1']['createdAt']
          updatedAt: PrismaSelect['QuizV1CheckboxStepV1']['updatedAt']
          title: PrismaSelect['QuizV1CheckboxStepV1']['title']
          quizStepV1Id: PrismaSelect['QuizV1CheckboxStepV1']['quizStepV1Id']
        }>
      }) => {
        let dataQuizCheckboxStep1: Partial<ForGetDataBySelectID['QuizCheckboxStep1']> = {}

        if (typeof data['title'] != 'undefined') dataQuizCheckboxStep1['title'] = data['title']

        if (Object.keys(dataQuizCheckboxStep1).length != 0) {
          const getEntityQuizCheckboxStep1 = dataStore.QuizCheckboxStep1.get(id)
          if (getEntityQuizCheckboxStep1) {
            dataStore.QuizCheckboxStep1.set(id, {
              ...getEntityQuizCheckboxStep1,
              ...dataQuizCheckboxStep1,
            })

            callbacks.QuizCheckboxStep1.forEach(async (value, key) => {
              if (id == value.entityID) value.callback()
            })
          }
        }
      },
      QuizV1CheckboxItemV1: ({
        id,
        data,
      }: {
        id: string
        data: Partial<{
          type: PrismaSelect['QuizV1CheckboxItemV1']['type']
          order: PrismaSelect['QuizV1CheckboxItemV1']['order']
          id: PrismaSelect['QuizV1CheckboxItemV1']['id']
          createdAt: PrismaSelect['QuizV1CheckboxItemV1']['createdAt']
          updatedAt: PrismaSelect['QuizV1CheckboxItemV1']['updatedAt']
          title: PrismaSelect['QuizV1CheckboxItemV1']['title']
          checkboxStepV1Id: PrismaSelect['QuizV1CheckboxItemV1']['checkboxStepV1Id']
          targetID: PrismaSelect['QuizV1CheckboxItemV1']['targetID']
          imageID: PrismaSelect['QuizV1CheckboxItemV1']['imageID']
        }>
      }) => {
        let dataQuizCheckboxStepItem1: Partial<ForGetDataBySelectID['QuizCheckboxStepItem1']> = {}

        if (typeof data['order'] != 'undefined') dataQuizCheckboxStepItem1['order'] = data['order']
        if (typeof data['title'] != 'undefined') dataQuizCheckboxStepItem1['title'] = data['title']

        if (Object.keys(dataQuizCheckboxStepItem1).length != 0) {
          const getEntityQuizCheckboxStepItem1 = dataStore.QuizCheckboxStepItem1.get(id)
          if (getEntityQuizCheckboxStepItem1) {
            dataStore.QuizCheckboxStepItem1.set(id, {
              ...getEntityQuizCheckboxStepItem1,
              ...dataQuizCheckboxStepItem1,
            })

            callbacks.QuizCheckboxStepItem1.forEach(async (value, key) => {
              if (id == value.entityID) value.callback()
            })
          }
        }
      },
      QuizV1RadioStepV1: ({
        id,
        data,
      }: {
        id: string
        data: Partial<{
          type: PrismaSelect['QuizV1RadioStepV1']['type']
          id: PrismaSelect['QuizV1RadioStepV1']['id']
          order: PrismaSelect['QuizV1RadioStepV1']['order']
          createdAt: PrismaSelect['QuizV1RadioStepV1']['createdAt']
          updatedAt: PrismaSelect['QuizV1RadioStepV1']['updatedAt']
          title: PrismaSelect['QuizV1RadioStepV1']['title']
          quizStepV1Id: PrismaSelect['QuizV1RadioStepV1']['quizStepV1Id']
        }>
      }) => {
        let dataQuizRadioStep1: Partial<ForGetDataBySelectID['QuizRadioStep1']> = {}

        if (typeof data['title'] != 'undefined') dataQuizRadioStep1['title'] = data['title']

        if (Object.keys(dataQuizRadioStep1).length != 0) {
          const getEntityQuizRadioStep1 = dataStore.QuizRadioStep1.get(id)
          if (getEntityQuizRadioStep1) {
            dataStore.QuizRadioStep1.set(id, {
              ...getEntityQuizRadioStep1,
              ...dataQuizRadioStep1,
            })

            callbacks.QuizRadioStep1.forEach(async (value, key) => {
              if (id == value.entityID) value.callback()
            })
          }
        }
      },
      QuizV1RadioItemV1: ({
        id,
        data,
      }: {
        id: string
        data: Partial<{
          type: PrismaSelect['QuizV1RadioItemV1']['type']
          order: PrismaSelect['QuizV1RadioItemV1']['order']
          id: PrismaSelect['QuizV1RadioItemV1']['id']
          createdAt: PrismaSelect['QuizV1RadioItemV1']['createdAt']
          updatedAt: PrismaSelect['QuizV1RadioItemV1']['updatedAt']
          title: PrismaSelect['QuizV1RadioItemV1']['title']
          radioStepV1Id: PrismaSelect['QuizV1RadioItemV1']['radioStepV1Id']
          targetID: PrismaSelect['QuizV1RadioItemV1']['targetID']
          imageID: PrismaSelect['QuizV1RadioItemV1']['imageID']
        }>
      }) => {
        let dataQuizRadioStepItem1: Partial<ForGetDataBySelectID['QuizRadioStepItem1']> = {}

        if (typeof data['order'] != 'undefined') dataQuizRadioStepItem1['order'] = data['order']
        if (typeof data['title'] != 'undefined') dataQuizRadioStepItem1['title'] = data['title']

        if (Object.keys(dataQuizRadioStepItem1).length != 0) {
          const getEntityQuizRadioStepItem1 = dataStore.QuizRadioStepItem1.get(id)
          if (getEntityQuizRadioStepItem1) {
            dataStore.QuizRadioStepItem1.set(id, {
              ...getEntityQuizRadioStepItem1,
              ...dataQuizRadioStepItem1,
            })

            callbacks.QuizRadioStepItem1.forEach(async (value, key) => {
              if (id == value.entityID) value.callback()
            })
          }
        }
      },
      LeadV1: ({
        id,
        data,
      }: {
        id: string
        data: Partial<{
          createdAt: PrismaSelect['LeadV1']['createdAt']
          type: PrismaSelect['LeadV1']['type']
          id: PrismaSelect['LeadV1']['id']
          information: PrismaSelect['LeadV1']['information']
          siteV1Id: PrismaSelect['LeadV1']['siteV1Id']
          AmazonEmailMessageId: PrismaSelect['LeadV1']['AmazonEmailMessageId']
        }>
      }) => {
        let dataLead1: Partial<ForGetDataBySelectID['Lead1']> = {}

        if (typeof data['createdAt'] != 'undefined') dataLead1['createdAt'] = data['createdAt']
        if (typeof data['information'] != 'undefined') dataLead1['information'] = data['information']
        if (typeof data['AmazonEmailMessageId'] != 'undefined') dataLead1['AmazonEmailMessageId'] = data['AmazonEmailMessageId']

        if (Object.keys(dataLead1).length != 0) {
          const getEntityLead1 = dataStore.Lead1.get(id)
          if (getEntityLead1) {
            dataStore.Lead1.set(id, {
              ...getEntityLead1,
              ...dataLead1,
            })

            callbacks.Lead1.forEach(async (value, key) => {
              if (id == value.entityID) value.callback()
            })
          }
        }
      },
      Target: ({
        id,
        data,
      }: {
        id: string
        data: Partial<{
          id: PrismaSelect['Target']['id']
          shortID: PrismaSelect['Target']['shortID']
          createdAt: PrismaSelect['Target']['createdAt']
          updatedAt: PrismaSelect['Target']['updatedAt']
          name: PrismaSelect['Target']['name']
          siteID: PrismaSelect['Target']['siteID']
        }>
      }) => {
        let dataTarget1: Partial<ForGetDataBySelectID['Target1']> = {}

        if (typeof data['name'] != 'undefined') dataTarget1['name'] = data['name']

        if (Object.keys(dataTarget1).length != 0) {
          const getEntityTarget1 = dataStore.Target1.get(id)
          if (getEntityTarget1) {
            dataStore.Target1.set(id, {
              ...getEntityTarget1,
              ...dataTarget1,
            })

            callbacks.Target1.forEach(async (value, key) => {
              if (id == value.entityID) value.callback()
            })
          }
        }
      },
      ComplexTarget: ({
        id,
        data,
      }: {
        id: string
        data: Partial<{
          id: PrismaSelect['ComplexTarget']['id']
          siteV1Id: PrismaSelect['ComplexTarget']['siteV1Id']
          createdAt: PrismaSelect['ComplexTarget']['createdAt']
          updatedAt: PrismaSelect['ComplexTarget']['updatedAt']
          yandexMetrikaTargetId: PrismaSelect['ComplexTarget']['yandexMetrikaTargetId']
        }>
      }) => {},
      OrTarget: ({
        id,
        data,
      }: {
        id: string
        data: Partial<{
          id: PrismaSelect['OrTarget']['id']
          createdAt: PrismaSelect['OrTarget']['createdAt']
          updatedAt: PrismaSelect['OrTarget']['updatedAt']
          complexTargetId: PrismaSelect['OrTarget']['complexTargetId']
        }>
      }) => {},
      AndTarget: ({
        id,
        data,
      }: {
        id: string
        data: Partial<{
          id: PrismaSelect['AndTarget']['id']
          createdAt: PrismaSelect['AndTarget']['createdAt']
          updatedAt: PrismaSelect['AndTarget']['updatedAt']
          complexTargetId: PrismaSelect['AndTarget']['complexTargetId']
        }>
      }) => {},
      Targets: ({
        id,
        data,
      }: {
        id: string
        data: Partial<{
          id: PrismaSelect['Targets']['id']
          createdAt: PrismaSelect['Targets']['createdAt']
          updatedAt: PrismaSelect['Targets']['updatedAt']
          andTargetsId: PrismaSelect['Targets']['andTargetsId']
          orTargetsId: PrismaSelect['Targets']['orTargetsId']
        }>
      }) => {},
      PageOpenedEvent: ({
        id,
        data,
      }: {
        id: string
        data: Partial<{
          id: PrismaSelect['PageOpenedEvent']['id']
          createdAt: PrismaSelect['PageOpenedEvent']['createdAt']
          updatedAt: PrismaSelect['PageOpenedEvent']['updatedAt']
          siteV1Id: PrismaSelect['PageOpenedEvent']['siteV1Id']
          pageId: PrismaSelect['PageOpenedEvent']['pageId']
        }>
      }) => {},
      BySecondsLaunchEvent: ({
        id,
        data,
      }: {
        id: string
        data: Partial<{
          id: PrismaSelect['BySecondsLaunchEvent']['id']
          createdAt: PrismaSelect['BySecondsLaunchEvent']['createdAt']
          updatedAt: PrismaSelect['BySecondsLaunchEvent']['updatedAt']
          siteV1Id: PrismaSelect['BySecondsLaunchEvent']['siteV1Id']
          seconds: PrismaSelect['BySecondsLaunchEvent']['seconds']
        }>
      }) => {},
      FormSendedEvent: ({
        id,
        data,
      }: {
        id: string
        data: Partial<{
          id: PrismaSelect['FormSendedEvent']['id']
          createdAt: PrismaSelect['FormSendedEvent']['createdAt']
          updatedAt: PrismaSelect['FormSendedEvent']['updatedAt']
          siteV1Id: PrismaSelect['FormSendedEvent']['siteV1Id']
          formSendedId: PrismaSelect['FormSendedEvent']['formSendedId']
        }>
      }) => {},
      PopupOpenedEvent: ({
        id,
        data,
      }: {
        id: string
        data: Partial<{
          id: PrismaSelect['PopupOpenedEvent']['id']
          createdAt: PrismaSelect['PopupOpenedEvent']['createdAt']
          updatedAt: PrismaSelect['PopupOpenedEvent']['updatedAt']
          siteV1Id: PrismaSelect['PopupOpenedEvent']['siteV1Id']
          popupOpenedId: PrismaSelect['PopupOpenedEvent']['popupOpenedId']
        }>
      }) => {},
      CompanyMail: ({
        id,
        data,
      }: {
        id: string
        data: Partial<{
          id: PrismaSelect['CompanyMail']['id']
          createdAt: PrismaSelect['CompanyMail']['createdAt']
          updatedAt: PrismaSelect['CompanyMail']['updatedAt']
          siteV1Id: PrismaSelect['CompanyMail']['siteV1Id']
          mail: PrismaSelect['CompanyMail']['mail']
          text: PrismaSelect['CompanyMail']['text']
        }>
      }) => {},
    },
  }
}

export const synchronFrontendEngineAtSite = SynchronFrontendEngine()
